var Ba = Object.defineProperty;
var Ha = (i, s, t) => s in i ? Ba(i, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[s] = t;
var f = (i, s, t) => Ha(i, typeof s != "symbol" ? s + "" : s, t);
import { j as o, h as Dr, $ as Wa, a as Ma, b as za, c as Va, d as Ka, e as Ua, g as qa, i as Ga, n as O, O as Ya, k as no, l as so, w as qn, Z as Qa, H as Xa, m as Mn, o as vt, p as xo, r as Tr, q as Ja, t as oo, W as Za, u as ti, A as ei, F as ni, v as jr, x as Nr, y as ro, z as Fr, B as Gn, C as si, D as oi, E as ri, G as ai, I as ii, J as li, K as Pr, L as ci, M as di } from "./vendor-Bz73_ROW.js";
import b from "classnames";
import { PureComponent as k, Component as xt, useState as U, useCallback as L, useEffect as at, cloneElement as un, isValidElement as Lt, forwardRef as z, Children as Ht, createRef as W, createContext as Wt, memo as Rr, useRef as Z, useMemo as G, useContext as Jt, Fragment as Mt, useImperativeHandle as pn, createElement as hi, lazy as ui, Suspense as pi, useReducer as mi } from "react";
import { T as B, I as R, E as mn, w as gn, r as Ms, B as lt, a as an, b as Lr, e as gi } from "./emoji-OBfaI_6_.js";
import { c as jT, f as NT, d as FT, i as PT } from "./emoji-OBfaI_6_.js";
import { useKey as Er, useMount as Le, useUnmount as te, useUpdateEffect as Zt, useToggle as fi, useSetState as bi, useClickAway as $r, useEvent as fn, usePrevious as ln, useDebounce as yi } from "react-use";
import N from "moment-timezone";
import { v4 as cn } from "uuid";
import { noop as xi } from "ts-essentials";
import { a as LT } from "./svg-rQ8BHEX_.js";
import _i from "react-dom";
const Ci = "h-button-styles--button__button", wi = "h-button-styles--button__buttonNormal", vi = "h-button-styles--button__buttonLarge", Si = "h-button-styles--button__buttonDisabled", Ii = "h-button-styles--button__buttonLoading", ki = "h-button-styles--button__buttonWithLabel", Di = "h-button-styles--button__buttonLabel", Ti = "h-button-styles--button__buttonSlot", ji = "h-button-styles--button__buttonContent", Nt = {
  button: Ci,
  buttonNormal: wi,
  buttonLarge: vi,
  buttonDisabled: Si,
  buttonLoading: Ii,
  buttonWithLabel: ki,
  buttonLabel: Di,
  buttonSlot: Ti,
  buttonContent: ji
}, Ni = "h-button-styles--danger-button__danger", Fi = "h-button-styles--danger-button__dangerLabel", Ar = {
  danger: Ni,
  dangerLabel: Fi
}, Pi = "h-button-styles--primary-button__primary", Ri = "h-button-styles--primary-button__primaryLabel", Or = {
  primary: Pi,
  primaryLabel: Ri
}, Li = "h-button-styles--secondary-button__secondary", Ei = "h-button-styles--secondary-button__secondaryLabel", Br = {
  secondary: Li,
  secondaryLabel: Ei
}, $i = "h-button-styles--tertiary-button__tertiary", Ai = "h-button-styles--tertiary-button__tertiaryLabel", Hr = {
  tertiary: $i,
  tertiaryLabel: Ai
}, Oi = {
  normal: Nt.buttonNormal,
  large: Nt.buttonLarge
}, Bi = {
  primary: Or.primary,
  secondary: Br.secondary,
  tertiary: Hr.tertiary,
  danger: Ar.danger
}, Hi = {
  primary: Or.primaryLabel,
  secondary: Br.secondaryLabel,
  tertiary: Hr.tertiaryLabel,
  danger: Ar.dangerLabel
};
var Bs;
let Yn = (Bs = class extends k {
  getClassName() {
    const {
      variant: s = "primary",
      size: t = "normal",
      disabled: e,
      active: n,
      isLoading: r,
      className: a,
      label: l,
      slotEnd: c
    } = this.props, d = Bi[s];
    return b(
      Nt.button,
      {
        [d]: !0,
        [`${d}Active`]: n
      },
      Oi[t],
      {
        [Nt.buttonDisabled]: e,
        [Nt.buttonLoading]: r,
        [Nt.buttonWithLabel]: !c && !!l
      },
      a
    );
  }
  render() {
    const {
      variant: s,
      size: t,
      icon: e,
      slotStart: n,
      slotEnd: r,
      children: a,
      className: l,
      onClick: c,
      active: d,
      disabled: h,
      isLoading: u,
      type: p,
      innerRef: m,
      label: g,
      styleText: y,
      loadingIndicator: x,
      ...C
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      "button",
      {
        ...C,
        type: p,
        className: this.getClassName(),
        onClick: h ? void 0 : c,
        disabled: h,
        ref: m,
        children: u ? x : /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          (n || e) && /* @__PURE__ */ o.jsx("span", { className: Nt.buttonSlot, children: e ? /* @__PURE__ */ o.jsx(R, { name: e }) : n }),
          (y || a) && /* @__PURE__ */ o.jsx("span", { className: Nt.buttonContent, children: y ? /* @__PURE__ */ o.jsx(
            B.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: a
            }
          ) : a }),
          g && /* @__PURE__ */ o.jsx(
            B.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: b(
                Nt.buttonLabel,
                Hi[s]
              ),
              children: g
            }
          ),
          r && /* @__PURE__ */ o.jsx("span", { className: Nt.buttonSlot, children: r })
        ] })
      }
    );
  }
}, f(Bs, "defaultProps", {
  variant: "primary",
  size: "normal",
  type: "button",
  disabled: !1,
  active: !1,
  isLoading: !1,
  loadingIndicator: /* @__PURE__ */ o.jsx(B.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
  styleText: !0
}), Bs);
const Wi = /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: "Something went wrong" });
class Wr extends xt {
  render() {
    return /* @__PURE__ */ o.jsx(mn, { fallback: Wi, children: /* @__PURE__ */ o.jsx(Yn, { ...this.props }) });
  }
}
f(Wr, "defaultProps", Yn.defaultProps);
const tt = Dr(
  Wr,
  Yn
), Mi = "h-button-navigationButton--navigationButton__root", zi = {
  root: Mi
}, FD = ({
  navigate: i,
  className: s,
  onClick: t,
  ...e
}) => {
  const n = (r) => {
    t == null || t(r), i();
  };
  return /* @__PURE__ */ o.jsx(
    Yn,
    {
      ...e,
      variant: e.variant ?? "tertiary",
      onClick: n,
      className: b(s, zi.root)
    }
  );
}, Vi = "h-spinner--spinner__root", Ki = {
  root: Vi
};
class ao extends k {
  render() {
    const { className: s, size: t, color: e, trackColor: n, bgColor: r, ...a } = this.props, l = b(
      {
        [Ki.root]: !0
      },
      s
    ), c = typeof t == "number" ? t : 32, d = typeof t == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return n && n.length && (u.borderColor = n), e && e.length && (u.borderTopColor = e), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ o.jsx("div", { ...a, style: u, className: l });
  }
}
const Ui = "h-iconButton--iconButton__iconButton", qi = {
  iconButton: Ui
};
var Hs;
let Rt = (Hs = class extends k {
  render() {
    const { children: s, className: t, icon: e, iconProps: n, iconSize: r, ...a } = this.props;
    return /* @__PURE__ */ o.jsx(
      tt,
      {
        "aria-label": e,
        ...a,
        className: b(qi.iconButton, t),
        loadingIndicator: /* @__PURE__ */ o.jsx(ao, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ o.jsx(R, { size: r || 16, name: e, ...n })
      }
    );
  }
}, f(Hs, "defaultProps", {
  variant: "primary"
}), Hs);
class Mr extends xt {
  render() {
    return /* @__PURE__ */ o.jsx(mn, { fallback: null, children: /* @__PURE__ */ o.jsx(Rt, { ...this.props }) });
  }
}
f(Mr, "defaultProps", Rt.defaultProps);
const st = Dr(
  Mr,
  Rt
), Gi = "h-tooltip--tooltip__content", Yi = "h-tooltip--tooltip__contentLight", Qi = "h-tooltip--tooltip__contentHasHead", Xi = "h-tooltip--tooltip__body", Ji = "h-tooltip--tooltip__head", Zi = "h-tooltip--tooltip__arrow", ue = {
  content: Gi,
  contentLight: Yi,
  contentHasHead: Qi,
  body: Xi,
  head: Ji,
  arrow: Zi
}, tl = 400;
function yt({
  children: i,
  content: s,
  onOpenChange: t,
  side: e = "top",
  className: n,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = tl,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: y,
  ...x
}) {
  const [C, _] = U(
    g ? !1 : void 0
  ), w = L(() => {
    _(!1), window.removeEventListener("click", w);
  }, []);
  at(() => () => {
    window.removeEventListener("click", w);
  }, [w]);
  const S = Wa();
  if (c || !s)
    return /* @__PURE__ */ o.jsx(o.Fragment, { children: i });
  const v = (D) => {
    D.stopPropagation(), window[C ? "removeEventListener" : "addEventListener"](
      "click",
      w
    ), _(!C);
  }, T = b(
    ue.content,
    {
      [ue.contentHasHead]: !!r,
      [ue.contentLight]: y
    },
    n
  );
  return /* @__PURE__ */ o.jsx(Ma, { children: /* @__PURE__ */ o.jsxs(
    za,
    {
      open: C ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: t,
      children: [
        /* @__PURE__ */ o.jsx(Va, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ o.jsx(
          p,
          {
            onClick: g ? v : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Lt(i) ? un(i, { onClick: v }) : i }),
        /* @__PURE__ */ o.jsx(Ka, { children: /* @__PURE__ */ o.jsx(
          Ua,
          {
            id: S,
            side: e,
            sideOffset: 4,
            align: h,
            className: T,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
              r && /* @__PURE__ */ o.jsx("div", { className: ue.head, children: r }),
              /* @__PURE__ */ o.jsx("div", { className: ue.body, children: s }),
              /* @__PURE__ */ o.jsx(qa, { className: ue.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const el = "h-attachment--attachment__root", nl = "h-attachment--attachment__icon", sl = "h-attachment--attachment__name", ys = {
  root: el,
  icon: nl,
  name: sl
}, _o = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function ol(i) {
  var t;
  const s = (t = i.split(".").pop()) == null ? void 0 : t.toLowerCase();
  return !s || !_o[s] ? "file" : _o[s];
}
class RD extends k {
  render() {
    const {
      className: s,
      fileName: t,
      label: e,
      onDownload: n,
      onPreview: r,
      isPreviewLoading: a,
      isDownloadLoading: l,
      ...c
    } = this.props, d = b(
      {
        [ys.root]: !0
      },
      s
    );
    return /* @__PURE__ */ o.jsxs("div", { ...c, className: d, children: [
      /* @__PURE__ */ o.jsx(
        R,
        {
          className: ys.icon,
          name: ol(t),
          size: 24,
          color: "neutral.700"
        }
      ),
      /* @__PURE__ */ o.jsx(
        yt,
        {
          content: e || t,
          wrap: "div",
          wrapProps: { className: ys.name },
          children: /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "4", color: "secondary", children: e || t })
        }
      ),
      r && /* @__PURE__ */ o.jsx(
        st,
        {
          isLoading: a,
          variant: "secondary",
          icon: "eye",
          onClick: a ? void 0 : r
        }
      ),
      n && /* @__PURE__ */ o.jsx(
        st,
        {
          isLoading: l,
          variant: "secondary",
          icon: "download",
          onClick: l ? void 0 : n
        }
      )
    ] });
  }
}
const rl = "h-avatar--avatar__root", zn = {
  root: rl,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, al = {
  24: 16,
  32: 20,
  40: 24
}, il = ({
  icon: i,
  size: s,
  color: t = "inherit"
}) => /* @__PURE__ */ o.jsx(R, { name: i, size: al[s], color: t }), ll = "h-image--image__image", cl = "h-image--image__error", dl = "h-image--image__complete", xs = {
  image: ll,
  error: cl,
  complete: dl
};
class rs extends xt {
  constructor(t) {
    super(t);
    f(this, "mounted");
    this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    var e, n;
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), (n = (e = this.props).onLoad) == null || n.call(e, t);
  }
  onError(t) {
    var e, n;
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), (n = (e = this.props).onError) == null || n.call(e, t);
  }
  render() {
    const { className: t, src: e, alt: n, ...r } = this.props, { imageSrc: a } = this.state, { loadingError: l, loadingComplete: c } = this.state, d = b(
      {
        [xs.image]: !0,
        [xs.error]: !!l,
        [xs.complete]: !!c
      },
      t
    );
    return /* @__PURE__ */ o.jsx(
      "img",
      {
        ...r,
        className: d,
        onError: this.onError,
        onLoad: this.onLoad,
        src: a,
        alt: n || ""
      }
    );
  }
}
f(rs, "defaultProps");
rs.defaultProps = {
  className: "",
  alt: ""
};
const hl = "h-avatar--imageAvatar__root", ul = {
  root: hl
}, pl = ({
  src: i,
  alt: s = "avatar"
}) => /* @__PURE__ */ o.jsx(rs, { src: i, alt: s, className: ul.root }), ml = "h-avatar--textAvatar__root", Vn = {
  root: ml,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, gl = {
  24: Vn["avatar-24"],
  32: Vn["avatar-32"],
  40: Vn["avatar-40"]
}, fl = ({ text: i = "", size: s }) => /* @__PURE__ */ o.jsx("div", { className: b(Vn.root, gl[s]), children: i.trim().split(" ").map(
  (t, e, n) => n.length === 1 ? t : t[0]
).join("").slice(0, 2) }), bl = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class yl {
  constructor(s) {
    this.colors = s, this.colors = s;
  }
  generate(s) {
    const t = this.getRandomIndex(s);
    return this.colors[t];
  }
  getRandomIndex(s) {
    const t = Ga(s);
    return Math.floor(t() * this.colors.length);
  }
}
var nt = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(nt || {});
function pe(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function It(i) {
  return !!i && i.trim().length !== 0;
}
function xl(i) {
  var t, e, n;
  if (i.icon)
    return {
      type: nt.Icon,
      icon: i.icon,
      backgroundColor: (t = i.color) == null ? void 0 : t.backgroundColor,
      iconColor: (e = i.color) == null ? void 0 : e.contentColor
    };
  const { user: s } = i;
  if (!s)
    return {
      type: nt.Icon,
      icon: "user-slash"
    };
  if (It(s.avatar_url))
    return {
      type: nt.Image,
      src: s.avatar_url,
      alt: s.name || s.display_name || s.email || s.phone_number || s.given_name || s.family_name || ""
    };
  if (It(s.name)) {
    const r = pe(s.name.trim()).split(" ");
    if (r.length === 1)
      return {
        type: nt.Text,
        text: ((n = r[0]) == null ? void 0 : n[0]) ?? ""
      };
    const a = r[0], l = r[r.length - 1];
    return {
      type: nt.Text,
      text: ((a == null ? void 0 : a[0]) ?? "") + ((l == null ? void 0 : l[0]) ?? "")
    };
  }
  if (It(s.display_name))
    return {
      type: nt.Text,
      text: pe(s.display_name.trim())
    };
  if (It(s.given_name) && It(s.family_name))
    return {
      type: nt.Text,
      text: pe(s.given_name.trim())[0] + pe(s.family_name.trim())[0]
    };
  if (It(s.given_name) && !It(s.family_name))
    return {
      type: nt.Text,
      text: pe(s.given_name.trim())[0]
    };
  if (!It(s.given_name) && It(s.family_name))
    return {
      type: nt.Text,
      text: pe(s.family_name.trim())[0]
    };
  if (It(s.email)) {
    const [r] = s.email.split("@");
    return {
      type: nt.Text,
      text: r.trim()
    };
  }
  return It(s.phone_number) ? {
    type: nt.Text,
    text: s.phone_number.slice(-2)
  } : s.id ? {
    type: nt.Icon,
    icon: "user-secret"
  } : {
    type: nt.Icon,
    icon: "user-slash"
  };
}
const kt = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, Co = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...kt,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": kt,
  "user-slash": kt,
  "map-pin": kt,
  "web-form": kt,
  code: kt,
  history: kt,
  smile: kt,
  key: kt,
  webhooks: kt,
  plug: kt
}, _l = {
  24: zn["avatar-24"],
  32: zn["avatar-32"],
  40: zn["avatar-40"]
};
class zr extends k {
  getAvatarChild(s, t) {
    if (s.type === nt.Icon)
      return /* @__PURE__ */ o.jsx(
        il,
        {
          size: t,
          icon: s.icon,
          color: s.iconColor
        }
      );
    if (s.type === nt.Image)
      return /* @__PURE__ */ o.jsx(pl, { src: s.src, alt: s.alt });
    if (s.type === nt.Text)
      return /* @__PURE__ */ o.jsx(fl, { size: t, text: s.text });
  }
  calculateColor(s) {
    var t;
    if (s.type === nt.Icon) {
      if (s.backgroundColor && s.iconColor)
        return {
          backgroundColor: s.backgroundColor,
          contentColor: s.iconColor
        };
      if (Co[s.icon])
        return Co[s.icon];
    }
    return s.type === nt.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : (t = this.props.user) != null && t.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : s.type === nt.Text ? this.props.colorGenerator.generate(s.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: s, size: t } = this.props, e = xl(this.props), n = this.getAvatarChild(e, t), r = this.calculateColor(e);
    return /* @__PURE__ */ o.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: b(
          zn.root,
          _l[t],
          s
        ),
        children: n
      }
    );
  }
}
f(zr, "defaultProps", {
  size: "32",
  colorGenerator: new yl(bl)
});
const Vr = gn(zr, {
  fallback: null
}), Cl = "h-badge--badge__badge", wl = "h-badge--badge__badgeSmall", vl = "h-badge--badge__badgeMedium", Sl = "h-badge--badge__badgePrimary", Il = "h-badge--badge__badgeSecondary", kl = "h-badge--badge__badgeSuccess", Dl = "h-badge--badge__badgeInfo", Tl = "h-badge--badge__badgeWarning", jl = "h-badge--badge__badgeError", Bt = {
  badge: Cl,
  badgeSmall: wl,
  badgeMedium: vl,
  badgePrimary: Sl,
  badgeSecondary: Il,
  badgeSuccess: kl,
  badgeInfo: Dl,
  badgeWarning: Tl,
  badgeError: jl
}, Nl = {
  small: Bt.badgeSmall,
  medium: Bt.badgeMedium
}, Fl = {
  primary: Bt.badgePrimary,
  secondary: Bt.badgeSecondary,
  success: Bt.badgeSuccess,
  info: Bt.badgeInfo,
  warning: Bt.badgeWarning,
  error: Bt.badgeError
}, Pl = "badge";
function LD(i) {
  const { className: s, size: t, variant: e, children: n, ...r } = i, a = b(
    Bt.badge,
    Nl[t],
    Fl[e],
    s
  );
  return /* @__PURE__ */ o.jsx("span", { className: a, ...r, "data-testid": Pl, children: n });
}
const M = z(function({
  flexWrap: s,
  flexDirection: t,
  justifyItems: e,
  justifyContent: n,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...s && { flexWrap: s },
    ...t && { flexDirection: t },
    ...e && { justifyItems: e },
    ...n && { justifyContent: n },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Ms(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ o.jsx(lt, { ...h, style: p, ref: u, children: d });
}), Rl = "h-banner--banner__root", Ll = "h-banner--banner__rootWithClose", El = "h-banner--banner__iconContainer", $l = "h-banner--banner__closeIcon", Al = "h-banner--banner__headline", Ol = "h-banner--banner__rootInfo", Bl = "h-banner--banner__icon", Hl = "h-banner--banner__description", Wl = "h-banner--banner__rootWarning", Ml = "h-banner--banner__rootAnnouncement", zl = "h-banner--banner__rootSuccess", Vl = "h-banner--banner__rootFail", Ct = {
  root: Rl,
  rootWithClose: Ll,
  iconContainer: El,
  closeIcon: $l,
  headline: Al,
  rootInfo: Ol,
  icon: Bl,
  description: Hl,
  rootWarning: Wl,
  rootAnnouncement: Ml,
  rootSuccess: zl,
  rootFail: Vl
}, Kl = (i, s) => {
  if (s !== void 0)
    return s;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, ED = ({
  actionSlot: i,
  className: s,
  description: t,
  headline: e,
  icon: n,
  variant: r,
  onClose: a
}) => {
  const l = b(Ct.root, s, {
    [Ct.rootInfo]: r === "info",
    [Ct.rootAnnouncement]: r === "announcement",
    [Ct.rootWarning]: r === "warning",
    [Ct.rootSuccess]: r === "success",
    [Ct.rootFail]: r === "fail",
    [Ct.rootWithClose]: a
  }), c = Kl(r, n);
  return /* @__PURE__ */ o.jsxs("div", { className: l, children: [
    /* @__PURE__ */ o.jsxs(M, { justifyContent: "center", children: [
      c && /* @__PURE__ */ o.jsx("span", { className: Ct.iconContainer, children: /* @__PURE__ */ o.jsx(R, { name: c, size: 16, className: Ct.icon }) }),
      /* @__PURE__ */ o.jsxs(M, { flexDirection: "column", children: [
        e && /* @__PURE__ */ o.jsx(
          B.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: Ct.headline,
            children: e
          }
        ),
        un(t, {
          className: Ct.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ o.jsx(M, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ o.jsx(
      st,
      {
        icon: "close",
        variant: "tertiary",
        className: Ct.closeIcon,
        onClick: a
      }
    )
  ] });
}, Ul = "h-buttonGroup--buttonGroup__root", ql = "h-buttonGroup--buttonGroup__button", Gl = "h-buttonGroup--buttonGroup__buttonWithBorder", Yl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", wn = {
  root: Ul,
  button: ql,
  buttonWithBorder: Gl,
  buttonWithoutBorder: Yl
}, $D = ({
  className: i,
  children: s,
  variant: t,
  size: e,
  disabled: n
}) => {
  const r = b(wn.root, i);
  return /* @__PURE__ */ o.jsx("div", { className: r, role: "group", children: Ht.map(s, (a) => {
    if (!Lt(a))
      return null;
    const l = (t ?? a.props.variant) === "secondary", c = b(a.props.className, {
      [wn.button]: !0,
      [wn.buttonWithBorder]: l,
      [wn.buttonWithoutBorder]: !l
    });
    return un(a, {
      className: c,
      disabled: n ?? a.props.disabled,
      variant: t ?? a.props.variant,
      size: e
    });
  }) });
}, Ql = "h-divider--divider__root", Xl = "h-divider--divider__withChildren", Jl = "h-divider--divider__horizontal", Zl = "h-divider--divider__vertical", _s = {
  root: Ql,
  withChildren: Xl,
  horizontal: Jl,
  vertical: Zl
}, io = z(function({
  className: s,
  children: t,
  as: e,
  orientation: n = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = e ?? (t ? "div" : "hr"), u = b(
    _s.root,
    _s[n],
    {
      [_s.withChildren]: !!t
    },
    s
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": an(r) } : {},
    ...a ? { margin: Ms(a) } : {},
    ...l ? { padding: Ms(l) } : {}
  };
  return /* @__PURE__ */ o.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof t == "string" ? /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: t }) : t
    }
  );
}), tc = "h-buttonList--buttonList__buttonList", ec = "h-buttonList--buttonList__inner", wo = {
  buttonList: tc,
  inner: ec
}, nc = "h-buttonList--header__header", sc = {
  header: nc
};
let oc = class extends k {
  render() {
    const { children: s, className: t, ...e } = this.props, n = b(
      {
        [sc.header]: !0
      },
      t
    );
    return /* @__PURE__ */ o.jsx("li", { ...e, className: n, children: s });
  }
};
const rc = "h-buttonList--item__item", ac = "h-buttonList--item__icon", ic = "h-buttonList--item__button", lc = "h-buttonList--item__buttonDisabled", cc = "h-buttonList--item__buttonCentered", dc = "h-buttonList--item__checkmark", hc = "h-buttonList--item__buttonLoading", uc = "h-buttonList--item__buttonContent", Kt = {
  item: rc,
  icon: ac,
  button: ic,
  buttonDisabled: lc,
  buttonCentered: cc,
  checkmark: dc,
  buttonLoading: hc,
  buttonContent: uc
}, pc = function({
  icon: s,
  children: t,
  className: e,
  isSelected: n,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = b(
    {
      [Kt.item]: !0
    },
    e
  ), g = b(
    Kt.button,
    {
      [Kt.buttonCentered]: r,
      [Kt.buttonLoading]: a,
      [Kt.buttonDisabled]: l
    },
    c
  ), y = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ o.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ o.jsxs(
    "button",
    {
      ...y,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ o.jsxs("span", { className: Kt.buttonContent, children: [
          s && /* @__PURE__ */ o.jsx(R, { className: Kt.icon, name: s }),
          /* @__PURE__ */ o.jsx(B.Paragraph, { variant: n ? "1" : "2", children: t })
        ] }),
        n && /* @__PURE__ */ o.jsx(
          R,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Kt.checkmark
          }
        )
      ]
    }
  ) });
}, mc = z(pc);
class vo extends k {
  static get Item() {
    return mc;
  }
  static get Header() {
    return oc;
  }
  static get Divider() {
    return gc;
  }
  render() {
    const { children: s, className: t, ...e } = this.props, n = b(
      {
        [wo.buttonList]: !0
      },
      t
    );
    return /* @__PURE__ */ o.jsx("div", { ...e, className: n, children: /* @__PURE__ */ o.jsx("ul", { className: wo.inner, children: s }) });
  }
}
const gc = () => /* @__PURE__ */ o.jsx(io, { as: "li", margin: "100 0" }), fc = "h-checkbox--checkbox__root", bc = "h-checkbox--checkbox__rootDisabled", yc = "h-checkbox--checkbox__rootChecked", xc = "h-checkbox--checkbox__rootIndeterminate", _c = "h-checkbox--checkbox__checkbox", Cc = "h-checkbox--checkbox__input", me = {
  root: fc,
  rootDisabled: bc,
  rootChecked: yc,
  rootIndeterminate: xc,
  checkbox: _c,
  input: Cc
};
class bn extends k {
  constructor(t) {
    super(t);
    f(this, "inputRef");
    this.inputRef = W();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: r,
      checked: a,
      indeterminate: l,
      disabled: c,
      tabIndex: d,
      ...h
    } = this.props, u = b(
      {
        [me.root]: !0,
        [me.rootDisabled]: c,
        [me.rootChecked]: a,
        [me.rootIndeterminate]: l
      },
      t
    );
    return /* @__PURE__ */ o.jsxs("span", { className: u, "data-testid": "habla-checkbox", ...h, children: [
      /* @__PURE__ */ o.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": l ? "mixed" : a,
          className: me.checkbox
        }
      ),
      /* @__PURE__ */ o.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: r,
          className: me.input,
          onChange: e || O,
          checked: a,
          disabled: c,
          ref: this.inputRef,
          tabIndex: d
        }
      )
    ] });
  }
}
const wc = "h-collapseCard--collapseCard__card", vc = {
  card: wc
}, lo = Wt({
  isOpen: !1,
  onToggle: O
}), Sc = "h-collapseCard--content__content", Ic = "h-collapseCard--content__contentIsOpen", So = {
  content: Sc,
  contentIsOpen: Ic
};
class Kr extends k {
  getRootClassName(s) {
    return b(So.content, this.props.className, {
      [So.contentIsOpen]: s
    });
  }
  render() {
    const { children: s, className: t, ...e } = this.props;
    return /* @__PURE__ */ o.jsx(lo.Consumer, { children: ({ isOpen: n }) => n ? /* @__PURE__ */ o.jsx(
      "ul",
      {
        ...e,
        className: this.getRootClassName(n),
        "data-testid": "content",
        children: s
      }
    ) : null });
  }
}
f(Kr, "displayName", "CollapseCard.Content");
function as(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (s) => {
      s.key === "Enter" && i(s);
    }
  };
}
const kc = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Dc = ["Escape", "Esc"], is = (i) => kc.includes(i), Ee = (i) => Dc.includes(i), Tc = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], Io = Tc.join(
  ':not([hidden]):not([tabindex="-1"]),'
), Ur = Rr(function({
  containerRef: s,
  children: t,
  isActive: e,
  autoFocus: n,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = e !== void 0, d = e === void 0 || e, h = Z(null), u = Z(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = s || h;
  Er(
    "Tab",
    (y) => {
      var S, v;
      if (!d)
        return;
      const x = (S = p.current) == null ? void 0 : S.querySelectorAll(Io), C = !((v = p.current) != null && v.contains(
        y.target instanceof Element ? y.target : null
      ));
      if (!x)
        return;
      const _ = x[0], w = x[x.length - 1];
      if (!y.shiftKey && document.activeElement === w || !y.shiftKey && l && C)
        return _ == null || _.focus(), y.preventDefault();
      (y.shiftKey && document.activeElement === _ || y.shiftKey && l && C) && (w == null || w.focus(), y.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      var y, x;
      n && (n === !0 ? (x = (y = p.current) == null ? void 0 : y.querySelector(Io)) == null || x.focus() : n.current && n.current.focus());
    });
  }, g = () => {
    var y;
    document.activeElement !== document.body && !((y = p.current) != null && y.contains(document.activeElement)) || setTimeout(() => {
      var x;
      r && (r === !0 ? (x = u.current) == null || x.focus() : r.current && r.current.focus());
    });
  };
  return Le(() => {
    c || (m(), a == null || a(!0));
  }), te(() => {
    c || (g(), a == null || a(!1));
  }), Zt(() => {
    e === !0 ? (u.current = document.activeElement, m()) : e === !1 && g(), a == null || a(!!e);
  }, [e]), s ? /* @__PURE__ */ o.jsx(o.Fragment, { children: t }) : /* @__PURE__ */ o.jsx("div", { ref: h, children: t });
}), jc = "h-dropdown--dropdown__dropdown", Nc = "h-dropdown--dropdown__dropdownOpen", Fc = "h-dropdown--dropdown__dropdownFromRight", Pc = "h-dropdown--dropdown__dropdownFromBottom", Rc = "h-dropdown--dropdown__dropdownAnimating", Lc = "h-dropdown--dropdown__dropdownFixed", Ec = "h-dropdown--dropdown__loader", $c = "h-dropdown--dropdown__error", Ac = "h-dropdown--dropdown__errorIcon", $t = {
  dropdown: jc,
  dropdownOpen: Nc,
  dropdownFromRight: Fc,
  dropdownFromBottom: Pc,
  dropdownAnimating: Rc,
  dropdownFixed: Lc,
  loader: Ec,
  error: $c,
  errorIcon: Ac
};
class zt extends k {
  constructor(t) {
    super(t);
    f(this, "dropdownRef");
    f(this, "timeoutAnimationStart");
    f(this, "timeoutAnimationEnd");
    this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = W(), this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: r, isLoading: a, errorMessage: l, fixed: c, closeOnBlur: d } = this.props;
    if (n && (a !== t.isLoading || l !== t.errorMessage)) {
      const h = a !== t.isLoading && a;
      this.animate(n.oldWidth, n.oldHeight, h);
    }
    r && this.calculatePosition(), r !== t.isOpen && (window[r ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), d && window[r ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), c && window[r ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleClickOutsideDropdown), window.removeEventListener("scroll", this.handleFixedScroll), window.removeEventListener("blur", this.handleOnClose), window.clearInterval(this.timeoutAnimationStart), window.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const r = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = window.setTimeout(() => {
        this.setState({
          width: r.width,
          height: r.height
        }), this.timeoutAnimationEnd = window.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !(t.target instanceof Node)) return;
    const { onClose: e } = this.props;
    this.dropdownRef.current && t.target !== this.dropdownRef.current && !this.dropdownRef.current.contains(t.target) && e();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, r = window.innerWidth / 2, a = window.innerHeight / 2;
      this.setState({
        fromRight: e > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, r = this.dropdownRef.current.parentElement.getBoundingClientRect(), a = {};
      return t ? a.right = `${window.innerWidth - r.right}px` : a.left = `${r.left}px`, e && (a.bottom = `${window.innerHeight - r.top}px`), n && (a.top = `${r.top + r.height}px`), a;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: r,
      isLoading: a,
      closeOnBlur: l,
      errorMessage: c,
      fixed: d,
      style: h,
      autoFocus: u,
      restoreFocus: p,
      bringInFocusOnTab: m,
      ...g
    } = this.props, { fromRight: y, fromBottom: x, animating: C, width: _, height: w } = this.state, S = b(
      {
        [$t.dropdown]: !0,
        [$t.dropdownOpen]: r,
        [$t.dropdownFromRight]: y,
        [$t.dropdownFromBottom]: x,
        [$t.dropdownAnimating]: C,
        [$t.dropdownFixed]: d
      },
      t
    );
    let v = { ...h };
    _ && w && (v.width = `${_}px`, v.height = `${w}px`), d && (v = { ...v, ...this.getFixedPosition() });
    const T = !a && !c;
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        ...g,
        className: S,
        ref: this.dropdownRef,
        style: v,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": r,
        children: [
          a && /* @__PURE__ */ o.jsx("div", { className: $t.loader }),
          !!c && !a && /* @__PURE__ */ o.jsxs("div", { className: $t.error, children: [
            /* @__PURE__ */ o.jsx(R, { className: $t.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ o.jsx("span", { children: c })
          ] }),
          T && /* @__PURE__ */ o.jsx(
            Ur,
            {
              containerRef: this.dropdownRef,
              isActive: r,
              autoFocus: u,
              restoreFocus: p,
              bringInFocusOnTab: m,
              children: e
            }
          )
        ]
      }
    );
  }
}
f(zt, "defaultProps", {
  onClose: () => {
  },
  closeOnBlur: !0
});
const Oc = "h-dropdownButton--dropdownButton__root", Bc = "h-dropdownButton--dropdownButton__wrapper", Cs = {
  root: Oc,
  wrapper: Bc
}, yn = Wt({
  toggleDropdown: O,
  openDropdown: O,
  closeDropdown: O,
  dropdownOpen: !1
});
class ee extends xt {
  constructor(t) {
    super(t);
    f(this, "buttonWrapperRef");
    f(this, "buttonRef");
    f(this, "contextState");
    f(this, "timeoutId");
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.buttonWrapperRef = W(), this.buttonRef = W(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  componentDidMount() {
    this.props.allowEscClose && this.props.show && window.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && window.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && window.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    Ee(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return window.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: r, dropdownOpen: a } = this.state, l = t ?? !a;
    this.contextState = { ...this.contextState, dropdownOpen: l }, this.setState({ dropdownOpen: l, pristine: !1 }), e && (l ? window.addEventListener : window.removeEventListener)("keydown", this.handleKeyDown, !0), n == null || n(l, r);
  }
  shouldDropdownBeAboveButton() {
    var e;
    const t = (e = this.buttonWrapperRef.current) == null ? void 0 : e.getBoundingClientRect();
    return t ? t.bottom > window.innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: r,
      noStyle: a,
      onMouseEnter: l,
      onMouseLeave: c
    } = this.props, { fromBottom: d } = this.state;
    return a ? /* @__PURE__ */ o.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e == null ? void 0 : e.className,
        ...e,
        onMouseEnter: l,
        onMouseLeave: c,
        ...as(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ o.jsx(
      st,
      {
        innerRef: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: l,
        onMouseLeave: c,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ o.jsx(
      tt,
      {
        innerRef: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: l,
        onMouseLeave: c,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: r ? void 0 : /* @__PURE__ */ o.jsx(R, { name: d ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: r,
      buttonProps: a,
      dropdownProps: l,
      noArrow: c,
      noStyle: d,
      show: h,
      onToggle: u,
      isLoading: p,
      errorMessage: m,
      fixed: g,
      onMouseEnter: y,
      onMouseLeave: x,
      allowEscClose: C,
      ..._
    } = this.props, { dropdownOpen: w, pristine: S } = this.state, v = b({ [Cs.root]: Cs.root }, t);
    return /* @__PURE__ */ o.jsx(yn.Provider, { value: this.contextState, children: /* @__PURE__ */ o.jsx("div", { ..._, className: v, ref: this.buttonWrapperRef, children: /* @__PURE__ */ o.jsxs("div", { className: Cs.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ o.jsx(
        zt,
        {
          restoreFocus: this.buttonRef,
          ...l,
          isOpen: w,
          onClose: this.close,
          isLoading: p,
          errorMessage: m,
          fixed: g,
          children: (w || !S) && r
        }
      )
    ] }) }) });
  }
}
f(ee, "defaultProps", {
  allowEscClose: !0
});
const Hc = "h-collapseCard--header__header", Wc = "h-collapseCard--header__headerOpen", Mc = "h-collapseCard--header__headerHasDropdown", zc = "h-collapseCard--header__title", vn = {
  header: Hc,
  headerOpen: Wc,
  headerHasDropdown: Mc,
  title: zc
};
class zs extends k {
  getRootClassName(s) {
    const { dropdown: t, className: e } = this.props;
    return b(
      vn.header,
      { [vn.headerOpen]: s, [vn.headerHasDropdown]: !!t },
      e
    );
  }
  render() {
    const {
      children: s,
      className: t,
      title: e,
      avatar: n,
      wrap: r = "nowrap",
      dropdown: a,
      onDropdownToggle: l,
      dropdownTrigger: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ o.jsx(lo.Consumer, { children: ({ isOpen: h, onToggle: u }) => {
      const p = this.getRootClassName(h);
      return /* @__PURE__ */ o.jsxs(
        "div",
        {
          ...d,
          onClick: u,
          className: p,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ o.jsxs(M, { alignItems: "center", padding: "400 0", children: [
              n,
              /* @__PURE__ */ o.jsx("div", { onMouseDown: (m) => m.stopPropagation(), children: /* @__PURE__ */ o.jsx(
                B.Paragraph,
                {
                  variant: "1",
                  wrap: r,
                  className: vn.title,
                  children: s
                }
              ) })
            ] }),
            /* @__PURE__ */ o.jsxs(M, { alignItems: "center", children: [
              !!a && /* @__PURE__ */ o.jsx(
                ee,
                {
                  onClick: (m) => m.stopPropagation(),
                  icon: c ? void 0 : "dots-h",
                  dropdown: a,
                  buttonProps: { variant: "tertiary" },
                  onToggle: l,
                  children: c
                }
              ),
              /* @__PURE__ */ o.jsx(
                st,
                {
                  icon: h ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
// It's important to keep the displayName because it's used by the collapseCard
// To determine the type of it's children
f(zs, "displayName", "CollapseCard.Header"), f(zs, "defaultProps", {
  title: ""
});
const Vc = "h-collapseCard--line__line", Kc = "h-collapseCard--line__lineHasLabel", Uc = "h-collapseCard--line__value", qc = "h-collapseCard--line__lineHideOverflow", Sn = {
  line: Vc,
  lineHasLabel: Kc,
  value: Uc,
  lineHideOverflow: qc
};
class Gc extends k {
  render() {
    const { label: s, children: t, className: e, hideOverflow: n, ...r } = this.props, a = b(
      {
        [Sn.line]: !0,
        [Sn.lineHasLabel]: !!s,
        [Sn.lineHideOverflow]: n
      },
      e
    );
    return /* @__PURE__ */ o.jsxs("li", { ...r, className: a, children: [
      s && /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: s }),
      s ? /* @__PURE__ */ o.jsx("span", { className: Sn.value, children: t }) : t
    ] });
  }
}
const Yc = "h-collapseCard--readMore__readMore", Qc = {
  readMore: Yc
};
class Xc extends k {
  render() {
    const { onClick: s, url: t, children: e, className: n, ...r } = this.props, a = b({ [Qc.readMore]: !0 }, n);
    return t ? /* @__PURE__ */ o.jsx(B.ExternalLink, { ...r, href: t, className: a, children: e }) : /* @__PURE__ */ o.jsx(
      tt,
      {
        variant: "secondary",
        ...r,
        onClick: s,
        className: a,
        children: e
      }
    );
  }
}
const Jc = "h-collapseCard--status__status", Zc = {
  status: Jc
};
class td extends k {
  render() {
    const { children: s, className: t, ...e } = this.props, n = b({ [Zc.status]: !0 }, t);
    return /* @__PURE__ */ o.jsx("li", { ...e, className: n, children: s });
  }
}
class le extends k {
  constructor(s) {
    super(s), this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(s) {
    var t;
    return ((t = s == null ? void 0 : s.type) == null ? void 0 : t.displayName) === "CollapseCard.Header" && Lt(s);
  }
  isContent(s) {
    var t;
    return ((t = s == null ? void 0 : s.type) == null ? void 0 : t.displayName) === "CollapseCard.Content" && Lt(s);
  }
  getHeaderChildren() {
    return Ht.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Ht.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: s } = this.props;
    return b(vc.card, s);
  }
  render() {
    const { className: s, onToggle: t, isOpen: e, children: n, ...r } = this.props;
    return /* @__PURE__ */ o.jsx(
      lo.Provider,
      {
        value: { isOpen: e, onToggle: this.handleToggle },
        children: /* @__PURE__ */ o.jsxs("div", { ...r, className: this.getRootClassName(), children: [
          this.getHeaderChildren(),
          this.getContentChildren()
        ] })
      }
    );
  }
}
f(le, "defaultProps", {
  isOpen: !1
}), f(le, "Line", Gc), f(le, "Header", zs), f(le, "Content", Kr), f(le, "ReadMore", Xc), f(le, "Status", td);
const OD = gn(le, {
  fallback: /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), ed = "h-collapsible--collapsible__root", nd = "h-collapsible--collapsible__collapsible", sd = "h-collapsible--collapsible__children", ws = {
  root: ed,
  collapsible: nd,
  children: sd
};
class BD extends k {
  constructor(t) {
    super(t);
    f(this, "childrenRef");
    this.childrenRef = W(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight();
  }
  componentDidUpdate() {
    this.measureChildrenHeight();
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: r, ...a } = this.props, { childrenHeight: l } = this.state, c = b(
      {
        [ws.root]: !0
      },
      t
    ), d = {
      maxHeight: n ? l : 0
    };
    return /* @__PURE__ */ o.jsxs("div", { ...a, className: c, children: [
      /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx("div", { children: e }) }),
      !!r && /* @__PURE__ */ o.jsx("div", { style: d, className: ws.collapsible, children: /* @__PURE__ */ o.jsx("span", { className: ws.children, ref: this.childrenRef, children: r }) })
    ] });
  }
}
const od = "h-colorPicker--colorPicker__root", rd = {
  root: od
}, ad = "h-inputWrapper--inputWrapper__root", id = "h-inputWrapper--inputWrapper__rootDisabled", ld = "h-inputWrapper--inputWrapper__rootActive", cd = "h-inputWrapper--inputWrapper__rootHasError", dd = "h-inputWrapper--inputWrapper__rootHasWarning", hd = "h-inputWrapper--inputWrapper__rootHasSuccess", ud = "h-inputWrapper--inputWrapper__inputWrapper", pd = "h-inputWrapper--inputWrapper__rootWithPrefix", md = "h-inputWrapper--inputWrapper__rootWithSuffix", gd = "h-inputWrapper--inputWrapper__suffixesContainer", fd = "h-inputWrapper--inputWrapper__prefix", bd = "h-inputWrapper--inputWrapper__suffix", yd = "h-inputWrapper--inputWrapper__prefixDropdownButton", xd = "h-inputWrapper--inputWrapper__suffixDropdownButton", _d = "h-inputWrapper--inputWrapper__prefixButton", Cd = "h-inputWrapper--inputWrapper__suffixButton", wd = "h-inputWrapper--inputWrapper__icon", ct = {
  root: ad,
  rootDisabled: id,
  rootActive: ld,
  rootHasError: cd,
  rootHasWarning: dd,
  rootHasSuccess: hd,
  inputWrapper: ud,
  rootWithPrefix: pd,
  rootWithSuffix: md,
  suffixesContainer: gd,
  prefix: fd,
  suffix: bd,
  prefixDropdownButton: yd,
  suffixDropdownButton: xd,
  prefixButton: _d,
  suffixButton: Cd,
  icon: wd
}, Vs = Wt({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), vd = "inputWrapper";
class Sd extends k {
  renderIcon() {
    const { icon: s } = this.props;
    return s ? /* @__PURE__ */ o.jsx(R, { className: ct.icon, name: s }) : null;
  }
  isButtonAddon(s) {
    return !!s && "type" in s && s.type === "button";
  }
  isCustomAddon(s) {
    return !!s && "type" in s && (!s.type || s.type === "custom");
  }
  renderAddon(s) {
    const t = this.props[s], { disabled: e } = this.props;
    if (!t)
      return null;
    let n;
    if (typeof t != "object" || !("type" in t))
      n = /* @__PURE__ */ o.jsx("div", { className: b(ct[s]), children: t });
    else if (this.isCustomAddon(t))
      n = t.noWrap ? t.value : /* @__PURE__ */ o.jsx("div", { className: ct[s], children: t.value });
    else if (this.isButtonAddon(t)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = t.button;
      n = /* @__PURE__ */ o.jsx(
        st,
        {
          className: b(
            {
              [ct[s]]: !t.noStyle,
              [ct[`${s}Button`]]: !t.noStyle
            },
            r
          ),
          disabled: e || a,
          ...l
        }
      );
    }
    return n;
  }
  getContextValue(s) {
    const { disabled: t, active: e, status: n } = this.props;
    return {
      position: s,
      disabled: !!t,
      active: !!e,
      status: n || "success"
    };
  }
  render() {
    const {
      className: s,
      disabled: t,
      active: e,
      status: n,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = b(
      ct.root,
      {
        [ct.rootActive]: e,
        [ct.rootDisabled]: t,
        [ct.rootHasError]: n === "error",
        [ct.rootHasWarning]: n === "warning",
        [ct.rootHasSuccess]: n === "success",
        [ct.rootWithPrefix]: !!r,
        [ct.rootWithSuffix]: !!a
      },
      s
    );
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": vd,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ o.jsx(Vs.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ o.jsx("div", { className: ct.inputWrapper, children: c }),
          /* @__PURE__ */ o.jsxs("span", { className: ct.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ o.jsx(Vs.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const Et = z(function(s, t) {
  return /* @__PURE__ */ o.jsx(Sd, { innerRef: t, ...s, children: s.children });
}), Id = "h-colorPicker-input--colorPickerInput__input", kd = {
  input: Id
}, Dd = ({
  className: i,
  ...s
}) => /* @__PURE__ */ o.jsx(Et, { prefix: "#", children: /* @__PURE__ */ o.jsx(
  Ya,
  {
    className: b(kd.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...s
  }
) }), Td = "h-colorPicker-presets--colorPickerPresets__root", jd = {
  root: Td
}, Nd = "h-colorPicker-presets-preset--colorPickerPreset__root", Fd = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Pd = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", Rd = "h-colorPicker-presets-preset--colorPickerPreset__preset", In = {
  root: Nd,
  rootIsSelected: Fd,
  rootAlpha: Pd,
  preset: Rd
}, Ld = ({
  color: i,
  onSelect: s,
  isSelected: t,
  alpha: e,
  className: n
}) => /* @__PURE__ */ o.jsx(
  "li",
  {
    className: b(In.root, n, {
      [In.rootIsSelected]: t,
      [In.rootAlpha]: e
    }),
    children: /* @__PURE__ */ o.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: In.preset,
        style: { backgroundColor: i },
        onClick: () => {
          s == null || s(i);
        }
      }
    )
  }
);
no([so]);
const Ed = ({
  presets: i,
  className: s,
  onChange: t,
  color: e,
  alpha: n,
  ...r
}) => /* @__PURE__ */ o.jsx(
  M,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: b(jd.root, s),
    ...r,
    children: i.map((a) => /* @__PURE__ */ o.jsx(
      Ld,
      {
        onSelect: t,
        color: a,
        isSelected: e === (a.startsWith("#") ? a : qn(a).toHex()),
        alpha: n
      },
      a
    ))
  }
);
no([so]);
const $d = ({
  onChange: i,
  color: s,
  alpha: t,
  className: e,
  ...n
}) => {
  const r = L((a) => {
    setTimeout(() => {
      i == null || i(qn(a).toHex());
    });
  }, []);
  return t ? /* @__PURE__ */ o.jsx(
    Xa,
    {
      className: e,
      color: qn(s ?? "").toRgbString(),
      onChange: r,
      ...n
    }
  ) : /* @__PURE__ */ o.jsx(
    Qa,
    {
      className: e,
      color: s,
      onChange: i,
      ...n
    }
  );
};
no([so]);
const Ad = "colorPickerTestId", ls = ({
  className: i,
  color: s,
  onChange: t,
  alpha: e,
  children: n,
  ...r
}) => {
  const [a, l] = U();
  return G(() => {
    const c = s != null && s.startsWith("#") ? s : qn(s ?? "").toHex();
    l(c);
  }, [s]), /* @__PURE__ */ o.jsx(
    M,
    {
      flexDirection: "column",
      gap: "250",
      className: b(rd.root, i),
      "data-testid": Ad,
      ...r,
      children: Ht.map(
        n,
        (c) => Lt(c) && un(c, {
          onChange: t,
          color: a,
          alpha: e,
          ...c.props
        })
      )
    }
  );
};
ls.Input = Dd;
ls.Sliders = $d;
ls.Presets = Ed;
const Od = "h-columns--columns__root", Bd = {
  root: Od
}, Hd = "1fr", Wd = z(function({ as: s = "div", children: t, className: e, style: n, ...r }, a) {
  const c = Ht.toArray(t).map((d) => d.props.size ?? Hd).join(" ");
  return /* @__PURE__ */ o.jsx(
    s,
    {
      ...r,
      ref: a,
      className: b(Bd.root, e),
      style: { ...n, gridTemplateColumns: c },
      children: t
    }
  );
}), Md = "h-columns-column--column__root", zd = {
  root: Md
}, Vd = "h-columns-column-row--columnRow__root", Kd = "h-columns-column-row--columnRow__noMinHeight", Ud = "h-columns-column-row--columnRow__noVerticalPadding", qd = "h-columns-column-row--columnRow__noHorizontalPadding", Gd = "h-columns-column-row--columnRow__borderTop", Yd = "h-columns-column-row--columnRow__borderBottom", Qd = "h-columns-column-row--columnRow__scrollable", Xd = "h-columns-column-row--columnRow__slottable", Ut = {
  root: Vd,
  noMinHeight: Kd,
  noVerticalPadding: Ud,
  noHorizontalPadding: qd,
  borderTop: Gd,
  borderBottom: Yd,
  scrollable: Qd,
  slottable: Xd
}, Jd = 1, Zd = z(function({
  as: s = "div",
  children: t,
  className: e,
  noVerticalPadding: n,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const y = b(e, Ut.root, {
    [Ut.slottable]: u,
    [Ut.noVerticalPadding]: u ?? n,
    [Ut.noHorizontalPadding]: r,
    [Ut.borderTop]: l,
    [Ut.borderBottom]: c,
    [Ut.scrollable]: d,
    [Ut.noMinHeight]: a
  });
  return /* @__PURE__ */ o.jsx(
    s,
    {
      ...m,
      ref: g,
      className: y,
      style: {
        ...p,
        flexGrow: h ?? d ? Jd : void 0
      },
      children: t
    }
  );
}), th = "h-columns-column-slot--columnSlot__root", eh = "h-columns-column-slot--columnSlot__noVerticalPadding", ko = {
  root: th,
  noVerticalPadding: eh
}, nh = ({
  children: i,
  className: s,
  noVerticalPadding: t,
  placement: e = "start"
}) => {
  const n = b(ko.root, s, {
    [ko.noVerticalPadding]: t
  });
  return /* @__PURE__ */ o.jsx(
    M,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: e,
      className: n,
      children: i
    }
  );
}, ft = ({
  as: i,
  children: s,
  className: t
}) => /* @__PURE__ */ o.jsx(
  M,
  {
    as: i,
    flexDirection: "column",
    className: b(zd.root, t),
    children: s
  }
);
ft.Row = Zd;
ft.Slot = nh;
const sh = "h-copyToClipboard--copyToClipboard__copyToClipboard", oh = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", Do = {
  copyToClipboard: sh,
  copyToClipboardTooltip: oh
};
class qr extends xt {
  constructor(t) {
    super(t);
    f(this, "timerHandle");
    this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: r, onClick: a } = this.props;
    e || (typeof a == "function" && a(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, r);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: r } = this.props, { clicked: a } = this.state, l = b(
      Do.copyToClipboard,
      { [Do.copyToClipboardTooltip]: a && r },
      t
    );
    return /* @__PURE__ */ o.jsx("div", { className: l, children: Ht.map(e, (c) => Lt(c) ? un(c, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...a ? n : {}
    }) : c) });
  }
}
f(qr, "defaultProps", {
  tooltip: !0,
  disabled: !1,
  transitionDuration: 2e3,
  clickedProps: {}
});
class HD extends k {
  render() {
    const { buttonProps: s, ...t } = this.props;
    return /* @__PURE__ */ o.jsx(qr, { ...t, children: /* @__PURE__ */ o.jsx(Rt, { icon: "copy", variant: "secondary", ...s }) });
  }
}
const rh = "h-simplePagination--simplePagination__paginationButton", To = {
  paginationButton: rh
}, ah = "simplePaginationTestId", ih = ({
  nextButtonClick: i = O,
  previousButtonClick: s = O,
  nextButtonText: t = "Next page",
  previousButtonText: e = "Previous page",
  nextButtonDisabled: n = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ o.jsxs("div", { "data-testid": ah, ...p, children: [
  !l && /* @__PURE__ */ o.jsx(
    tt,
    {
      disabled: r || h,
      onClick: s,
      variant: "secondary",
      ...d,
      className: b(
        To.paginationButton,
        d == null ? void 0 : d.className
      ),
      children: h ? u : e
    }
  ),
  !a && /* @__PURE__ */ o.jsx(
    tt,
    {
      disabled: n || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: b(
        To.paginationButton,
        c == null ? void 0 : c.className
      ),
      children: h ? u : t
    }
  )
] }), cs = Wt(
  void 0
);
var ht = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(ht || {});
const lh = "h-table-tfoot--tfoot__root", ch = "h-table-tfoot--tfoot__rootIsLoading", jo = {
  root: lh,
  rootIsLoading: ch
}, Gr = Wt(
  void 0
), No = ({ className: i, children: s, ...t }, e) => /* @__PURE__ */ o.jsx(cs.Consumer, { children: (n) => n != null && n.status.loading && ["spinner"].includes(n == null ? void 0 : n.loading.loadingStrategy) ? null : /* @__PURE__ */ o.jsx(Gr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ o.jsx(
  "tfoot",
  {
    ...t,
    ref: e,
    className: b(
      {
        [jo.rootIsLoading]: n == null ? void 0 : n.status.loading
      },
      jo.root,
      i
    ),
    "data-testid": ht.Foot,
    children: s
  }
) }) }), dh = Object.assign(z(No), { name: No.name }), hh = "h-table-thead--thead__root", uh = "h-table-thead--thead__rootIsLoading", Fo = {
  root: hh,
  rootIsLoading: uh
}, Yr = Wt(
  void 0
), Po = ({ className: i, ...s }, t) => /* @__PURE__ */ o.jsx(cs.Consumer, { children: (e) => {
  const n = b(Fo.root, i, {
    [Fo.rootIsLoading]: e == null ? void 0 : e.status.loading
  });
  return /* @__PURE__ */ o.jsx(Yr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ o.jsx(
    "thead",
    {
      ...s,
      ref: t,
      className: n,
      "data-testid": ht.Head
    }
  ) });
} }), ph = Object.assign(z(Po), { name: Po.name }), $e = (i) => {
  const s = Jt(cs);
  if (!s)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const t = Jt(Yr) || {
    isTableHead: !1
  }, e = Jt(Gr) || {
    isTableFoot: !1
  };
  return i.children({
    ...s,
    ...t,
    ...e
  });
}, mh = "h-table-tableFooter--tableFooter__root", gh = "h-table-tableFooter--tableFooter__rootIsLoading", Ro = {
  root: mh,
  rootIsLoading: gh
}, Lo = ({ children: i, className: s, ...t }, e) => /* @__PURE__ */ o.jsx($e, { children: ({ status: n }) => /* @__PURE__ */ o.jsx(
  "div",
  {
    ref: e,
    className: b(
      {
        [Ro.rootIsLoading]: n.loading
      },
      Ro.root,
      s
    ),
    ...t,
    children: i
  }
) }), co = Object.assign(z(Lo), {
  name: Lo.name
});
function fh(i) {
  return Ht.toArray(i).reduce(
    (s, t) => {
      const e = t;
      return e.type === co ? s.footers.push(e) : s.children.push(e), s;
    },
    { children: [], footers: [] }
  );
}
var Qn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Qn || {});
const bh = "h-pagination--pageNumber__button", yh = "h-pagination--pageNumber__text", xh = "h-pagination--pageNumber__textSelected", vs = {
  button: bh,
  text: yh,
  textSelected: xh
}, _h = ({
  number: i,
  isSelected: s = !1,
  onClick: t
}) => {
  const e = b(vs.text, {
    [vs.textSelected]: s
  });
  return /* @__PURE__ */ o.jsx("li", { children: /* @__PURE__ */ o.jsx(
    tt,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => t(i),
      "data-testid": Qn.PageNumber,
      className: vs.button,
      children: /* @__PURE__ */ o.jsx("span", { className: e, children: i })
    }
  ) });
}, Ch = "h-pagination--pagination__root", wh = "h-pagination--pagination__pageNumberSeparatorWrapper", Eo = {
  root: Ch,
  pageNumberSeparatorWrapper: wh
};
class Qr extends xt {
  constructor(s) {
    super(s), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: s, pageCount: t, pageRangeDisplayed: e } = this.props, n = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [s, t, e].every(
      n
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(s) {
    const { currentPage: t, onPageChange: e } = this.props;
    s !== t && e(s);
  }
  areAllPagedDisplayable() {
    const { pageCount: s, pageRangeDisplayed: t } = this.props;
    return t >= s;
  }
  leadingTruncationIsNeeded() {
    const { start: t } = this.calculateMiddlePagesRange();
    return t - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: s } = this.props, { start: t, length: e } = this.calculateMiddlePagesRange(), n = t - 1 + e;
    return s - n > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: s } = this.props;
    return s - 2;
  }
  calculateMiddlePagesRange(s) {
    const { pageCount: t, currentPage: e } = this.props, n = Math.max(
      this.getMiddlePagesLength() - ((s == null ? void 0 : s.extraPadding) ?? 0),
      1
    ), r = n % 2 === 0 ? n / 2 - 1 : Math.floor(n / 2);
    return { start: Mn(
      e - r,
      2,
      t - n
    ), length: n };
  }
  createPageNumbers(s, t = 1) {
    return Array.from({ length: s }, (e, n) => n + t);
  }
  renderPageNumbers(s, t = 1) {
    return this.createPageNumbers(s, t).map(
      (e) => this.renderSinglePageNumber(e)
    );
  }
  renderSinglePageNumber(s) {
    const { currentPage: t } = this.props, e = s === t;
    return /* @__PURE__ */ o.jsx(
      _h,
      {
        number: s,
        isSelected: e,
        onClick: this.handlePageSelect
      },
      s
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(s = 0) {
    return /* @__PURE__ */ o.jsx("li", { className: Eo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ o.jsx(Lr, { name: "dots-h" }) }, `gap-${s}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: s } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(s)] : this.renderSinglePageNumber(s);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: e, length: n } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(n, e);
    }
    const { start: s, length: t } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(t, s);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: s } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ o.jsxs("ul", { className: b(Eo.root, s), children: [
      /* @__PURE__ */ o.jsx("li", { children: /* @__PURE__ */ o.jsx(
        Rt,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Qn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ o.jsx("li", { children: /* @__PURE__ */ o.jsx(
        Rt,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Qn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
f(Qr, "defaultProps", {
  pageRangeDisplayed: 6
});
const $o = ({ children: i, ...s }, t) => /* @__PURE__ */ o.jsx($e, { children: ({ pagination: e }) => !e.paginated || e.pageCount <= 1 ? null : /* @__PURE__ */ o.jsx(co, { children: /* @__PURE__ */ o.jsx("div", { ref: t, ...s, "data-testid": ht.PaginationRow, children: /* @__PURE__ */ o.jsx(M, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ o.jsx(
  Qr,
  {
    currentPage: e.selectedPage,
    pageCount: e.pageCount,
    onPageChange: e.onPageChange,
    pageRangeDisplayed: e.pageRangeDisplayed
  }
) }) }) }) }), vh = Object.assign(z($o), {
  name: $o.name
}), Sh = "h-table-tbody--tbody__root", Ih = "h-table-tbody--tbody__rootIsLoading", kh = "h-table-tbody--tbody__rootIsLoadingFade", Ss = {
  root: Sh,
  rootIsLoading: Ih,
  rootIsLoadingFade: kh
}, Dh = "h-emptyState--emptyState__textWrapper", Th = "h-emptyState--emptyState__rootSmall", jh = "h-emptyState--emptyState__rootLarge", Is = {
  textWrapper: Dh,
  rootSmall: Th,
  rootLarge: jh
}, Nh = ({
  className: i,
  title: s,
  description: t,
  icon: e = "info",
  iconColor: n = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = b(
    {
      [Is.rootSmall]: r === "small",
      [Is.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ o.jsxs(
    M,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        e && /* @__PURE__ */ o.jsx(R, { name: e, size: 20, color: an(n) }),
        /* @__PURE__ */ o.jsxs(
          M,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: Is.textWrapper,
            children: [
              /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "1", children: s }),
              /* @__PURE__ */ o.jsx(
                B.Paragraph,
                {
                  variant: "2",
                  as: typeof t == "string" ? "p" : "div",
                  children: t
                }
              )
            ]
          }
        ),
        (a == null ? void 0 : a.children) && /* @__PURE__ */ o.jsx(tt, { ...a })
      ]
    }
  );
};
function Fh(i) {
  return /* @__PURE__ */ o.jsx("tr", { "data-testid": ht.EmptyRow, children: /* @__PURE__ */ o.jsx("td", { colSpan: 100, children: /* @__PURE__ */ o.jsx(M, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ o.jsx(Nh, { ...i }) }) }) });
}
function Ph({
  onRetry: i,
  ...s
}) {
  return /* @__PURE__ */ o.jsx("tr", { "data-testid": ht.LoadingFailedRow, ...s, children: /* @__PURE__ */ o.jsx("td", { colSpan: 100, children: /* @__PURE__ */ o.jsxs(
    M,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ o.jsx(tt, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function Rh({
  ...i
}) {
  return /* @__PURE__ */ o.jsx("tr", { "data-testid": ht.LoadingRow, ...i, children: /* @__PURE__ */ o.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ o.jsxs(
    M,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ o.jsx(ao, {}),
        /* @__PURE__ */ o.jsx(lt, { margin: "300", children: /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const Ao = ({ children: i, className: s, ...t }, e) => /* @__PURE__ */ o.jsx($e, { children: ({
  status: { loading: n, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !n, h = ["spinner"].includes(c) ? !n && !d : !d;
  return /* @__PURE__ */ o.jsxs(
    "tbody",
    {
      ...t,
      "data-testid": ht.Body,
      ref: e,
      className: b(
        {
          [Ss.rootIsLoading]: n,
          [Ss.rootIsLoadingFade]: n && c === "fade"
        },
        Ss.root,
        s
      ),
      children: [
        c === "spinner" && n && /* @__PURE__ */ o.jsx(Rh, {}),
        d && /* @__PURE__ */ o.jsx(Ph, { onRetry: a }),
        l && /* @__PURE__ */ o.jsx(Fh, { ...l }),
        h && i
      ]
    }
  );
} }), Lh = Object.assign(z(Ao), { name: Ao.name }), Eh = "h-table-td--td__root", $h = "h-table-td--td__rootExtraPaddingForFirstChild", Ah = "h-table-td--td__rootStickyFooterTd", ks = {
  root: Eh,
  rootExtraPaddingForFirstChild: $h,
  rootStickyFooterTd: Ah
}, Oo = ({ className: i, children: s, ...t }, e) => /* @__PURE__ */ o.jsx($e, { children: ({ rows: n, presentation: r, isTableFoot: a }) => {
  const l = b(
    ks.root,
    {
      [ks.rootExtraPaddingForFirstChild]: !n.expandableRows,
      [ks.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ o.jsx(
    lt,
    {
      as: "td",
      ref: e,
      className: l,
      ...t,
      "data-testid": ht.Td,
      children: s
    }
  );
} }), ce = Object.assign(z(Oo), { name: Oo.name }), Oh = "h-table-th--th__root", Bh = "h-table-th--th__rootSticky", Hh = "h-table-th--th__rootShowBG", Wh = "h-table-th--th__rootClickable", Mh = "h-table-th--th__icon", zh = "h-table-th--th__contentWrapper", Vh = "h-table-th--th__tooltip", ne = {
  root: Oh,
  rootSticky: Bh,
  rootShowBG: Hh,
  rootClickable: Wh,
  icon: Mh,
  contentWrapper: zh,
  tooltip: Vh
};
class Bo extends k {
  constructor() {
    super(...arguments);
    f(this, "context");
  }
  columnIsInSortableColumns() {
    var t, e;
    return ((e = (t = this.context) == null ? void 0 : t.sorting.sortableColumns) == null ? void 0 : e.some(
      (n) => n === this.props.columnId
    )) ?? !0;
  }
  getContextualInfo() {
    var n, r;
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: ((n = e == null ? void 0 : e.sorting.sortStatus) == null ? void 0 : n.sortBy) === t,
      sortDirection: (r = e == null ? void 0 : e.sorting.sortStatus) == null ? void 0 : r.direction,
      columnIsSortable: e != null && e.sorting.sortable && !vt(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), r = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return r;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return r;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return r;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: r } = this.getContextualInfo(), { columnId: a } = this.props;
      t == null || t(n), r && !vt(a) && (e == null || e.sorting.onSortChange(this.getTheNewSortDirection(a)));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ o.jsx(
      R,
      {
        className: ne.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ o.jsx($e, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: r,
        children: a,
        tooltip: l,
        columnId: c,
        thRef: d,
        ...h
      } = this.props, { sortByThisColumn: u, columnIsSortable: p, sortDirection: m } = this.getContextualInfo(), g = b(
        ne.root,
        {
          [ne.rootClickable]: p,
          [ne.rootSticky]: n.stickyHeader,
          [ne.rootShowBG]: n.headerWithBackground
        },
        r
      ), y = b({
        [ne.tooltip]: l
      });
      return /* @__PURE__ */ o.jsx(
        lt,
        {
          as: "th",
          ...h,
          ref: d,
          className: g,
          onClick: this.getClickHandler(),
          "data-testid": ht.Th,
          children: /* @__PURE__ */ o.jsxs("span", { className: ne.contentWrapper, children: [
            /* @__PURE__ */ o.jsx(yt, { content: l, disabled: !l, children: /* @__PURE__ */ o.jsx("span", { className: y, children: a }) }),
            u && this.renderIcon(m)
          ] })
        }
      );
    } });
  }
}
const Ks = Object.assign(
  z(
    function(s, t) {
      return /* @__PURE__ */ o.jsx(Bo, { ...s, thRef: t });
    }
  ),
  { name: Bo.name }
), Kh = (i) => i === !1, Uh = "h-table-tr--tr__trHoverable", qh = "h-table-tr--tr__expansionTriggerWrapper", Gh = "h-table-tr--tr__expansionTriggerWrapperExpanded", Yh = "h-table-tr--tr__checkboxCell", Qh = "h-table-tr--tr__checkboxCellExpanded", Xh = "h-table-tr--tr__expandedRowContentWrapper", Dt = {
  trHoverable: Uh,
  expansionTriggerWrapper: qh,
  expansionTriggerWrapperExpanded: Gh,
  checkboxCell: Yh,
  checkboxCellExpanded: Qh,
  expandedRowContentWrapper: Xh
}, Jh = ({
  rowId: i,
  isExpandable: s,
  isExpanded: t,
  onExpansionToggle: e,
  expandableContent: n,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = b(u.className, {
    [Dt.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": ht.Row,
        children: [
          s && /* @__PURE__ */ o.jsx(
            ce,
            {
              className: b(Dt.expansionTriggerWrapper, {
                [Dt.expansionTriggerWrapperExpanded]: t
              }),
              children: n && /* @__PURE__ */ o.jsx(
                Rt,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right",
                  "data-testid": ht.RowExpansionTrigger,
                  onClick: () => {
                    vt(i) || e(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ o.jsx(
            ce,
            {
              className: b(Dt.checkboxCell, {
                [Dt.checkboxCellExpanded]: t
              }),
              children: /* @__PURE__ */ o.jsx(M, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ o.jsx(
                bn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    vt(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    s && t && /* @__PURE__ */ o.jsxs("tr", { "data-testid": ht.Row, children: [
      /* @__PURE__ */ o.jsx(ce, { className: Dt.expansionTriggerWrapper }),
      r && /* @__PURE__ */ o.jsx(ce, { className: Dt.checkboxCell }),
      /* @__PURE__ */ o.jsx(
        ce,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: Dt.expandedRowContentWrapper,
          children: n
        }
      )
    ] })
  ] });
}, Zh = ({
  isExpandable: i,
  children: s,
  trRef: t,
  ...e
}) => /* @__PURE__ */ o.jsxs("tr", { ...e, ref: t, "data-testid": ht.Row, children: [
  i && /* @__PURE__ */ o.jsx(ce, { className: Dt.expansionTriggerWrapper, children: /* @__PURE__ */ o.jsx("span", {}) }),
  s
] }), tu = ({
  isExpandable: i,
  isSelectable: s,
  allRowsSelected: t,
  allRowsSelectedIndeterminate: e,
  onAllRowsSelect: n,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ o.jsxs("tr", { ...l, ref: a, "data-testid": ht.Row, children: [
  i && /* @__PURE__ */ o.jsx(Ks, { className: Dt.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ o.jsx("span", {}) }),
  s && /* @__PURE__ */ o.jsx(Ks, { className: Dt.checkboxCell, columnId: null, children: /* @__PURE__ */ o.jsx(M, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ o.jsx(
    bn,
    {
      checked: t,
      indeterminate: e,
      onChange: n,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Ho extends k {
  constructor() {
    super(...arguments);
    f(this, "context");
  }
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    var e;
    const { rowId: t } = this.props;
    return ((e = this.context) == null ? void 0 : e.rows.selectableRows) === !0 && !vt(t);
  }
  hasExpandableRow() {
    var n;
    const { expandableContent: t, rowId: e } = this.props;
    return ((n = this.context) == null ? void 0 : n.rows.expandableRows) === !0 && !vt(t) && !vt(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(Kh);
  }
  rowIdIsPresent(t) {
    return !vt(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...r } = this.props;
    return /* @__PURE__ */ o.jsx($e, { children: (a) => {
      this.context = a;
      const { rows: l } = a;
      if (a.isTableHead)
        return /* @__PURE__ */ o.jsx(
          tu,
          {
            ...r,
            isExpandable: l.expandableRows,
            isSelectable: l.selectableRows,
            allRowsSelected: l.allRowsSelected,
            allRowsSelectedIndeterminate: l.allRowsSelectedIndeterminate,
            onAllRowsSelect: l.onAllRowsSelect,
            children: t
          }
        );
      if (a.isTableFoot)
        return /* @__PURE__ */ o.jsx(Zh, { ...r, isExpandable: l.expandableRows, children: t });
      const c = vt(n) ? !1 : this.isRowExpanded(l.expandedRows, n), d = vt(n) ? !1 : l.selectedRowIds.includes(n);
      return /* @__PURE__ */ o.jsx(
        Jh,
        {
          ...r,
          rowId: n,
          isExpanded: c,
          isSelected: d,
          onSelect: l.onRowSelect,
          isExpandable: l.expandableRows,
          expandableContent: e,
          isSelectable: l.selectableRows,
          onExpansionToggle: l.onExpansionToggle,
          isHoverable: a.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const eu = Object.assign(
  z(function(s, t) {
    return /* @__PURE__ */ o.jsx(Ho, { ...s, trRef: t });
  }),
  { name: Ho.name }
), nu = "h-table--table__wrapper", su = "h-table--table__wrapperIsFramed", ou = "h-table--table__wrapperIsLoading", ru = "h-table--table__innerWrapper", au = "h-table--table__wrapperIsDisabled", iu = "h-table--table__table", ge = {
  wrapper: nu,
  wrapperIsFramed: su,
  wrapperIsLoading: ou,
  innerWrapper: ru,
  wrapperIsDisabled: au,
  table: iu
}, nn = class nn extends k {
  constructor(s) {
    var t;
    super(s), this.state = {
      expandedRows: ((t = s.expandableRowsProps) == null ? void 0 : t.initiallyExpandedRows) ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  handleExpansionToggle(s) {
    this.state.expandedRows.includes(s) ? this.setState(({ expandedRows: t }) => ({
      expandedRows: t.filter((e) => e !== s)
    })) : this.setState(({ expandedRows: t }) => ({
      expandedRows: [...t, s]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: s,
        stickyHeader: t,
        stickyFooter: e,
        sortingProps: n,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!s,
        stickyHeader: !!t,
        stickyFooter: !!e,
        hoverable: !!m
      },
      sorting: {
        sortable: !!n,
        sortableColumns: n == null ? void 0 : n.sortableColumns,
        sortStatus: (n == null ? void 0 : n.sortStatus) ?? null,
        onSortChange: (n == null ? void 0 : n.onSortChange) ?? O
      },
      pagination: {
        paginated: !!r,
        selectedPage: (r == null ? void 0 : r.selectedPage) ?? 1,
        pageCount: (r == null ? void 0 : r.pageCount) ?? 1,
        onPageChange: (r == null ? void 0 : r.onPageChange) ?? O,
        pageRangeDisplayed: r == null ? void 0 : r.pageRangeDisplayed
      },
      rows: {
        expandableRows: (l == null ? void 0 : l.expandableRows) ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: (a == null ? void 0 : a.selectedRowIds) ?? [],
        onRowSelect: (a == null ? void 0 : a.onRowSelect) ?? O,
        onAllRowsSelect: (a == null ? void 0 : a.onAllRowsSelect) ?? O,
        allRowsSelected: (a == null ? void 0 : a.allRowsSelected) ?? !1,
        allRowsSelectedIndeterminate: (a == null ? void 0 : a.allRowsSelectedIndeterminate) ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: s,
      className: t,
      children: e,
      wrapperProps: n,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = fh(e), h = b(ge.wrapper, n == null ? void 0 : n.className, {
      [ge.wrapperIsFramed]: s,
      [ge.wrapperIsLoading]: this.props.loading,
      [ge.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = b(
      {
        [ge.innerWrapper]: !0
      },
      a
    ), p = b(ge.table, t), m = this.getContextValue();
    return /* @__PURE__ */ o.jsx(mn, { fallback: nn.fallback, children: /* @__PURE__ */ o.jsx(cs.Provider, { value: m, children: /* @__PURE__ */ o.jsxs("div", { ...n, className: h, children: [
      /* @__PURE__ */ o.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ o.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ o.jsx(vh, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
};
f(nn, "defaultProps", {
  headerWithBackground: !0,
  stickyHeader: !1,
  stickyFooter: !1,
  framed: !0,
  hoverable: !1,
  loadingStrategy: "spinner"
}), f(nn, "fallback", /* @__PURE__ */ o.jsx(
  M,
  {
    justifyContent: "center",
    alignItems: "center",
    style: { minHeight: "10vh" },
    children: /* @__PURE__ */ o.jsx(B.Paragraph, { children: "Oops! something went wrong..." })
  }
));
let Xn = nn;
const bt = Object.assign(
  z(
    function(s, t) {
      return /* @__PURE__ */ o.jsx(Xn, { ...s, tableRef: t });
    }
  ),
  {
    name: Xn.name,
    Thead: ph,
    Tbody: Lh,
    Tfoot: dh,
    Tr: eu,
    Th: Ks,
    Td: ce,
    Footer: co
  }
), lu = "h-helpIcon--helpIcon__infoIcon", cu = {
  infoIcon: lu
};
class ho extends k {
  render() {
    const {
      side: s,
      text: t,
      title: e,
      disabled: n,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      yt,
      {
        head: e,
        content: t,
        disabled: n,
        side: s,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ o.jsx("span", { className: b(cu.infoIcon, a), children: /* @__PURE__ */ o.jsx(R, { name: "info" }) })
      }
    );
  }
}
const Xr = ({
  columns: i
}) => /* @__PURE__ */ o.jsx(o.Fragment, { children: i.map(({ label: s, style: t, helpIcon: e, columnId: n }, r) => /* @__PURE__ */ o.jsxs(bt.Th, { columnId: n || s, style: t, children: [
  s,
  (e == null ? void 0 : e.title) && (e == null ? void 0 : e.text) && /* @__PURE__ */ o.jsx(ho, { side: "bottom", ...e })
] }, s || r)) }), du = ({
  columns: i,
  data: s
}) => /* @__PURE__ */ o.jsxs(bt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ o.jsx(bt.Thead, { children: /* @__PURE__ */ o.jsx(bt.Tr, { children: /* @__PURE__ */ o.jsx(Xr, { columns: i }) }) }),
  /* @__PURE__ */ o.jsx(bt.Tbody, { children: s.map((t, e) => /* @__PURE__ */ o.jsx(bt.Tr, { children: i.map(({ selector: n }, r) => /* @__PURE__ */ o.jsx(bt.Td, { children: n(t) }, r)) }, e)) })
] }), hu = ({
  data: i,
  rowId: s,
  columns: t,
  subTableColumns: e,
  subTableDataSelector: n
}) => /* @__PURE__ */ o.jsx(
  bt.Tr,
  {
    expandableContent: !!(e && n) && /* @__PURE__ */ o.jsx(
      du,
      {
        data: n(i),
        columns: e
      }
    ),
    rowId: s,
    children: t.map(({ selector: r }, a) => /* @__PURE__ */ o.jsx(bt.Td, { children: r(i) }, a))
  }
), WD = ({
  columns: i,
  subTableColumns: s,
  data: t,
  subTableDataSelector: e,
  tableWrapperProps: n,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((y) => y.sortable).reduce(
    (y, x) => x.columnId ? [...y, x.columnId] : y,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ o.jsxs(
    bt,
    {
      stickyHeader: !0,
      wrapperProps: n,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(s && e)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ o.jsx(bt.Thead, { children: /* @__PURE__ */ o.jsx(bt.Tr, { children: /* @__PURE__ */ o.jsx(Xr, { columns: i }) }) }),
        /* @__PURE__ */ o.jsx(bt.Tbody, { children: t.map((y, x) => /* @__PURE__ */ o.jsx(
          hu,
          {
            rowId: u ? u(y) : x,
            data: y,
            columns: i,
            subTableDataSelector: e,
            subTableColumns: s
          },
          x
        )) }),
        a && /* @__PURE__ */ o.jsx(bt.Footer, { children: /* @__PURE__ */ o.jsx(ih, { ...a }) })
      ]
    }
  );
}, uu = "h-datePickerOld--datePickerDay__root", pu = "h-datePickerOld--datePickerDay__rootActive", mu = "h-datePickerOld--datePickerDay__rootDisabled", gu = "h-datePickerOld--datePickerDay__rootDim", fu = "h-datePickerOld--datePickerDay__label", He = {
  root: uu,
  rootActive: pu,
  rootDisabled: mu,
  rootDim: gu,
  label: fu
};
class bu extends k {
  render() {
    const {
      className: s,
      dim: t,
      active: e,
      disabled: n,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = b(
      {
        [He.root]: !0,
        [He.rootDim]: t,
        [He.rootActive]: e,
        [He.rootDisabled]: !e && n
      },
      s
    );
    return /* @__PURE__ */ o.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: n,
        children: /* @__PURE__ */ o.jsx("span", { className: He.label, children: r })
      }
    );
  }
}
const yu = "h-datePickerOld--datePickerOld__grid", xu = "h-datePickerOld--datePickerOld__gridItem", _u = "h-datePickerOld--datePickerOld__day", Cu = "h-datePickerOld--datePickerOld__month", wu = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", vu = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Su = "h-datePickerOld--datePickerOld__arrowTime", Iu = "h-datePickerOld--datePickerOld__arrow", ku = "h-datePickerOld--datePickerOld__dayNames", Du = "h-datePickerOld--datePickerOld__dayName", Tu = "h-datePickerOld--datePickerOld__time", ju = "h-datePickerOld--datePickerOld__timeDisplay", X = {
  grid: yu,
  gridItem: xu,
  day: _u,
  month: Cu,
  timeButtonContainerLeft: wu,
  timeButtonContainerRight: vu,
  arrowTime: Su,
  arrow: Iu,
  dayNames: ku,
  dayName: Du,
  time: Tu,
  timeDisplay: ju
}, MD = (i) => [0, 6].indexOf(i.getDay()) !== -1, je = class je extends k {
  constructor(t) {
    super(t);
    f(this, "nextMonth", (t) => {
      t.preventDefault(), this.goToMonth(1);
    });
    f(this, "prevMonth", (t) => {
      t.preventDefault(), this.goToMonth(-1);
    });
    f(this, "nextMinutes", (t) => {
      t.preventDefault(), this.goToTime(t, 15, "minutes");
    });
    f(this, "prevMinutes", (t) => {
      t.preventDefault(), this.goToTime(t, -15, "minutes");
    });
    f(this, "nextHour", (t) => {
      t.preventDefault(), this.goToTime(t, 1);
    });
    f(this, "prevHour", (t) => {
      t.preventDefault(), this.goToTime(t, -1);
    });
    const e = je.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: je.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: r, minDate: a, maxDate: l } = this.props, c = [], d = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), h = d.getDay() || 7, u = new Date(
      d.getFullYear(),
      d.getMonth() + 1,
      1
    );
    h < 3 && d.setDate(d.getDate() - 7), d.setDate(d.getDate() - (h - 1));
    const p = je.getDateValue(n).getTime();
    let m = 0;
    for (; d < u || d.getDay() !== 1 || m < 6; ) {
      const g = d.getTime(), y = new Date(g);
      c.push({
        date: y,
        label: d.getDate().toString(),
        isThisMonth: d.getMonth() === e.getMonth(),
        selected: g === p,
        disabled: r(d) || !!(l && y > l) || !!(a && y < a)
      }), d.getDay() === 1 && (m += 1), d.setDate(d.getDate() + 1);
    }
    return c;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: r } = this.state, a = {
      ...this.state,
      selectedDate: e
    };
    r.getMonth() !== e.getMonth() && (a.showDate = e), this.setState(a), n(e);
  }
  goToTime(t, e, n = "hours") {
    const r = n === "minutes" ? "setMinutes" : "setHours", a = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: l }
    } = this.props, { selectedDate: c } = this.state, d = new Date(c.getTime());
    d[r](d[a]() + e), this.setState({
      selectedDate: d
    }), l(d);
  }
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", r = t === "minutes" ? "getMinutes" : "getHours", { maxDate: a } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    return c[n](c[r]() + e), !(c.getDate() !== l.getDate()) && (a === null || a >= c);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: r,
      minDate: a,
      maxDate: l,
      ...c
    } = this.props, { selectedDate: d, showDate: h } = this.state, u = b({}, t), p = this.generateGrid(), m = {
      month: "long",
      year: "numeric"
    };
    let g = null;
    try {
      g = h.toLocaleDateString("en-US", m);
    } catch (y) {
      g = `${h.getMonth() + 1} / ${h.getFullYear()}`, console.warn("toLocaleDateString exception", y);
    }
    return /* @__PURE__ */ o.jsxs("div", { ...c, className: u, children: [
      /* @__PURE__ */ o.jsxs("div", { className: X.month, children: [
        /* @__PURE__ */ o.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ o.jsx(R, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        g,
        /* @__PURE__ */ o.jsx(
          "button",
          {
            className: X.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ o.jsx(R, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ o.jsxs("div", { className: X.dayNames, children: [
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Mon" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Tue" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Wed" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Thu" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Fri" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Sat" }),
        /* @__PURE__ */ o.jsx("p", { className: X.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ o.jsx("div", { className: X.grid, children: p.map((y) => /* @__PURE__ */ o.jsx("div", { className: X.gridItem, children: /* @__PURE__ */ o.jsx(
        bu,
        {
          onClick: (x) => this.handleDateClick(x, y.date),
          dim: !y.isThisMonth,
          active: y.selected,
          disabled: y.disabled,
          className: X.day,
          children: y.label
        }
      ) }, y.date.getTime())) }),
      n && /* @__PURE__ */ o.jsxs("div", { className: X.time, children: [
        /* @__PURE__ */ o.jsxs("div", { className: X.timeButtonContainerLeft, children: [
          /* @__PURE__ */ o.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ o.jsx(R, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ o.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ o.jsx(R, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ o.jsx("div", { className: X.timeDisplay, children: `${xo(
          d.getHours().toString(),
          2,
          "0"
        )}:${xo(d.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ o.jsxs("div", { className: X.timeButtonContainerRight, children: [
          /* @__PURE__ */ o.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ o.jsx(R, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ o.jsx(
            "button",
            {
              className: X.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ o.jsx(R, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
};
f(je, "defaultProps");
let Us = je;
Us.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Nu(i) {
  return Math.abs(i.diff(N())) < 25e3 ? "just now" : i.fromNow();
}
function qs(i) {
  return N(i, N.ISO_8601).isValid();
}
function Pe(i) {
  return !!N.tz.zone(i ?? "");
}
const Ft = "HH:mm", Jr = Tr(24), Zr = Tr(0, 60, 15), ta = (i) => N("1995-12-25").format(i);
function ea(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function na(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function sa({
  hour: i,
  minute: s,
  timeFormat: t
}) {
  const e = N({ hour: i, minute: s });
  return {
    id: e.format(Ft),
    name: e.format(t)
  };
}
function Fu(i, s) {
  return (s == null ? void 0 : s.map(({ hour: t, minute: e }) => (ea(t), na(e), sa({ hour: t, minute: e, timeFormat: i })))) || [];
}
function oa({
  hours: i,
  minutes: s,
  overrides: t,
  timeFormat: e
}) {
  return Ja(
    i.reduce(
      (n, r, a) => [
        ...n,
        ...s.map((l, c) => (c === 0 && ea(r), a === 0 && na(l), sa({ hour: r, minute: l, timeFormat: e })))
      ],
      []
    ).concat(Fu(e, t)),
    ["id"]
  );
}
const Pu = "h-datePicker--datePicker__root", Ru = "h-datePicker--datePicker__navigationButton", Lu = "h-datePicker--datePicker__nextMonthButton", Eu = "h-datePicker--datePicker__prevMonthButton", Te = {
  root: Pu,
  navigationButton: Ru,
  nextMonthButton: Lu,
  prevMonthButton: Eu
}, Jn = {
  previousMonth({ ariaLabel: i, ...s }) {
    const t = b(
      Te.navigationButton,
      Te.prevMonthButton
    );
    return /* @__PURE__ */ o.jsx("div", { className: t, children: /* @__PURE__ */ o.jsx(R, { ...s, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...s }) {
    const t = b(
      Te.navigationButton,
      Te.nextMonthButton
    );
    return /* @__PURE__ */ o.jsx("div", { className: t, children: /* @__PURE__ */ o.jsx(R, { ...s, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, ra = (i) => /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
  /* @__PURE__ */ o.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ o.jsx("span", { className: "day-complimentary-highlight" })
] }), aa = ({ month: i }) => /* @__PURE__ */ o.jsx("span", { children: i.format("MMMM YYYY") }), ia = (i) => {
  const { value: s, presets: t, onSelect: e } = i, n = L(
    (r) => {
      e(r.key === s ? null : r);
    },
    [e, s]
  );
  return /* @__PURE__ */ o.jsxs(Mt, { children: [
    /* @__PURE__ */ o.jsx(io, { orientation: "vertical" }),
    /* @__PURE__ */ o.jsx(vo, { children: t.map((r) => /* @__PURE__ */ o.jsx(
      vo.Item,
      {
        isSelected: r.key === s,
        onClick: () => n(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, $u = "h-fieldLabel--fieldLabel__root", Au = "h-fieldLabel--fieldLabel__label", Ou = "h-fieldLabel--fieldLabel__labelChildren", Bu = "h-fieldLabel--fieldLabel__rootRequired", Hu = "h-fieldLabel--fieldLabel__helpIcon", We = {
  root: $u,
  label: Au,
  labelChildren: Ou,
  rootRequired: Bu,
  helpIcon: Hu
}, Wu = "fieldLabel";
class uo extends k {
  render() {
    const { required: s, helpIcon: t, className: e, children: n, ...r } = this.props, a = b(We.root, e, {
      [We.rootRequired]: s
    });
    return /* @__PURE__ */ o.jsxs("div", { className: a, "data-testid": Wu, children: [
      /* @__PURE__ */ o.jsx("label", { className: We.label, ...r, children: /* @__PURE__ */ o.jsx("div", { className: We.labelChildren, children: n }) }),
      !!(t != null && t.text) && /* @__PURE__ */ o.jsx(
        ho,
        {
          ...t,
          className: b(We.helpIcon, t.className)
        }
      )
    ] });
  }
}
const Mu = "h-dropdownSelect--dropdownInfinite__item", zu = "h-dropdownSelect--dropdownInfinite__list", Vu = "h-dropdownSelect--dropdownInfinite__listEmpty", Ds = {
  item: Mu,
  list: zu,
  listEmpty: Vu
};
class Wo extends k {
  render() {
    const {
      item: s,
      itemComponent: t,
      tooltip: e,
      onSelect: n,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ o.jsx(
      t,
      {
        item: s,
        onSelect: n,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return e ? /* @__PURE__ */ o.jsx(yt, { ...e, children: m }, s.id) : m;
  }
}
const Ku = 6, Uu = 48;
class ds extends k {
  constructor(t) {
    super(t);
    f(this, "listRef");
    f(this, "infiniteListRef");
    /**
     * This attribute is supposed to be a React component. The FixedSizeList
     * component expects a component is a child.
     *
     * @see https://react-window.vercel.app/#/examples/list/fixed-size
     */
    f(this, "ListItem", ({
      index: t,
      style: e
    }) => {
      const { items: n, itemComponent: r, onSelect: a, onChange: l, clearSearch: c } = this.props, d = this.isItemLoaded(t), h = t === n.length - 1, u = d ? n[t] : { id: cn(), name: "Loading..." }, p = this.props.pagination ? this.props.pagination.nextEnable : !1;
      return /* @__PURE__ */ o.jsxs("div", { style: e, className: Ds.item, children: [
        /* @__PURE__ */ o.jsx(
          Wo,
          {
            id: this.getItemId(t),
            checked: this.isItemChecked(u),
            clearSearch: c,
            disabled: this.isItemDisabled(u),
            isLoading: !d,
            item: u,
            itemComponent: r,
            onChange: l,
            onSelect: a,
            tooltip: this.getTooltip(u),
            active: this.isItemActive(u)
          }
        ),
        h && p && d && /* @__PURE__ */ o.jsx(Za, { onEnter: this.loadMoreItems })
      ] });
    });
    f(this, "loadMoreItems", async () => {
      var t, e;
      this.props.pagination && await ((e = (t = this.props.pagination).onNext) == null ? void 0 : e.call(t));
    });
    this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = W(), this.infiniteListRef = W();
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return t === e || t.id === e;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return ((e == null ? void 0 : e.findIndex((r) => typeof r == "object" ? r.id === t.id : r === t.id)) ?? -1) > -1;
  }
  isItemDisabled(t) {
    var n;
    return t ? (((n = this.props.disabledItems) == null ? void 0 : n.indexOf(t.id)) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || oo(e == null ? void 0 : e[t.id]) ? null : (e == null ? void 0 : e[t.id]) ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: r,
      onChange: a,
      onKeyDown: l,
      clearSearch: c,
      itemsDisplayCount: d = Ku,
      itemHeight: h = Uu,
      id: u,
      ariaLabelledby: p
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ o.jsx(
        "div",
        {
          style: { maxHeight: `${d * h}px` },
          className: b({
            [Ds.list]: !0,
            [Ds.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: u,
          "aria-labelledby": p,
          children: t.map((_, w) => {
            const S = ti(_) ? _ : _.id.toString() || _.name.toString() || _.toString();
            return /* @__PURE__ */ o.jsx(
              Wo,
              {
                id: this.getItemId(w),
                checked: this.isItemChecked(_),
                clearSearch: c,
                disabled: this.isItemDisabled(_),
                item: _,
                itemComponent: n,
                onChange: a,
                onSelect: r,
                onKeyDown: l,
                tooltip: this.getTooltip(_),
                active: this.isItemActive(_)
              },
              S
            );
          })
        }
      );
    const { nextEnable: m, itemCount: g } = e, y = g || (m ? t.length + d : t.length), x = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, C = Math.min(
      y * h,
      d * h
    );
    return /* @__PURE__ */ o.jsx(ei, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: _ }) => /* @__PURE__ */ o.jsx(
      ni,
      {
        ...x,
        ref: this.infiniteListRef,
        width: _,
        height: C,
        itemCount: y,
        itemSize: h,
        "aria-labelledby": p,
        children: this.ListItem
      }
    ) });
  }
}
f(ds, "defaultProps", {
  selectedItems: [],
  disabledItems: [],
  tooltipItems: {},
  activeItem: null
});
const qu = "h-selectItems-checkableBaseItem--checkableBaseItem__root", Gu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Yu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", Qu = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Xu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", Me = {
  root: qu,
  rootActive: Gu,
  rootDisabled: Yu,
  checkbox: Qu,
  content: Xu
};
class po extends k {
  constructor(s) {
    super(s), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: s, item: t, checked: e } = this.props;
    typeof s == "function" && s(t, !e);
  }
  noop(s) {
    s.preventDefault();
  }
  render() {
    const {
      item: s,
      onChange: t,
      clearSearch: e,
      checked: n,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      ...d
    } = this.props, h = b(Me.root, {
      [Me.rootDisabled]: r,
      [Me.rootActive]: c
    }), u = r ? O : this.handleChange;
    return /* @__PURE__ */ o.jsxs("label", { ...d, className: h, children: [
      /* @__PURE__ */ o.jsx(
        bn,
        {
          id: s == null ? void 0 : s.id,
          name: "",
          className: Me.checkbox,
          checked: n,
          onChange: u
        }
      ),
      /* @__PURE__ */ o.jsx("div", { className: Me.content, children: l })
    ] });
  }
}
const Ju = "h-selectItems-emptySelectItem--emptySelectItem__root", Zu = "h-selectItems-emptySelectItem--emptySelectItem__name", Mo = {
  root: Ju,
  name: Zu
};
class xn extends k {
  render() {
    const { label: s, ...t } = this.props;
    return /* @__PURE__ */ o.jsx("div", { ...t, className: Mo.root, children: /* @__PURE__ */ o.jsx("div", { className: Mo.name, children: s }) });
  }
}
const tp = "h-selectItems-selectItem--selectItem__root", ep = "h-selectItems-selectItem--selectItem__rootActive", np = "h-selectItems-selectItem--selectItem__name", sp = "h-selectItems-selectItem--selectItem__nameBold", op = "h-selectItems-selectItem--selectItem__nameWithDescription", rp = "h-selectItems-selectItem--selectItem__description", ap = "h-selectItems-selectItem--selectItem__icon", se = {
  root: tp,
  rootActive: ep,
  name: np,
  nameBold: sp,
  nameWithDescription: op,
  description: rp,
  icon: ap
};
class mo extends xt {
  render() {
    const {
      item: s,
      onSelect: t,
      clearSearch: e,
      checked: n,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = s, m = b(se.root, {
      [se.rootActive]: a
    }), g = b(se.name, {
      [se.nameBold]: n,
      [se.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ o.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          t(s);
        },
        children: [
          u ? /* @__PURE__ */ o.jsx(R, { className: se.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ o.jsxs(M, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ o.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ o.jsx("span", { className: se.description, "data-testid": "description", children: d })
          ] }),
          n && /* @__PURE__ */ o.jsx(R, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
f(mo, "defaultProps", {
  checked: !1
});
const ip = "h-selectItems-checkableSelectItem--checkableSelectItem__name", lp = {
  name: ip
};
class zD extends k {
  render() {
    const { item: s, isLoading: t } = this.props, { name: e } = t ? { name: "Loading..." } : s;
    return /* @__PURE__ */ o.jsx(po, { ...this.props, children: /* @__PURE__ */ o.jsx("span", { className: lp.name, children: e }) });
  }
}
const cp = "h-selectItems-tagSelectItem--tagSelectItem__root", dp = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", hp = "h-selectItems-tagSelectItem--tagSelectItem__name", up = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", pp = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", mp = "h-selectItems-tagSelectItem--tagSelectItem__dot", fe = {
  root: cp,
  rootActive: dp,
  name: hp,
  nameBold: up,
  dotContainer: pp,
  dot: mp
};
class gp extends k {
  render() {
    const {
      item: s,
      onSelect: t,
      clearSearch: e,
      checked: n,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = s, u = b(fe.root, {
      [fe.rootActive]: l
    }), p = b(fe.name, {
      [fe.nameBold]: n
    });
    return /* @__PURE__ */ o.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          t(s), e();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ o.jsx("div", { className: fe.dotContainer, children: /* @__PURE__ */ o.jsx(
            "div",
            {
              className: fe.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ o.jsx("div", { className: p, children: d }),
          n && /* @__PURE__ */ o.jsx(R, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ o.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
f(gp, "defaultProps", {
  checked: !1
});
const fp = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", bp = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", yp = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", xp = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", kn = {
  name: fp,
  dotContainer: bp,
  dot: yp,
  nameContainer: xp
};
class VD extends k {
  constructor(s) {
    super(s), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: s, item: t, checked: e } = this.props;
    typeof s == "function" && s(t, !e);
  }
  render() {
    const { item: s, isLoading: t, disabled: e } = this.props, { name: n, color: r } = t ? { name: "Loading...", color: "#000" } : s;
    return /* @__PURE__ */ o.jsx(
      po,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : e,
        children: /* @__PURE__ */ o.jsxs("div", { className: kn.nameContainer, children: [
          r && /* @__PURE__ */ o.jsx("div", { className: kn.dotContainer, children: /* @__PURE__ */ o.jsx("div", { className: kn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ o.jsx("span", { className: kn.name, children: n }),
          e && /* @__PURE__ */ o.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const _p = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Cp = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", wp = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", vp = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", Sp = "h-selectItems-avatarSelectItem--avatarSelectItem__names", Ip = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", kp = "h-selectItems-avatarSelectItem--avatarSelectItem__container", Dp = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", qt = {
  root: _p,
  rootActive: Cp,
  secondaryName: wp,
  primaryName: vp,
  names: Sp,
  namesBold: Ip,
  container: kp,
  containerCheckable: Dp
};
class la extends k {
  getNames(s) {
    const t = /* @__PURE__ */ new Set();
    typeof s.name == "string" && t.add(s.name), typeof s.name != "string" && typeof s.display_name == "string" && t.add(s.display_name), typeof s.phone_number == "string" && t.add(s.phone_number), typeof s.email == "string" && t.add(s.email);
    const e = Array.from(t);
    return {
      primaryName: e.length > 0 ? e[0] : "No name",
      secondaryName: e.length > 1 ? e[1] : null
    };
  }
  getAvatar(s) {
    return typeof s.icon == "string" ? /* @__PURE__ */ o.jsx(R, { name: s.icon, size: 16 }) : /* @__PURE__ */ o.jsx(Vr, { user: s });
  }
  renderContent() {
    const s = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, t = this.getAvatar(s), e = this.getNames(s), n = b(qt.container, {
      [qt.containerCheckable]: this.props.checkable
    }), r = b(qt.names, {
      [qt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ o.jsxs("div", { className: n, children: [
      t,
      /* @__PURE__ */ o.jsxs("div", { className: r, children: [
        /* @__PURE__ */ o.jsx("div", { className: qt.primaryName, children: e.primaryName }),
        e.secondaryName !== null && /* @__PURE__ */ o.jsx("div", { className: qt.secondaryName, children: e.secondaryName })
      ] })
    ] });
  }
  render() {
    const s = this.renderContent(), { checkable: t, ...e } = this.props;
    if (t) {
      const m = e;
      return /* @__PURE__ */ o.jsx(po, { ...m, children: s });
    }
    const n = e, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = n, p = b(qt.root, {
      [qt.rootActive]: c
    });
    return /* @__PURE__ */ o.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          s,
          d && /* @__PURE__ */ o.jsx(R, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
f(la, "defaultProps", {
  checked: !1
});
class KD extends k {
  render() {
    return /* @__PURE__ */ o.jsx(la, { checkable: !0, ...this.props });
  }
}
const Tp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", jp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", Np = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Fp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", Dn = {
  root: Tp,
  rootActive: jp,
  suggestion: Np,
  icon: Fp
};
class Pp extends xt {
  constructor(s) {
    super(s), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(s) {
    const { searched: t, active: e } = this.props;
    t !== s.searched && this.searchItem(), e !== s.active && (e ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: s, searched: t, searchSuggestion: e } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const n = await (e == null ? void 0 : e(s, t));
        this.setState({ item: n });
      } catch (n) {
        console.error(n);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: s, onSuggest: t, clearSearch: e, triggerClose: n } = this.props;
    n == null || n(), t == null || t(s), e();
  }
  handleKeyDown(s) {
    this.props.active && s.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: s,
      triggerClose: t,
      onSuggest: e,
      searched: n,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!n || p || u)
      return null;
    const m = b(s, Dn.root, {
      [Dn.rootActive]: a
    });
    return /* @__PURE__ */ o.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ o.jsx("div", { className: Dn.suggestion, children: l == null ? void 0 : l(n) }),
          /* @__PURE__ */ o.jsx("div", { className: Dn.icon, children: /* @__PURE__ */ o.jsx(R, { name: "plus" }) })
        ]
      }
    );
  }
}
f(Pp, "defaultProps", {
  searchSuggestion: (s, t) => s.find((e) => e.name.toLowerCase() === t.toLowerCase()),
  renderSuggestion: (s) => `Add "${s}" tag`
});
const Rp = "h-selectItems-deselectItem--deselectItem__root", Lp = "h-selectItems-deselectItem--deselectItem__rootDisabled", Ep = "h-selectItems-deselectItem--deselectItem__name", $p = "h-selectItems-deselectItem--deselectItem__icon", Tn = {
  root: Rp,
  rootDisabled: Lp,
  name: Ep,
  icon: $p
};
class Ap extends k {
  render() {
    const { item: s, onSelect: t, clearSearch: e, disabled: n, ...r } = this.props, { name: a } = s, l = b(Tn.root, {
      [Tn.rootDisabled]: n
    });
    return /* @__PURE__ */ o.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ o.jsx("div", { className: Tn.name, children: a }),
      /* @__PURE__ */ o.jsx(
        "button",
        {
          className: Tn.icon,
          onClick: () => {
            t(s);
          },
          disabled: n,
          children: /* @__PURE__ */ o.jsx(R, { name: "close" })
        }
      )
    ] });
  }
}
const Op = "h-selectItems-tagDeselectItem--tagDeselectItem__root", Bp = "h-selectItems-tagDeselectItem--tagDeselectItem__name", Hp = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", Wp = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", Mp = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", ze = {
  root: Op,
  name: Bp,
  icon: Hp,
  dotContainer: Wp,
  dot: Mp
};
class UD extends k {
  render() {
    const { item: s, onSelect: t, clearSearch: e, disabled: n, isLoading: r, ...a } = this.props, { name: l, color: c } = s, d = b(ze.root);
    return /* @__PURE__ */ o.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ o.jsx("div", { className: ze.dotContainer, children: /* @__PURE__ */ o.jsx(
        "div",
        {
          className: ze.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ o.jsx("div", { className: ze.name, children: l }),
      n && /* @__PURE__ */ o.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ o.jsx(
        "button",
        {
          className: ze.icon,
          onClick: () => {
            t(s);
          },
          children: /* @__PURE__ */ o.jsx(R, { name: "close" })
        }
      )
    ] });
  }
}
const zp = "h-chip--chip__root", Vp = "h-chip--chip__rootLight", Kp = "h-chip--chip__rootNoBorder", Up = "h-chip--chip__rootDisabled", qp = "h-chip--chip__rootInteractable", Ve = {
  root: zp,
  rootLight: Vp,
  rootNoBorder: Kp,
  rootDisabled: Up,
  rootInteractable: qp
}, Gp = ({
  className: i,
  children: s,
  onClick: t,
  light: e,
  noBorder: n,
  disabled: r,
  ...a
}) => {
  const l = b(
    {
      [Ve.root]: !0,
      [Ve.rootLight]: e,
      [Ve.rootNoBorder]: n,
      [Ve.rootDisabled]: r,
      [Ve.rootInteractable]: typeof t == "function" && !r
    },
    i
  ), c = typeof t == "function" ? "button" : "div";
  return /* @__PURE__ */ o.jsx(lt, { ...a, as: c, className: l, onClick: t, children: s });
}, Yp = "h-tag--tag__tagName", Qp = "h-tag--tag__tagNameTruncated", Xp = "h-tag--tag__icon", Jp = "h-tag--tag__deleteButton", Zp = "h-tag--tag__deleteButtonDisabled", tm = "h-tag--tag__deleteIcon", be = {
  tagName: Yp,
  tagNameTruncated: Qp,
  icon: Xp,
  deleteButton: Jp,
  deleteButtonDisabled: Zp,
  deleteIcon: tm
}, Re = ({
  className: i,
  tagNameClassName: s,
  children: t,
  onDelete: e,
  color: n,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = b(
    {
      [be.tagName]: !0,
      [be.tagNameTruncated]: !l
    },
    s
  ), u = b(be.deleteButton, {
    [be.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ o.jsxs(
    Gp,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        n && /* @__PURE__ */ o.jsx(
          "span",
          {
            className: be.icon,
            style: { backgroundColor: an(n) ?? void 0 }
          }
        ),
        /* @__PURE__ */ o.jsx("span", { className: h, children: t }),
        !!e && !c && /* @__PURE__ */ o.jsx("button", { className: u, type: "button", onClick: e, children: /* @__PURE__ */ o.jsx(R, { name: "close", className: be.deleteIcon }) })
      ]
    }
  );
}, em = "h-select--select__root", nm = "h-select--select__rootDisabled", sm = "h-select--select__inputWrapper", om = "h-select--select__control", rm = "h-select--select__rootHasIcon", am = "h-select--select__selection", im = "h-select--select__selectionItem", lm = "h-select--select__tag", cm = "h-select--select__tagName", dm = "h-select--select__tagLimiter", hm = "h-select--select__text", um = "h-select--select__rootSearchable", pm = "h-select--select__rootDropdownOpen", mm = "h-select--select__rootIsSearching", gm = "h-select--select__search", fm = "h-select--select__rootSingle", bm = "h-select--select__indicators", ym = "h-select--select__spinner", xm = "h-select--select__clearIndicator", _m = "h-select--select__dropdownIndicator", Cm = "h-select--select__dropdown", wm = "h-select--select__dropdownFixed", vm = "h-select--select__pagination", Y = {
  root: em,
  rootDisabled: nm,
  inputWrapper: sm,
  control: om,
  rootHasIcon: rm,
  selection: am,
  selectionItem: im,
  tag: lm,
  tagName: cm,
  tagLimiter: dm,
  text: hm,
  rootSearchable: um,
  rootDropdownOpen: pm,
  rootIsSearching: mm,
  search: gm,
  rootSingle: fm,
  indicators: bm,
  spinner: ym,
  clearIndicator: xm,
  dropdownIndicator: _m,
  dropdown: Cm,
  dropdownFixed: wm,
  pagination: vm
}, Ne = class Ne extends k {
  constructor(t) {
    super(t);
    f(this, "controlRef");
    f(this, "searchRef");
    f(this, "listRef");
    this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = W(), this.searchRef = W(), this.listRef = W();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !Ne.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Ne.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    var r, a;
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if (window[n ? "addEventListener" : "removeEventListener"](
        "click",
        this.handleClickOutside
      ), n) {
        (r = this.searchRef.current) == null || r.focus();
        const l = this.initHighlightedIndex();
        this.highlightIndex(l, "auto");
      } else
        (a = this.searchRef.current) == null || a.blur();
    Nr(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && window.removeEventListener("click", this.handleClickOutside);
  }
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, r = `${t}-dropdown`, a = e !== null ? `${r}-option-${e}` : "";
    return { label: n, dropdown: r, option: a };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: r } = this.props;
    if (!e && !r && t.length) {
      const a = this.resolveItem(t[0]);
      return n.indexOf(a);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    var t;
    this.state.search && (this.setState({ search: "" }), (t = this.searchRef.current) == null || t.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      var r;
      e == null || e(n), n && (this.highlightIndex(0), (r = this.listRef.current) == null || r.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    var a, l;
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: r } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return r == null || r(!e), (a = this.controlRef.current) == null || a.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return r == null || r(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return r == null || r(!1), (l = this.controlRef.current) == null || l.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !(e != null && e.contains(n)) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      var a, l;
      if (t === null || t === -1) return;
      const r = (((l = (a = this.listRef.current) == null ? void 0 : a.listRef.current) == null ? void 0 : l.children) ?? [])[t];
      r == null || r.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: r, selectedItems: a } = this.state, { multiple: l, hideSelectedItems: c } = this.props, d = this.getAvailableItems(), h = t.key === "Escape", u = t.key === "Enter", p = t.key === "ArrowUp", m = t.key === "ArrowDown", g = t.key === "Backspace";
    if ((u || p || m) && t.preventDefault(), m && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (h && (n && t.stopPropagation(), this.handleDropdown("close")), g && l && !e) {
      const y = a[a.length - 1];
      y && this.handleRemove(y);
    }
    if (this.hasSuggestionComponent()) {
      if (m && (r === null || r === d.length - 1 || r === 0 && d.length === 0))
        return this.highlightIndex(-1);
      if (p && r === 0)
        return this.highlightIndex(-1);
    }
    if (m && r === null)
      return this.highlightIndex(0);
    if (r !== null) {
      if (m && r === d.length - 1)
        return this.highlightIndex(0);
      if (m)
        return this.highlightIndex(r + 1);
      if (p && r > 0)
        return this.highlightIndex(r - 1);
      if (p && r <= 0)
        return this.highlightIndex(d.length - 1);
      if (u) {
        const y = d[r], x = y && this.isItemDisabled(y);
        if (y && !x) {
          this.handleSelect(y);
          const C = Math.min(
            c ? r : r + 1,
            d.length - 2
          );
          this.highlightIndex(C);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: r } = this.props;
    if (e) {
      const a = this.isItemSelected(t);
      this.handleChange(t, !a);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), r == null || r(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: r } = this.state;
    this.setState({
      selectedItems: e ? [...r, t] : r.filter((a) => a.id !== t.id)
    }), this.resetSearch(), n == null || n(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e == null || e(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    var e, n;
    return this.state.search ? this.state.search.length : (e = this.state.selectedItems) != null && e.length ? 5 : ((n = this.props.placeholder) == null ? void 0 : n.length) || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: r, searchBy: a } = this.props, l = new RegExp(ro(t), "i");
    return e.filter((d) => {
      const h = [];
      return t && !r && (a && typeof a == "function" ? h.push(a(d, t)) : a && a instanceof Array ? h.push(
        a.some((u) => {
          const p = d[u];
          return (typeof p == "string" || typeof p == "number") && l.test(p.toString().trim());
        })
      ) : h.push(l.test(this.getItemName(d)))), n && h.push(!this.isItemSelected(d)), h.every((u) => u);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    var e;
    return (e = this.props.disabledItems) == null ? void 0 : e.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ o.jsx(M, { flexDirection: "column", children: e == null ? void 0 : e.slice(t).map((n) => /* @__PURE__ */ o.jsxs(
        M,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ o.jsx(lt, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ o.jsx(
              st,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (r) => this.handleRemove(n, r)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    var e, n;
    return ((n = (e = this.props).renderSelection) == null ? void 0 : n.call(e, t)) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, r = t == null ? void 0 : t.slice(0, e).map((a) => {
      const l = this.renderSelection(a);
      return /* @__PURE__ */ o.jsx(
        "div",
        {
          onClick: (c) => c.stopPropagation(),
          "data-testid": "select-selection",
          className: Y.selectionItem,
          children: /* @__PURE__ */ o.jsx(
            Re,
            {
              className: Y.tag,
              tagNameClassName: Y.tagName,
              onDelete: (c) => this.handleRemove(a, c),
              color: a.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: l
            }
          )
        },
        a.id
      );
    });
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      r,
      n && /* @__PURE__ */ o.jsx("div", { onClick: (a) => a.stopPropagation(), children: /* @__PURE__ */ o.jsx(
        yt,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ o.jsxs(
            Re,
            {
              className: b(Y.tag, Y.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], r = /* @__PURE__ */ o.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ o.jsx(
      "span",
      {
        className: Y.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : r;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ o.jsx(
      "input",
      {
        className: Y.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: r,
      tooltipItems: a,
      emptyComponent: l,
      suggestionComponent: c,
      emptyMessage: d,
      pagination: h,
      dropdownProps: u,
      searchSuggestion: p,
      renderSuggestion: m,
      onSuggest: g,
      multiple: y
    } = this.props, x = b(
      {
        [Y.dropdown]: !0,
        [Y.dropdownFixed]: (u == null ? void 0 : u.fixed) ?? !1
      },
      u == null ? void 0 : u.className
    ), C = this.getAvailableItems(), _ = C[e ?? -1] ?? null, w = !C.length;
    return /* @__PURE__ */ o.jsxs(
      zt,
      {
        onClick: this.handleDropdownClick,
        ...u,
        className: x,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          w && typeof l == "function" && /* @__PURE__ */ o.jsx(
            l,
            {
              label: d ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(c) && /* @__PURE__ */ o.jsx(
            c,
            {
              searched: n,
              onSuggest: g,
              triggerClose: y ? void 0 : () => this.handleDropdown("close"),
              items: C,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: p,
              renderSuggestion: m
            }
          ),
          !w && /* @__PURE__ */ o.jsx(
            ds,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: h,
              items: C,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: r,
              tooltipItems: a,
              activeItem: _,
              itemComponent: this.props.itemComponent
            }
          ),
          !!h && !h.infinite && /* @__PURE__ */ o.jsxs(
            "div",
            {
              className: Y.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ o.jsx(
                  tt,
                  {
                    variant: "secondary",
                    disabled: !h.previousEnable,
                    onClick: h.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ o.jsx(
                  tt,
                  {
                    variant: "secondary",
                    disabled: !h.nextEnable,
                    onClick: h.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: r,
      multiple: a,
      searchable: l,
      clearable: c,
      prefix: d,
      suffix: h,
      icon: u,
      status: p
    } = this.props, { search: m, dropdownOpen: g } = this.state, y = b(
      {
        [Y.root]: !0,
        [Y.rootSingle]: !a,
        [Y.rootDisabled]: e,
        [Y.rootSearchable]: l,
        [Y.rootDropdownOpen]: g,
        [Y.rootIsSearching]: !!m,
        [Y.rootHasIcon]: !!u
      },
      t
    ), x = m ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: y,
        role: "combobox",
        "aria-expanded": g,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ o.jsx(
            Et,
            {
              prefix: d,
              suffix: h,
              icon: u,
              status: p,
              active: g,
              disabled: e,
              className: Y.inputWrapper,
              children: /* @__PURE__ */ o.jsxs(
                "div",
                {
                  className: Y.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: x,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ o.jsxs("div", { className: Y.selection, children: [
                      a ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ o.jsxs("div", { className: Y.indicators, children: [
                      r && /* @__PURE__ */ o.jsx(
                        ao,
                        {
                          className: Y.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && c && /* @__PURE__ */ o.jsx(
                        st,
                        {
                          tabIndex: -1,
                          className: Y.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ o.jsx(
                        st,
                        {
                          tabIndex: -1,
                          className: Y.dropdownIndicator,
                          icon: g ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (C) => {
                            C.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": g ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && g && this.renderDropdown()
        ]
      }
    );
  }
};
f(Ne, "defaultProps", {
  id: jr("select"),
  selectedItems: [],
  disabledItems: [],
  itemComponent: mo,
  emptyComponent: xn,
  emptyMessage: "No options",
  placeholder: "",
  disabled: !1,
  loading: !1,
  multiple: !1,
  searchable: !1,
  clearable: !1,
  keepOpen: !1,
  hideSelectedItems: !1,
  hasDropDownIndicator: !0
}), f(Ne, "isSuggestionComponentWarningShown", !1);
let dn = Ne;
function Sm(i) {
  return /* @__PURE__ */ o.jsx(
    mn,
    {
      fallback: /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ o.jsx(dn, { ...i })
    }
  );
}
const Im = "h-datePicker-timezoneSelector--timezoneSelector__root", km = "h-datePicker-timezoneSelector--timezoneSelector__label", zo = {
  root: Im,
  label: km
}, ca = ({
  disabled: i,
  tooltipProps: s,
  selectedTimezone: t,
  onChange: e
}) => {
  const n = N.tz.guess(!0), r = L((h, u) => {
    const [p, m] = N.tz(h).format("Z").split(":"), [g, y] = N.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(y));
  }, []), a = (h) => `(GMT${N.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = G(() => {
    const h = N.tz.names().filter((m) => m !== n), u = {
      id: n,
      name: `Default ${a(n)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    e(h);
  };
  return /* @__PURE__ */ o.jsxs("div", { className: zo.root, children: [
    /* @__PURE__ */ o.jsx(uo, { className: zo.label, children: "Time zone" }),
    /* @__PURE__ */ o.jsx(yt, { ...s, side: "top", children: /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(
      Sm,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          Pe(t) ? t : n
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Dm = "h-fieldAlert--fieldAlert__root", Tm = "h-fieldAlert--fieldAlert__alert", jm = "h-fieldAlert--fieldAlert__icon", Ts = {
  root: Dm,
  alert: Tm,
  icon: jm
}, Nm = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Fm = {
  root: Nm
};
function Pm({
  className: i,
  variant: s = "tertiary",
  ...t
}) {
  return /* @__PURE__ */ o.jsx(
    tt,
    {
      ...t,
      variant: s,
      className: b(i, Fm.root)
    }
  );
}
const Rm = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function hs({
  children: i,
  className: s,
  ...t
}) {
  const e = t.variant || "title", n = b(Ts.root, s), [r, a] = U(!1), l = Rm[e], c = L(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ o.jsxs(B.Input, { ...t, variant: e, className: n, children: [
    !!l && /* @__PURE__ */ o.jsx(R, { className: Ts.icon, name: l }),
    /* @__PURE__ */ o.jsx("div", { className: Ts.alert, ref: c, children: r ? /* @__PURE__ */ o.jsx(yt, { content: i, children: i }) : i })
  ] });
}
hs.Button = Pm;
const jn = (i, s = 0) => {
  if (!i)
    return s;
  if (typeof i == "number")
    return i;
  const t = parseFloat(i);
  return isNaN(t) ? s : t;
}, Lm = "h-inputText-inputNumberArrows--inputNumberArrows__root", Em = "h-inputText-inputNumberArrows--inputNumberArrows__button", $m = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", Am = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", Om = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", ye = {
  root: Lm,
  button: Em,
  buttonUp: $m,
  buttonDown: Am,
  spacer: Om
}, Bm = 50, Vo = 300, Hm = "inputNumberArrowsTestId";
class Wm extends k {
  constructor(t) {
    super(t);
    f(this, "intervalId");
    f(this, "timeoutId");
    this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: r,
      inputRef: { current: a }
    } = this.props;
    if (!a)
      return 0;
    const l = jn(a.value), c = jn(e, 1), d = jn(n, Number.MIN_SAFE_INTEGER), h = jn(r, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(l - c, d) : Math.min(l + c, h);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Vo
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Vo
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      Bm
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    var d;
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const r = this.getNewValue(t), a = new Event("input", { bubbles: !0 }), l = Object.getPrototypeOf(e), c = (d = Object.getOwnPropertyDescriptor(
      l,
      "value"
    )) == null ? void 0 : d.set;
    c == null || c.call(e, r), e.dispatchEvent(a), e.focus();
  }
  render() {
    return /* @__PURE__ */ o.jsxs("div", { className: ye.root, "data-testid": Hm, children: [
      /* @__PURE__ */ o.jsx(
        "button",
        {
          className: b(ye.button, ye.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ o.jsx(R, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ o.jsx("span", { className: ye.spacer }),
      /* @__PURE__ */ o.jsx(
        "button",
        {
          className: b(ye.button, ye.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ o.jsx(R, { name: "angle-down" })
        }
      )
    ] });
  }
}
const Mm = "h-inputText--inputText__rootReadOnly", zm = "h-inputText--inputText__container", Vm = "h-inputText--inputText__rootHasIcon", Km = "h-inputText--inputText__rootTypeNumber", Um = "h-inputText--inputText__input", Ke = {
  rootReadOnly: Mm,
  container: zm,
  rootHasIcon: Vm,
  rootTypeNumber: Km,
  input: Um
}, qm = "inputText", us = z(function(s, t) {
  const e = Z(null);
  pn(t, () => e.current);
  const {
    className: n,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: y,
    hideNumberArrows: x = !1,
    active: C = !1,
    ..._
  } = s, w = b(n, {
    [Ke.rootTypeNumber]: l === "number",
    [Ke.rootHasIcon]: !!u,
    [Ke.rootReadOnly]: a
  });
  return /* @__PURE__ */ o.jsx(
    Et,
    {
      className: w,
      status: p,
      disabled: r,
      active: C,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ o.jsxs("div", { className: Ke.container, children: [
        /* @__PURE__ */ o.jsx(
          "input",
          {
            "data-testid": qm,
            dir: "auto",
            id: c,
            name: c,
            ref: e,
            ..._,
            min: m,
            max: g,
            step: y,
            type: l,
            disabled: r,
            readOnly: a,
            className: Ke.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ o.jsx(
          Wm,
          {
            min: m,
            max: g,
            step: y,
            inputRef: e,
            readOnly: a
          }
        )
      ] })
    }
  );
}), Gm = "hmm A", Ym = (i, s) => {
  const t = `${i}`.padStart(2, "0"), e = `${s}`.padStart(2, "0");
  return `${t}:${e}`;
}, Ko = (i, s) => {
  const t = i.hours(), e = i.minutes();
  return {
    id: Ym(t, e),
    name: i.format(s)
  };
}, hn = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: s = !1,
  timeOptions: t,
  overrides: e,
  selectedItems: n,
  selectableHours: r = Jr,
  selectableMinutes: a = Zr,
  timeFormat: l = N.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = n || [], [p, m] = U(
    () => typeof u == "object" ? u == null ? void 0 : u.id : u || null
  ), [g, y] = U(""), x = G(
    () => t || oa({
      hours: r,
      minutes: a,
      overrides: e,
      timeFormat: l
    }),
    [
      t,
      r,
      a,
      e,
      l
    ]
  ), C = G(() => {
    const S = N(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, Gm]
    );
    if (!S.isValid())
      return null;
    const T = S.hours(), D = S.minutes();
    if (!d || d(T, D))
      return Ko(S, l);
    const E = T <= 12, F = T + 12, P = d(F, D);
    return E && P ? Ko(N({ hours: F, minutes: D }), l) : null;
  }, [u, g]), _ = G(() => {
    if (!s)
      return x;
    const S = p ? x.filter(({ name: T }) => T !== (C == null ? void 0 : C.name)) : x.filter(
      ({ name: T }) => T.startsWith(g) && T !== (C == null ? void 0 : C.name)
    );
    if (!C)
      return S;
    const v = p !== C.id ? 0 : S.findIndex(
      (T) => N(T.id, [l]) > N(C.id, [l])
    );
    return S.splice(
      // If it's -1 then there was no later time, so add it to the end.
      v === -1 ? S.length : v,
      0,
      C
    ), S;
  }, [C, g, p, x]), w = L(
    (S) => {
      (S == null ? void 0 : S.id) !== (C == null ? void 0 : C.id) && y(""), c((S == null ? void 0 : S.id) || null), m((S == null ? void 0 : S.id) || null);
    },
    [C]
  );
  return at(() => {
    u ? (y(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ o.jsx(
    dn,
    {
      searchable: !0,
      placeholder: ta(l),
      ...h,
      selectedItems: n,
      hasDropDownIndicator: i,
      items: s ? _ : x,
      onChange: O,
      onClear: w,
      onSelect: w,
      ...s && { onSearch: y }
    }
  );
}, Qm = "h-timePicker-range--timeRangePicker__root", Xm = "h-timePicker-range--timeRangePicker__timePickerFrom", Jm = "h-timePicker-range--timeRangePicker__timePickerTo", Zm = "h-timePicker-range--timeRangePicker__arrowContainer", tg = "h-timePicker-range--timeRangePicker__arrowContainerHasError", eg = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", ng = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", oe = {
  root: Qm,
  timePickerFrom: Xm,
  timePickerTo: Jm,
  arrowContainer: Zm,
  arrowContainerHasError: tg,
  arrowContainerHasWarning: eg,
  arrowContainerHasSuccess: ng
}, sg = ({
  className: i,
  disabled: s,
  endTime: t,
  onSelect: e,
  overrides: n,
  placeholder: r,
  selectableHours: a = Jr,
  selectableMinutes: l = Zr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = N.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, y] = U({
    startTime: d || null,
    endTime: t || null
  }), x = G(
    () => oa({
      hours: a,
      minutes: l,
      overrides: n,
      timeFormat: u
    }),
    [a, l, n, u]
  ), C = G(() => {
    const v = x.map(
      ({ id: E }) => N(E, [u])
    ), T = N(m, [u]), D = m && v.findIndex(
      (E) => E > T
    ) || 0;
    return x.slice(D);
  }, [x, m, u]);
  at(() => {
    const v = typeof d == "string", T = typeof d == "string";
    (v && d !== m || T && t !== g) && y((D) => ({
      ...D,
      ...v && { startTime: d },
      ...T && { endTime: t }
    }));
  });
  const _ = L(
    (v) => (T) => void y((D) => {
      var J;
      const E = N(T, [u]), F = N(D.startTime, [u]), P = N(D.endTime, [u]), I = x.map(
        ({ id: $ }) => N($, [u])
      ), j = I.findIndex(
        ($) => $ >= E
      ) || -1, A = v === "startTime" ? j : I.findIndex(
        ($) => $ >= F
      ), K = v === "endTime" ? -1 : I.findIndex(
        ($) => $ >= P
      ), rt = {
        ...D,
        [v]: T,
        ...D.endTime !== null && v !== "endTime" && A >= K && {
          endTime: ((J = x[j + 1]) == null ? void 0 : J.id) || null
        }
      };
      return e(rt), rt;
    }),
    [e]
  ), w = L(
    (v, T) => {
      const D = N(m, [u]);
      if (!D.isValid())
        return !0;
      const F = D.hours(), P = D.minutes();
      return F < v || F === v && P < T;
    },
    [m, u]
  ), S = (v) => (r == null ? void 0 : r[v]) || r || ta(u);
  return /* @__PURE__ */ o.jsxs(lt, { className: b(oe.root, i), children: [
    /* @__PURE__ */ o.jsx(
      hn,
      {
        className: oe.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: s,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: _("startTime"),
        placeholder: S("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ o.jsx(
      lt,
      {
        className: b(oe.arrowContainer, {
          [oe.arrowContainerHasError]: c === "error",
          [oe.arrowContainerHasWarning]: c === "warning",
          [oe.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ o.jsx(R, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ o.jsx(
      hn,
      {
        className: oe.timePickerTo,
        searchable: !0,
        disabled: s || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: C,
        onSelect: _("endTime"),
        placeholder: S("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: w
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
}, Xt = class Xt {
  constructor(s, t, e) {
    this.dateFormat = s, this.dateParser = t, this.dateRangeConstraint = e, this.dateFormat = s, this.dateParser = t, this.dateRangeConstraint = e;
  }
  isValidDate(s) {
    try {
      return this.dateParser(s).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(s) {
    if (!this.isValidDate(s))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: t, maxDate: e } = this.dateRangeConstraint, n = this.dateParser(s);
    return n.isBefore(t, "day") ? {
      isValid: !1,
      error: `Date must be after ${t.format(this.dateFormat)}`
    } : n.isAfter(e, "day") ? {
      isValid: !1,
      error: `Date must be before ${e.format(this.dateFormat)}`
    } : Xt.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: s,
    endDateInputValue: t
  }) {
    const { minDate: e, maxDate: n } = this.dateRangeConstraint;
    if (!this.isValidDate(s))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(s), a = this.dateParser(t);
    return r.isBefore(e, "day") ? {
      isValid: !1,
      error: `From date must be after ${e.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(n, "day") ? {
      isValid: !1,
      error: `From date must be before ${n.format(this.dateFormat)}`
    } : Xt.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: s,
    endDateInputValue: t
  }) {
    const { minDate: e, maxDate: n } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(s), a = this.dateParser(t);
    return a.isAfter(n, "day") ? {
      isValid: !1,
      error: `To date must be before ${n.format(this.dateFormat)}`
    } : s && this.isValidDate(s) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(e, "day") ? {
      isValid: !1,
      error: `To date must be after ${e.format(this.dateFormat)}`
    } : Xt.validationOK;
  }
  isTimeOrderValid({
    startDate: s,
    endDate: t
  }) {
    return !s || !t ? Xt.validationOK : s.isAfter(t) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Xt.validationOK;
  }
};
f(Xt, "validationOK", { isValid: !0, error: null });
let Zn = Xt;
const og = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", rg = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", ag = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", ig = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", lg = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", cg = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", dg = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Gt = {
  root: og,
  rootPlacementTop: rg,
  rootPlacementTopWithTimezoneSelector: ag,
  rootPlacementBottom: ig,
  fields: lg,
  input: cg,
  alert: dg
};
Array(24).fill(0).map((i, s) => s);
const ss = class ss extends k {
  constructor(t) {
    var n, r;
    super(t);
    f(this, "dateRangeValidators");
    f(this, "timeOptions");
    f(this, "instanceId");
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: ((n = this.props.startDate) == null ? void 0 : n.format(e)) ?? "",
      startDateError: null,
      endDateInputValue: ((r = this.props.endDate) == null ? void 0 : r.format(e)) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = ss.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Zn(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: r } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: r
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e != null && e.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e != null && e.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: r } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: r });
      return;
    }
    const { isValid: a, error: l } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), c = e !== "" && !a ? l : null;
    this.setState(
      {
        startDateError: null,
        endDateError: c
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: r } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: r });
      return;
    }
    const { isValid: a, error: l } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), c = t !== "" && !a ? l : null;
    this.setState(
      {
        endDateError: null,
        startDateError: c
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return N(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, r, a, l, c) {
    const {
      dateFormat: d,
      disabled: h,
      focusedInput: u,
      onFocusChange: p,
      onTimeChange: m,
      timeFormat: g,
      withTimePicker: y,
      withDateInput: x
    } = this.props, { timeOrderError: C } = this.state;
    return /* @__PURE__ */ o.jsxs("div", { children: [
      /* @__PURE__ */ o.jsx(uo, { children: t === "startDate" ? "From" : "To" }),
      x && /* @__PURE__ */ o.jsx(
        us,
        {
          className: Gt.input,
          placeholder: d.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: a,
          onChange: (_) => this.handleInputValueChange(_, t),
          onFocus: () => p(t),
          autoComplete: "off",
          status: l ? "error" : void 0,
          disabled: h,
          active: u === t
        }
      ),
      y && /* @__PURE__ */ o.jsx("div", { className: Gt.input, children: /* @__PURE__ */ o.jsx(
        yt,
        {
          content: "Please select a date first.",
          disabled: !!n || h,
          side: "right",
          children: /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(
            hn,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: r ? [r] : void 0,
              status: C ? "error" : void 0,
              ...c,
              timeFormat: g,
              onSelect: (_) => m(e, _)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ o.jsx(
      hs,
      {
        className: Gt.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: r,
      timePickerProps: a = { start: {}, end: {} },
      hasTimezoneSelector: l
    } = this.props, {
      startDateInputValue: c,
      startDateError: d,
      endDateInputValue: h,
      endDateError: u
    } = this.state, { placement: p } = this.props, m = b(Gt.root, {
      [Gt.rootPlacementTop]: p === "top",
      [Gt.rootPlacementTopWithTimezoneSelector]: p === "top" && l,
      [Gt.rootPlacementBottom]: p === "bottom"
    });
    return /* @__PURE__ */ o.jsxs("div", { className: m, children: [
      /* @__PURE__ */ o.jsxs("div", { className: Gt.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          c,
          d,
          a.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          r,
          h,
          u,
          a.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
};
f(ss, "instanceCount", 0);
let Gs = ss;
const hg = "dateRangePickerTestId";
class da extends k {
  constructor(t) {
    var d;
    super(t);
    f(this, "visibleCalendarMonthRef", W());
    const {
      startDate: e,
      endDate: n,
      timezone: r,
      presetKey: a,
      presets: l,
      focusedInput: c = "startDate"
    } = t;
    this.state = {
      startTime: e ? N(e).format(Ft) : null,
      endTime: n ? N(n).format(Ft) : null,
      timezone: Pe(r) ? r : N.tz.guess(!0),
      presetKey: ((d = l == null ? void 0 : l.find(({ key: h }) => h === a)) == null ? void 0 : d.key) ?? null,
      focusedInput: c,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  updatePresetKey(t) {
    var n, r;
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: ((r = (n = this.props.presets) == null ? void 0 : n.find(({ key: a }) => a === e)) == null ? void 0 : r.key) ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && Pe(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? N(e, n) : N("0001-01-01"),
      maxDate: t ? N(t, n) : N("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: r } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, r)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    var g, y, x, C;
    const { startTime: n, endTime: r, timezone: a } = this.state, { timeRoundingStrategy: l } = this.props, c = this.addTimezoneToDate(
      t.startDate,
      a
    ), d = this.addTimezoneToDate(
      t.endDate,
      a
    );
    let h = (c == null ? void 0 : c.clone().startOf(l)) || null, u = (d == null ? void 0 : d.clone().endOf(l)) || null, p = ((g = t.startDate) == null ? void 0 : g.clone().startOf(l)) || null, m = ((y = t.endDate) == null ? void 0 : y.clone().endOf(l)) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: ((x = t.startDate) == null ? void 0 : x.clone().startOf(l).format(Ft)) ?? null,
          endTime: ((C = t.endDate) == null ? void 0 : C.clone().startOf(l).format(Ft)) ?? null
        },
        () => {
          this.props.onChange({
            startDate: h,
            localStartDate: p,
            endDate: u,
            localEndDate: m,
            timezone: a,
            localTimezone: N.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (h = this.addTimeToDate(
      c,
      n,
      "startDate"
    ), p = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), r && (u = this.addTimeToDate(d, r, "endDate"), m = this.addTimeToDate(t.endDate, r, "endDate")), this.props.onChange({
      startDate: h,
      localStartDate: p,
      endDate: u,
      localEndDate: m,
      timezone: a,
      localTimezone: N.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: r } = t;
      this.onDatesChange({ startDate: e, endDate: n }, r);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: r } = this.props;
    this.setState(
      (a) => ({
        ...a,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: r })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Pe(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: r } = this.props, [a, l] = e.split(":");
    return !a || !l ? n === "startDate" ? t.clone().startOf(r) : t.clone().endOf(r) : t.clone().set({
      hours: parseInt(a, 10),
      minutes: parseInt(l, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(n, r, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: r } = this.props;
    n != null && n.isSame(t) || this.setState({
      startTime: n ? N(n).format(Ft) : null
    }), r != null && r.isSame(e) || this.setState({
      endTime: r ? N(r).format(Ft) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    var a;
    const { startDate: n, endDate: r } = this.props;
    if (e && t && !n && !r)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!r && !e) && !(!r && e)) {
      if (r && !e) {
        const l = (a = this.visibleCalendarMonthRef.current) == null ? void 0 : a.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && r.isSame(l, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (r && e) {
        if (r.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || N.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: r,
      timezoneSelectorProps: a
    } = this.props, { timezone: l } = this.state;
    if (!r)
      return null;
    const c = !!t || !!e, d = !c && !n, h = !c || n || (a == null ? void 0 : a.disabled);
    return /* @__PURE__ */ o.jsx(
      ca,
      {
        disabled: h,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !d,
          ...a == null ? void 0 : a.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: l
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: r,
      timePickerProps: a,
      disabled: l,
      startDate: c,
      endDate: d,
      selectableMinutes: h,
      selectableHours: u,
      inputsPlacement: p,
      timeFormat: m,
      timeRoundingStrategy: g
    } = this.props;
    if (p !== t || !e && !n)
      return null;
    const { startTime: y, endTime: x, focusedInput: C } = this.state, { minDate: _, maxDate: w } = this.getDateConstraints();
    return /* @__PURE__ */ o.jsx(
      Gs,
      {
        dateFormat: this.dateFormat,
        timeFormat: m,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: c,
        endDate: d,
        startTime: y,
        endTime: x,
        minDate: _,
        maxDate: w,
        disabled: l,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: r,
        timePickerProps: a,
        selectableMinutes: h,
        selectableHours: u,
        placement: t,
        timeRoundingStrategy: g,
        focusedInput: C
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t != null && t.length ? /* @__PURE__ */ o.jsx(
      ia,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: r, endDate: a } = this.props, l = n ? () => /* @__PURE__ */ o.jsx("span", {}) : Jn.previousMonth, c = n ? () => /* @__PURE__ */ o.jsx("span", {}) : Jn.nextMonth;
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": hg,
        className: b(Te.root, t),
        children: [
          /* @__PURE__ */ o.jsxs(M, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ o.jsx(
              Fr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: r,
                endDate: a,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: ra,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: l,
                renderNavNextButton: c,
                renderMonthElement: aa,
                initialVisibleMonth: () => r || a || N(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
f(da, "defaultProps", {
  withDateInput: !0,
  withTimePicker: !1,
  timePickerProps: { start: {}, end: {} },
  inputsPlacement: "bottom",
  timeRoundingStrategy: "day"
});
const ug = "h-datePicker-single-inputFields--datePickerInputFields__root", pg = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", mg = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", gg = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", fg = "h-datePicker-single-inputFields--datePickerInputFields__input", bg = "h-datePicker-single-inputFields--datePickerInputFields__alert", re = {
  root: ug,
  rootPlacementTop: pg,
  rootPlacementTopWithTimezoneSelector: mg,
  rootPlacementBottom: gg,
  input: fg,
  alert: bg
}, os = class os extends k {
  constructor(t) {
    var n;
    super(t);
    f(this, "dateValidators");
    f(this, "instanceId");
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: ((n = this.props.date) == null ? void 0 : n.format(e)) ?? "",
      dateError: null
    }, this.instanceId = os.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Zn(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, r = N(e);
    if (!(e === t.date || r != null && r.isSame(N(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: r.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return N(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: r, dateError: a } = this.state;
    return n ? /* @__PURE__ */ o.jsx(
      us,
      {
        className: re.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: r,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: a ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: r = {},
      disabled: a,
      onTimeChange: l,
      timeFormat: c
    } = this.props;
    if (!n)
      return null;
    const d = !t && !a, h = !t || a;
    return /* @__PURE__ */ o.jsx(
      yt,
      {
        content: "Please select a date first.",
        disabled: !d,
        side: "right",
        children: /* @__PURE__ */ o.jsx("div", { className: re.input, children: /* @__PURE__ */ o.jsx(
          hn,
          {
            disabled: h,
            onSelect: l,
            selectedItems: e ? [e] : void 0,
            ...r,
            timeFormat: c
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ o.jsx(
      hs,
      {
        className: re.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = b(re.root, {
      [re.rootPlacementTop]: e === "top",
      [re.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [re.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ o.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
};
f(os, "instanceCount", 0);
let Ys = os;
const yg = "datePickerTestId";
class ha extends k {
  constructor(t) {
    var l;
    super(t);
    f(this, "visibleCalendarMonthRef", W());
    const { date: e, timezone: n, presets: r, presetKey: a } = t;
    this.state = {
      time: e ? N(e).format(Ft) : null,
      timezone: Pe(n) ? n : N.tz.guess(!0),
      presetKey: ((l = r == null ? void 0 : r.find(({ key: c }) => c === a)) == null ? void 0 : l.key) ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || N("0001-01-01"),
      maxDate: t || N("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(t, r);
    let c = (l == null ? void 0 : l.clone().startOf(a)) || null, d = (t == null ? void 0 : t.clone().startOf(a)) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: (t == null ? void 0 : t.clone().startOf(a).format(Ft)) ?? null
        },
        () => {
          this.props.onChange({
            date: c,
            localDate: d,
            timezone: r,
            localTimezone: N.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (c = this.addTimeToDate(l, n), d = this.addTimeToDate(t, n)), this.props.onChange({
      date: c,
      localDate: d,
      timezone: r,
      localTimezone: N.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Pe(e) ? N(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [r, a] = e.split(":");
    return !r || !a ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: r, maxDate: a } = this.getDateConstraints();
    return !t.isBetween(r, a, n);
  }
  updateTimeOnDateChange(t) {
    var n;
    const { date: e } = this.props;
    (n = t.date) != null && n.isSame(e) || this.setState({
      time: e ? N(e).format(Ft) : null
    });
  }
  recalculateDatePickerKey() {
    var n;
    const { date: t } = this.props, e = (n = this.visibleCalendarMonthRef.current) == null ? void 0 : n.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: r } = this.props, { timezone: a } = this.state;
    if (!n)
      return null;
    const l = !!t, c = !l && !e, d = !l || e || (r == null ? void 0 : r.disabled);
    return /* @__PURE__ */ o.jsx(
      ca,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r == null ? void 0 : r.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a,
        ...r
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: r,
      withTimePicker: a,
      withTimezoneSelector: l,
      timePickerProps: c,
      selectableMinutes: d,
      selectableHours: h,
      disabled: u,
      date: p,
      inputsPlacement: m,
      timeRoundingStrategy: g
    } = this.props;
    if (m !== t || !r && !a)
      return null;
    const { time: y } = this.state, { minDate: x, maxDate: C } = this.getDateConstraints();
    return /* @__PURE__ */ o.jsx(
      Ys,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: y,
        date: p,
        minDate: x,
        maxDate: C,
        disabled: u,
        withDateInput: r,
        withTimePicker: a,
        hasTimezoneSelector: l,
        timePickerProps: c,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: g
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t != null && t.length ? /* @__PURE__ */ o.jsx(
      ia,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: r } = this.props, { datePickerKey: a } = this.state, l = n ? () => /* @__PURE__ */ o.jsx("span", {}) : Jn.previousMonth, c = n ? () => /* @__PURE__ */ o.jsx("span", {}) : Jn.nextMonth;
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": yg,
        className: b(Te.root, t),
        children: [
          /* @__PURE__ */ o.jsxs(M, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ o.jsx(
              Fr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: r,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: ra,
                daySize: 32,
                renderNavPrevButton: l,
                renderNavNextButton: c,
                renderMonthElement: aa,
                initialVisibleMonth: () => r || N(),
                onFocusChange: O,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              a
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
f(ha, "defaultProps", {
  dateFormat: N.localeData().longDateFormat("L"),
  withDateInput: !1,
  withTimePicker: !1,
  timePickerProps: {},
  inputsPlacement: "bottom",
  timeRoundingStrategy: "day"
});
const xg = "h-dialer--dialer__dialer", _g = "h-dialer--dialer__number", Cg = "h-dialer--dialer__letters", wg = "h-dialer--dialer__asterisk", Kn = {
  dialer: xg,
  number: _g,
  letters: Cg,
  asterisk: wg
}, vg = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Kn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class qD extends k {
  render() {
    const { className: s, onInput: t, ...e } = this.props, n = b(Kn.dialer, s);
    return /* @__PURE__ */ o.jsx("div", { ...e, className: n, children: vg.map((r) => /* @__PURE__ */ hi(
      "div",
      {
        className: b(Kn.number),
        ...as(() => t(r.value)),
        key: r.value
      },
      /* @__PURE__ */ o.jsx(B.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ o.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ o.jsx("span", { className: Kn.letters, children: r.letters }) })
    )) });
  }
}
const Sg = "h-fieldWrapper--fieldWrapper__root", Ig = "h-fieldWrapper--fieldWrapper__rootDisabled", kg = "h-fieldWrapper--fieldWrapper__label", Dg = "h-fieldWrapper--fieldWrapper__alert", Nn = {
  root: Sg,
  rootDisabled: Ig,
  label: kg,
  alert: Dg
}, Tg = "fieldWrapper";
class V extends k {
  static hasStatus(s, t) {
    return s != null && s[t] ? (s == null ? void 0 : s.touched) === void 0 || s.touched === !0 : !1;
  }
  static getStatusMessage(s, t) {
    if (this.hasStatus(s, t))
      return s == null ? void 0 : s[t];
  }
  static getStatus(s) {
    return V.hasStatus(s, "error") ? "error" : V.hasStatus(s, "warning") ? "warning" : V.hasStatus(s, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: s, description: t } = this.props;
    let e = t, n;
    return V.hasStatus(s, "error") ? (e = V.getStatusMessage(s, "error"), n = "error") : V.hasStatus(s, "warning") ? (e = V.getStatusMessage(s, "warning"), n = "warning") : V.hasStatus(s, "success") && (e = V.getStatusMessage(s, "success"), n = "success"), /* @__PURE__ */ o.jsx(hs, { variant: n, className: Nn.alert, children: e });
  }
  render() {
    const {
      className: s,
      labelFor: t,
      label: e,
      meta: n,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = b(
      Nn.root,
      {
        [Nn.rootDisabled]: a
      },
      s
    );
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": Tg,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ o.jsx(
            uo,
            {
              required: r,
              htmlFor: t,
              helpIcon: l,
              className: Nn.label,
              children: e
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Qs extends k {
  render() {
    const {
      className: s,
      input: t,
      label: e,
      meta: n,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: e,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ o.jsx(
          us,
          {
            status: V.getStatus(n),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const jg = "h-dropdownSelect--dropdownSelectContainer__search", Ng = "h-dropdownSelect--dropdownSelectContainer__pagination", Fg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", Pg = "h-dropdownSelect--dropdownSelectContainer__extra", Fn = {
  search: jg,
  pagination: Ng,
  selectionActions: Fg,
  extra: Pg
}, Rg = "DROP_SEARCH_INPUT";
class ua extends xt {
  constructor(t) {
    super(t);
    f(this, "listRef");
    f(this, "searchRef");
    f(this, "clearSearch", () => {
      const { onSearch: t } = this.props, { searchValue: e } = this.state;
      e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
    });
    this.state = {
      searchValue: ""
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = W(), this.searchRef = W();
  }
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, r = { ...e };
    return n || (r.searchValue = ""), r;
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: Rg,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { keyCode: e } = t, { searchValue: n } = this.state, { triggerClose: r } = this.props;
    e === 27 && n === "" ? r() : e === 27 ? this.clearSearch() : e === 13 && t.preventDefault();
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: r } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof r == "function" && r();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: r, triggerClose: a } = this.props;
    typeof n == "function" && n(t, e), r && this.focusSearch(), !r && typeof a == "function" && a();
  }
  onOpen() {
    this.focusSearch();
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: r,
      optionComponent: a,
      items: l,
      hasSearch: c,
      searchPlaceholder: d,
      pagination: h,
      keepOpen: u,
      onSelect: p,
      onSearch: m,
      onSuggest: g,
      onChange: y,
      onClear: x,
      onClearText: C,
      triggerClose: _,
      dropdownOpen: w,
      emptyMessage: S,
      selectedItems: v,
      disabledItems: T,
      tooltipItems: D,
      activeItem: E,
      itemsDisplayCount: F,
      itemHeight: P,
      renderSuggestion: I,
      searchSuggestion: j,
      ...A
    } = this.props;
    if (!w)
      return null;
    const { searchValue: K } = this.state, rt = l.length === 0, J = b(t);
    return /* @__PURE__ */ o.jsxs("div", { ...A, className: J, children: [
      c && /* @__PURE__ */ o.jsx("div", { className: Fn.search, ref: this.searchRef, children: /* @__PURE__ */ o.jsx(
        Qs,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: d
        }
      ) }),
      !!(c && r || a) && /* @__PURE__ */ o.jsxs("div", { className: Fn.extra, children: [
        a,
        c && typeof r == "function" && /* @__PURE__ */ o.jsx(
          r,
          {
            searched: K,
            onSuggest: g,
            triggerClose: u ? void 0 : _,
            clearSearch: this.clearSearch,
            items: l,
            searchSuggestion: j,
            renderSuggestion: I
          }
        )
      ] }),
      /* @__PURE__ */ o.jsxs("div", { children: [
        !rt && /* @__PURE__ */ o.jsx(
          ds,
          {
            ref: this.listRef,
            pagination: h,
            items: l,
            onSelect: this.onSelect,
            onChange: this.onChange,
            clearSearch: this.clearSearch,
            selectedItems: v,
            disabledItems: T,
            itemComponent: e,
            tooltipItems: D,
            itemsDisplayCount: F,
            itemHeight: P,
            activeItem: E
          }
        ),
        rt && typeof n == "function" && /* @__PURE__ */ o.jsx(n, { label: S || "" })
      ] }),
      typeof x == "function" && /* @__PURE__ */ o.jsx("div", { className: Fn.selectionActions, children: /* @__PURE__ */ o.jsx(
        tt,
        {
          variant: "secondary",
          disabled: (v == null ? void 0 : v.length) === 0,
          onClick: x,
          children: C || "Clear"
        }
      ) }),
      !!h && !h.infinite && /* @__PURE__ */ o.jsxs("div", { className: Fn.pagination, children: [
        /* @__PURE__ */ o.jsx(
          tt,
          {
            variant: "secondary",
            disabled: !h.previousEnable,
            onClick: h.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ o.jsx(
          tt,
          {
            variant: "secondary",
            disabled: !h.nextEnable,
            onClick: h.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class ps extends k {
  render() {
    const {
      className: s,
      items: t,
      onSelect: e,
      onChange: n,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: y,
      buttonProps: x,
      dropdownProps: C,
      containerProps: _,
      pagination: w,
      emptyComponent: S,
      emptyMessage: v,
      selectedItems: T,
      disabledItems: D,
      tooltipItems: E,
      activeItem: F,
      itemsDisplayCount: P,
      itemHeight: I,
      optionComponent: j,
      renderSuggestion: A,
      searchSuggestion: K,
      ...rt
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      ee,
      {
        ...rt,
        className: s,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: C,
        dropdown: /* @__PURE__ */ o.jsx(yn.Consumer, { children: ({ toggleDropdown: J, dropdownOpen: $ }) => /* @__PURE__ */ o.jsx(
          ua,
          {
            ..._,
            items: t,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: e,
            onChange: n,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: J,
            dropdownOpen: $,
            pagination: w,
            emptyComponent: S,
            emptyMessage: v,
            selectedItems: T,
            disabledItems: D,
            tooltipItems: E,
            activeItem: F,
            itemsDisplayCount: P,
            itemHeight: I,
            optionComponent: j,
            renderSuggestion: A,
            searchSuggestion: K
          }
        ) }),
        children: y
      }
    );
  }
}
f(ps, "defaultProps", {
  className: "",
  buttonProps: {},
  dropdownProps: {},
  containerProps: {},
  noArrow: !0,
  hasSearch: !1,
  searchPlaceholder: "Search...",
  pagination: !1,
  keepOpen: !1,
  onSearch: () => {
  },
  onSuggest: () => {
  },
  onChange: () => {
  },
  onSelect: () => {
  },
  onToggle: () => {
  },
  onKeyDown: () => {
  },
  emptyComponent: xn,
  emptyMessage: "No items found",
  selectedItems: [],
  disabledItems: [],
  tooltipItems: {},
  activeItem: null
});
const Lg = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", Eg = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", $g = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", js = {
  items: Lg,
  moreItemsDropdown: Eg,
  tagName: $g
};
class pa extends xt {
  getItems() {
    const { items: s } = this.props;
    return s;
  }
  render() {
    const {
      items: s,
      itemComponent: t,
      onSelect: e,
      onChange: n,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: y,
      selectedItems: x,
      optionComponent: C,
      ..._
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      ps,
      {
        ..._,
        containerProps: g,
        items: this.getItems(),
        itemComponent: t,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: e,
        onChange: n,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: C,
        children: y
      }
    );
  }
}
f(pa, "defaultProps", {
  noArrow: !0,
  hasSearch: !1,
  searchPlaceholder: "Search...",
  keepOpen: !1,
  onSearch: () => {
  },
  onSuggest: () => {
  },
  onChange: () => {
  },
  onSelect: () => {
  },
  emptyComponent: xn,
  emptyMessage: "No items found",
  buttonText: "+Select item",
  selectedItems: []
});
class Ag extends xt {
  constructor(s) {
    super(s), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(s) {
    if (typeof s == "object")
      return s;
    const t = this.props.items.find((e) => e.id === s);
    return t || { id: jr(), name: "Unknown" };
  }
  getItemName(s) {
    return s.name.toString().trim();
  }
  isItemDisabled(s) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(s.id) >= 0 : !1;
  }
  getTooltip(s) {
    const { tooltipItems: t } = this.props;
    return !t || oo(t[s.id]) ? null : t[s.id];
  }
  getListItem(s, t) {
    const { onRemove: e } = this.props, n = this.resolveItem(s), r = this.getItemName(n), a = this.getTooltip(n), l = /* @__PURE__ */ o.jsx(
      Re,
      {
        className: js.tagName,
        onDelete: () => e(n),
        color: n.color,
        disabled: this.isItemDisabled(n),
        children: r
      },
      n.id
    );
    return a ? /* @__PURE__ */ o.jsx(yt, { ...a, children: l }, t) : l;
  }
  getListMoreItem(s) {
    const { MoreItemsItemComponent: t, onRemove: e } = this.props, n = this.resolveItem(s), r = this.getTooltip(n), a = /* @__PURE__ */ o.jsx(
      t,
      {
        item: n,
        onSelect: e,
        disabled: this.isItemDisabled(n),
        clearSearch: O,
        isLoading: !1,
        checked: !1
      },
      n.id
    );
    return r ? /* @__PURE__ */ o.jsx(yt, { ...r, children: a }, n.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: s,
      previewItemsNumber: t,
      moreItemsDropdownProps: e = {}
    } = this.props;
    let n = [], r = [], a = "";
    if (t && s) {
      if (s.length > 0 && s.length < t)
        n = s.map(this.getListItem);
      else if (s.length >= t) {
        const h = s.slice(0, t), u = s.slice(
          t,
          s.length
        );
        n = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      n = s.map(this.getListItem);
    const { className: l, ...c } = e, d = /* @__PURE__ */ o.jsx(
      "div",
      {
        ...c,
        className: b(js.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      n,
      t && s.length > t ? /* @__PURE__ */ o.jsxs(
        ee,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ o.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: s,
      selectedItems: t,
      previewItemsNumber: e,
      className: n,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: y,
      emptyComponent: x,
      emptyMessage: C,
      containerProps: _,
      moreItemsDropdownProps: w,
      MoreItemsItemComponent: S,
      hideSelectedItems: v,
      disabledItems: T,
      tooltipItems: D,
      optionComponent: E,
      ...F
    } = this.props, P = b(
      {
        [js.items]: !0
      },
      n
    );
    return /* @__PURE__ */ o.jsxs("div", { className: P, children: [
      /* @__PURE__ */ o.jsx(
        pa,
        {
          items: s,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: y,
          emptyComponent: x,
          emptyMessage: C,
          containerProps: _,
          selectedItems: t,
          disabledItems: T,
          tooltipItems: D,
          optionComponent: E,
          ...F
        }
      ),
      !v && this.getPreviewItems()
    ] });
  }
}
f(Ag, "defaultProps", {
  MoreItemsItemComponent: Ap,
  hideSelectedItems: !1,
  disabledItems: [],
  tooltipItems: {}
});
const Og = "h-fieldButton--fieldButton__button", Bg = {
  button: Og
};
class GD extends k {
  render() {
    const {
      className: s,
      buttonClassName: t,
      label: e,
      meta: n,
      disabled: r,
      helpIcon: a,
      description: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = b(t, Bg.button);
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: e,
        meta: n,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ o.jsx(
          tt,
          {
            disabled: r,
            ...u,
            className: p,
            children: h
          }
        )
      }
    );
  }
}
const Hg = "h-inputDatePicker--inputDatePicker__root", Wg = "h-inputDatePicker--inputDatePicker__inputContainer", Mg = "h-inputDatePicker--inputDatePicker__input", zg = "h-inputDatePicker--inputDatePicker__rootReadOnly", Vg = "h-inputDatePicker--inputDatePicker__iconsContainer", Kg = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", Ug = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", qg = "h-inputDatePicker--inputDatePicker__calendarIcon", Gg = "h-inputDatePicker--inputDatePicker__clearIcon", At = {
  root: Hg,
  inputContainer: Wg,
  input: Mg,
  rootReadOnly: zg,
  iconsContainer: Vg,
  rootHasClearIcon: Kg,
  rootHasWrapperIcon: Ug,
  calendarIcon: qg,
  clearIcon: Gg
}, Yg = "inputDatePickerTestId";
class ma extends k {
  constructor(t) {
    super(t);
    f(this, "inputRef");
    f(this, "rootRef");
    f(this, "datePickerContainerRef");
    this.inputRef = W(), this.rootRef = W(), this.datePickerContainerRef = W(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    var e;
    const t = (e = this.datePickerContainerRef.current) == null ? void 0 : e.querySelector('input[type="text"]');
    t == null || t.focus();
  }
  handleWindowClick(t) {
    var e;
    (e = this.rootRef.current) != null && e.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    var r;
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && ((r = this.inputRef.current) == null || r.focus());
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    var e;
    (e = this.rootRef.current) != null && e.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    is(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: r,
      dateFormat: a,
      dropdownProps: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u,
      placeholder: p,
      disabled: m,
      datePickerProps: g,
      clearable: y,
      minDate: x,
      maxDate: C,
      readOnly: _,
      ...w
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ o.jsx(
      Et,
      {
        prefix: c,
        suffix: d,
        disabled: m,
        icon: h,
        active: S,
        status: u,
        children: /* @__PURE__ */ o.jsxs("div", { className: At.inputContainer, children: [
          /* @__PURE__ */ o.jsx(
            "input",
            {
              ...w,
              id: e,
              name: e,
              className: At.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: m,
              placeholder: p || (a == null ? void 0 : a.toLowerCase()),
              autoComplete: "off",
              value: Gn(n) ? void 0 : (n == null ? void 0 : n.format(a)) ?? "",
              onChange: Gn(n) ? void 0 : O,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ o.jsxs("div", { className: At.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ o.jsx(
      st,
      {
        className: At.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ o.jsx(
      st,
      {
        className: At.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: r,
      datePickerProps: a,
      disabled: l,
      dropdownProps: c,
      dateFormat: d
    } = this.props, { isDropdownOpen: h, shouldRerenderDatePicker: u } = this.state;
    return /* @__PURE__ */ o.jsx(zt, { ...c, isOpen: h, children: /* @__PURE__ */ o.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ o.jsx(
      ha,
      {
        disabled: l,
        ...a,
        dateFormat: d,
        date: t ?? null,
        timezone: r,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      u.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: r, icon: a } = this.props, l = b(At.root, t, {
      [At.rootHasClearIcon]: n && e,
      [At.rootHasWrapperIcon]: !!a,
      [At.rootReadOnly]: r
    });
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": Yg,
        ref: this.rootRef,
        className: l,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
f(ma, "defaultProps", {
  dateFormat: N.localeData().longDateFormat("L"),
  name: Math.floor(Math.random() * 1e8).toString()
});
class YD extends k {
  constructor(s) {
    super(s), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(s) {
    const {
      input: { onChange: t }
    } = this.props;
    t == null || t({
      date: s != null && s.date ? s.date.toISOString() : "",
      localDate: s != null && s.localDate ? s.localDate.toISOString() : "",
      timezone: (s == null ? void 0 : s.timezone) || "",
      localTimezone: (s == null ? void 0 : s.localTimezone) || ""
    });
  }
  render() {
    const {
      className: s,
      input: { value: t, name: e, onChange: n, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: a,
        labelFor: e,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ o.jsx(
          ma,
          {
            name: e,
            value: qs(t == null ? void 0 : t.localDate) ? N(t.localDate, N.ISO_8601) : null,
            timezone: t == null ? void 0 : t.timezone,
            onChange: this.handleChange,
            ...r,
            status: V.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Qg = "h-inputDateRangePicker--inputDateRangePicker__root", Xg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", Jg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Zg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", tf = "h-inputDateRangePicker--inputDateRangePicker__input", ef = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", nf = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", sf = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", of = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", rf = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", af = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", lf = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", cf = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", df = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", mt = {
  root: Qg,
  inputsContainer: Xg,
  arrowContainer: Jg,
  inputContainer: Zg,
  input: tf,
  rootReadOnly: ef,
  iconsContainer: nf,
  rootStartDateHasClearIcon: sf,
  startDateIconsContainer: of,
  rootEndDateHasClearIcon: rf,
  endDateIconsContainer: af,
  rootHasWrapperIcon: lf,
  calendarIcon: cf,
  clearIcon: df
}, hf = "inputDateRangePickerTestId", sn = class sn extends k {
  constructor(t) {
    super(t);
    f(this, "inputsRef");
    f(this, "rootRef");
    f(this, "dateRangePickerContainerRef");
    this.inputsRef = {
      startDate: W(),
      endDate: W()
    }, this.rootRef = W(), this.dateRangePickerContainerRef = W(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: r } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || r !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    var n, r, a;
    const { focusedInput: t } = this.state, e = (n = this.dateRangePickerContainerRef.current) == null ? void 0 : n.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? (r = e == null ? void 0 : e[0]) == null || r.focus() : (a = e == null ? void 0 : e[1]) == null || a.focus();
  }
  handleWindowClick(t) {
    var e;
    (e = this.rootRef.current) != null && e.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    var a;
    const { onChange: e, value: n } = this.props, { focusedInput: r } = this.state;
    typeof e == "function" && e(t), ((n == null ? void 0 : n[r]) ?? t[r] !== null) && ((a = this.inputsRef[r].current) == null || a.focus());
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: r, localTimezone: a } = this.props, l = {
      startDate: e === "startDate" ? null : (n == null ? void 0 : n.startDate) ?? null,
      localStartDate: e === "startDate" ? null : (n == null ? void 0 : n.localStartDate) ?? null,
      endDate: e === "endDate" ? null : (n == null ? void 0 : n.endDate) ?? null,
      localEndDate: e === "endDate" ? null : (n == null ? void 0 : n.localEndDate) ?? null,
      timezone: r || null,
      localTimezone: a || null
    };
    this.handleDatesChange(l);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    var e;
    (e = this.rootRef.current) != null && e.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    is(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || N.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: r, disabled: a } = this.props, { isDropdownOpen: l } = this.state;
    return /* @__PURE__ */ o.jsx(
      Et,
      {
        prefix: t,
        suffix: e,
        disabled: a,
        icon: n,
        active: l,
        status: r,
        children: /* @__PURE__ */ o.jsxs("div", { className: mt.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ o.jsx("div", { className: mt.arrowContainer, children: /* @__PURE__ */ o.jsx(R, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    var F;
    const {
      className: n,
      clearable: r,
      dateFormat: a,
      dateRangePickerProps: l,
      disabled: c,
      dropdownProps: d,
      icon: h,
      localTimezone: u,
      maxDate: p,
      minDate: m,
      name: g,
      onChange: y,
      placeholder: x,
      prefix: C,
      readOnly: _,
      status: w,
      suffix: S,
      tabIndex: v,
      timezone: T,
      value: D,
      ...E
    } = this.props;
    return /* @__PURE__ */ o.jsxs("div", { className: mt.inputContainer, children: [
      /* @__PURE__ */ o.jsx(
        "input",
        {
          ...E,
          id: sn.getInputName(g, t),
          name: sn.getInputName(g, t),
          className: mt.input,
          ref: this.inputsRef[t],
          onClick: (P) => this.handleInputClick(P, t),
          onFocus: (P) => this.handleInputFocus(P, t),
          onBlur: (P) => this.handleInputBlur(P),
          onKeyDown: (P) => this.handleInputKeydown(P, t),
          disabled: c,
          placeholder: (x == null ? void 0 : x[t]) || x || ((F = this.dateFormat) == null ? void 0 : F.toLowerCase()),
          autoComplete: "off",
          value: D && N(D[t]).isValid() ? N(D[t]).format(this.dateFormat) : "",
          onChange: Gn(D) ? void 0 : O,
          tabIndex: e ?? v,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ o.jsxs(
        "div",
        {
          className: b(mt.iconsContainer, {
            [mt.startDateIconsContainer]: t === "startDate",
            [mt.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ o.jsx(
      st,
      {
        className: mt.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: r } = this.props;
    return !e || !(n != null && n[t]) ? null : /* @__PURE__ */ o.jsx(
      st,
      {
        className: mt.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: r,
        onClick: (a) => this.handleClearIconClick(a, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c
    } = this.props, { isDropdownOpen: d, focusedInput: h, shouldRerenderDateRangePicker: u } = this.state;
    return /* @__PURE__ */ o.jsx(zt, { ...c, isOpen: d, children: /* @__PURE__ */ o.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ o.jsx(
      da,
      {
        disabled: l,
        ...a,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: (t == null ? void 0 : t.startDate) ?? null,
        endDate: (t == null ? void 0 : t.endDate) ?? null,
        timezone: r ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: h
      },
      u.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: r, icon: a } = this.props, l = b(mt.root, t, {
      [mt.rootStartDateHasClearIcon]: n && (e == null ? void 0 : e.startDate),
      [mt.rootEndDateHasClearIcon]: n && (e == null ? void 0 : e.endDate),
      [mt.rootHasWrapperIcon]: !!a,
      [mt.rootReadOnly]: r
    });
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-testid": hf,
        ref: this.rootRef,
        className: l,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
};
f(sn, "defaultProps", {
  name: {
    startDate: Math.floor(Math.random() * 1e8).toString(),
    endDate: Math.floor(Math.random() * 1e8).toString()
  }
});
let ts = sn;
class QD extends k {
  constructor(s) {
    super(s), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(s) {
    const {
      input: { onChange: t }
    } = this.props;
    t == null || t({
      startDate: s != null && s.startDate ? s.startDate.toISOString() : "",
      localStartDate: s != null && s.localStartDate ? s.localStartDate.toISOString() : "",
      endDate: s != null && s.endDate ? s.endDate.toISOString() : "",
      localEndDate: s != null && s.localEndDate ? s.localEndDate.toISOString() : "",
      timezone: (s == null ? void 0 : s.timezone) ?? "",
      localTimezone: (s == null ? void 0 : s.localTimezone) ?? ""
    });
  }
  getDateRange({
    localStartDate: s,
    localEndDate: t
  }) {
    const e = qs(s) ? N(s, N.ISO_8601) : null, n = qs(t) ? N(t, N.ISO_8601) : null;
    return {
      startDate: e,
      endDate: n
    };
  }
  render() {
    const {
      className: s,
      input: { name: t, value: e, onChange: n, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: y, localTimezone: x } = e;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: a,
        labelFor: ts.getInputName(t, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ o.jsx(
          ts,
          {
            name: t,
            value: this.getDateRange(e),
            timezone: y,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: V.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const uf = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format"
], de = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
), go = (i) => si(i), fo = (i, s = window) => s.getComputedStyle(i).display === "block";
function Ns(i, s) {
  const t = {
    ctrlKey: [
      "Control",
      ...de ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...de ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...de ? ["$metaOrCtrl"] : []]
  };
  return i.some((e) => {
    if (s.code !== e[1])
      return !1;
    const n = e[0] ?? [];
    return Object.entries(t).every(
      ([r, a]) => {
        const l = oi(
          a,
          n
        ).length;
        return s[r] ? l > 0 : l === 0;
      }
    );
  });
}
const pf = (i, s, t) => {
  var n;
  if (!i || s < 0 || t < 0) return !1;
  const e = ((n = i == null ? void 0 : i.textContent) == null ? void 0 : n.length) ?? 0;
  return !(s > e || t > e);
}, mf = (i, s) => i.document.queryCommandState(s), gf = (i) => i.document.queryCommandValue("formatBlock"), ff = (i) => i.type.indexOf("image/") === 0, Uo = (i, s) => {
  const t = cn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(s),
    uid: t
  };
}, bf = (i) => {
  i && i.querySelectorAll("td").forEach((s) => {
    s.style.border = "1px solid currentColor";
  });
}, Xs = (i) => {
  i.setAttribute("dir", "auto");
  const s = window.getComputedStyle(i).direction;
  i.setAttribute("dir", s);
}, qo = (i) => {
  i && i.childNodes.forEach((s) => {
    s.nodeType !== Node.ELEMENT_NODE && s.nodeType !== Node.TEXT_NODE || go(s) && fo(s) && Xs(s);
  });
}, bo = (i, s = !0) => {
  const t = document.createElement("div");
  return t.style.display = "none", t.innerHTML = i, document.body.appendChild(t), t.childNodes.forEach((e) => {
    if (!(e.nodeType !== Node.ELEMENT_NODE && e.nodeType !== Node.TEXT_NODE)) {
      if (go(e) && fo(e))
        e.innerHTML = bo(e.innerHTML, !1), Xs(e);
      else if (s) {
        const n = document.createElement("div");
        n.appendChild(e.cloneNode(!0)), e.replaceWith(n), Xs(n);
      }
    }
  }), document.body.removeChild(t), t.innerHTML;
}, Go = (i, s = { side: "both" }) => {
  const { side: t } = s, e = i.split(""), n = " ", r = "&nbsp;";
  let a = 0, l = e.length - 1;
  if (t === "both" || t === "start")
    for (; e[a] === n; )
      e[a++] = r;
  if (t === "both" || t === "end")
    for (; e[l] === n; )
      e[l--] = r;
  return e.join("");
}, es = (i, s) => i.split(/\r\n|\r|\n/g).map((t, e) => t ? s.inline && e === 0 ? Go(t, { side: "end" }) : `<div>${Go(t)}</div>` : "<br />").join("");
function yf(i) {
  var a, l, c;
  const s = "&nbsp;", t = " ", e = " ", n = xf(i.anchorNode), r = _f(i.anchorNode);
  if (((a = i.anchorNode) == null ? void 0 : a.nodeType) === Node.TEXT_NODE && n.endsWith(s)) {
    const { focusOffset: d, anchorOffset: h } = i, u = Array.prototype.indexOf.call(
      (l = i.anchorNode.parentElement) == null ? void 0 : l.childNodes,
      i.anchorNode
    ), p = r.replaceAll(s, e).replace(/.$/, t), m = document.createTextNode(p);
    if ((c = i.anchorNode.parentElement) == null || c.childNodes[u].replaceWith(m), i != null && i.rangeCount && (i == null ? void 0 : i.rangeCount) > 0 && pf(m, d, h)) {
      const g = i.getRangeAt(0);
      g.setStart(m, d), g.setEnd(m, h);
    }
  }
}
function xf(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const s = document.createElement("span");
  return s.appendChild(i.cloneNode()), s.innerHTML;
}
function _f(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const Cf = "h-inputRichText-addonTrigger--addonTrigger__root", wf = {
  root: Cf
};
function vf(i) {
  var n;
  if (!i)
    return null;
  const { focusOffset: s, anchorOffset: t, anchorNode: e } = i;
  return s !== t || !e || e.nodeName !== "#text" ? null : ((n = e == null ? void 0 : e.textContent) == null ? void 0 : n.slice(0, s)) || null;
}
const Pn = (i, s) => {
  const t = ga(i, s);
  return t && i.triggers.isAddonTrigger(t.matchedTrigger) ? t.matchedTrigger : null;
}, Rn = (i, s) => {
  const t = ga(i, s);
  return t ? t.match : null;
}, ga = (i, s) => s ? i.triggers.test(s) : null, Yo = "input-rich-text-addon-trigger", Sf = (i, s) => {
  const t = i.selection.recreate();
  if (!t || !s) return null;
  const e = t.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && e && t != null && t.rangeCount && (t == null ? void 0 : t.rangeCount) > 0 ? t.getRangeAt(0).getBoundingClientRect() : null;
}, If = (i, s) => {
  if (i.ref.current && s) {
    const t = i.ref.current.getBoundingClientRect();
    return {
      left: `${s.x - t.x}px`,
      top: `${s.y - t.y}px`,
      height: "0",
      width: s.width,
      position: "absolute"
    };
  }
  return {};
}, Yt = (i) => vf(i.selection.recreate()) || "", Fs = (i, s) => !!s && i.triggers.isAddonTrigger(s), Ps = (i) => (i == null ? void 0 : i.nodeType) === Node.ELEMENT_NODE, Js = (i, s) => i.dataset.testid === s ? i : i.parentElement ? Js(i.parentElement, s) : null, xe = {};
class kf extends EventTarget {
  constructor() {
    super(...arguments);
    /**
     * A map of event listeners for each event type.
     *
     * Since it can be tricky to register/unregister event listeners as data
     * changes in the consumer, we store the event listeners in a map to be able
     * to clear them easily, in order to avoid memory leaks.
     */
    f(this, "callbacks", {
      focus: [],
      insert: [],
      up: [],
      down: []
    });
  }
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const ke = new kf(), Df = Wt({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: ke
});
var Tf = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(Tf || {});
const jf = (i) => {
  var T, D, E;
  const { editor: s } = i, [t, e] = U(null), [n, r] = U(null), [a, l] = U(null), [c, d] = U(!1), h = If(s, a), [u] = U(cn()), { dismissText: p } = xe[u] ?? { dismissText: "" }, m = (t == null ? void 0 : t[0]) ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  (m == null ? void 0 : m.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " "))) || !1, y = L(() => {
    var j;
    const F = Pn(s, Yt(s)), P = Rn(s, Yt(s)), I = Sf(s, F);
    Fs(s, F) && ((j = F == null ? void 0 : F.shouldHandleSelectionChange) == null ? void 0 : j.call(F)) !== !1 ? (r(F), e(P), l(I)) : (r(null), e(null), l(null)), d(!0);
  }, [s]), x = L(() => {
    var I;
    const F = Pn(s, Yt(s)), P = (I = Rn(s, Yt(s))) == null ? void 0 : I[0];
    return Fs(s, F) && !!P;
  }, [s]), C = L(() => {
    var A, K;
    const F = Pn(s, Yt(s)), P = (A = Rn(s, Yt(s))) == null ? void 0 : A[0], I = ((K = xe[u]) == null ? void 0 : K.dismissText) || "", j = I ? P == null ? void 0 : P.startsWith(I) : !1;
    return Fs(s, F) && !!P && !j;
  }, [s, u]), _ = L(() => {
    s.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: C,
        callback: () => {
          ke.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: C,
        callback: () => {
          ke.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: C,
        callback: () => {
          ke.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: C,
        callback: () => {
          ke.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: C,
        callback: (F, P) => {
          var A;
          const I = (A = Rn(s, Yt(s))) == null ? void 0 : A[0];
          if (!I) {
            xe[u] = {
              dismissText: ""
            };
            return;
          }
          const j = Pn(s, Yt(s));
          (j == null ? void 0 : j.persistOnEsc) === !1 && (P.stopPropagation(), r(null), e(null), l(null)), xe[u] = {
            dismissText: (I.trim().length === 1 ? "" : I) ?? ""
          };
        }
      }
    ]);
  }, [s, C, u]);
  at(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && (n == null ? void 0 : n.persistOnEsc) !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && (n == null ? void 0 : n.persistOnEsc) === !1) && (xe[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, n]);
  const w = L((F) => {
    const P = F.nativeEvent.relatedTarget, I = Ps(P) && Js(P, Ca), j = Ps(P) && Js(P, Yo);
    (!Ps(P) || !I && !j) && d(!1);
  }, []), S = L(
    (F, { inline: P } = {}) => {
      var K, rt;
      const I = s.selection.recreate();
      if (!I || !n)
        return;
      const A = !!((rt = (K = I.anchorNode) == null ? void 0 : K.textContent) != null && rt.match(
        `^${n == null ? void 0 : n.trigger.source}`
      )) && !P ? (
        // Adjust each lines direction if it's been added to a new line
        bo(
          es(F, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        es(F, { inline: !0 })
      );
      I != null && I.rangeCount && (I == null ? void 0 : I.rangeCount) > 0 && s.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        I.getRangeAt(0).createContextualFragment(A),
        {
          getSelection: () => {
            var Cn;
            const J = s.selection.recreate();
            if (!J)
              return null;
            const { focusOffset: $ } = J, ut = n.trigger.exec(m), Vt = ((Cn = ut == null ? void 0 : ut[1]) == null ? void 0 : Cn.length) ?? 0, Q = m.length - Vt;
            return J != null && J.anchorNode && J.extend(
              J.anchorNode,
              $ - Q
            ), J;
          }
        }
      );
    },
    [s, m, n]
  );
  if (Le(() => {
    _(), s.selection.onUpdate(y), s.events.onBlur(w);
  }), te(() => {
    delete xe[u];
  }), !n || !c || !m || g)
    return null;
  const v = ((T = n.customContainer) == null ? void 0 : T.current) || window.document.body;
  return /* @__PURE__ */ o.jsx("div", { style: h, children: /* @__PURE__ */ o.jsxs(ri, { open: !0, children: [
    /* @__PURE__ */ o.jsx(ai, {}),
    /* @__PURE__ */ o.jsx(ii, { container: v, children: /* @__PURE__ */ o.jsx(
      li,
      {
        onOpenAutoFocus: (F) => F.preventDefault(),
        "data-testid": Yo,
        className: wf.root,
        side: ((D = n.popoverContent) == null ? void 0 : D.side) ?? "top",
        align: ((E = n.popoverContent) == null ? void 0 : E.align) ?? void 0,
        children: /* @__PURE__ */ o.jsx(
          Df.Provider,
          {
            value: { matchText: m, insertContent: S, eventEmitter: ke },
            children: n.component
          }
        )
      }
    ) })
  ] }) });
}, Nf = "h-inputRichText-toolbarButton--toolbarButton__root", Ff = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", Pf = "h-inputRichText-toolbarButton--toolbarButton__rootActive", Rf = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", Lf = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", _e = {
  root: Nf,
  rootDisabled: Ff,
  rootActive: Pf,
  rootWithBadge: Rf,
  rootWithText: Lf
};
function Pt({
  className: i,
  isActive: s,
  icon: t,
  disabled: e,
  showBadge: n,
  text: r,
  ...a
}) {
  const l = b(
    {
      [_e.root]: _e.root,
      [_e.rootActive]: s,
      [_e.rootDisabled]: e,
      [_e.rootWithBadge]: n,
      [_e.rootWithText]: r
    },
    i
  );
  return /* @__PURE__ */ o.jsx(
    "button",
    {
      tabIndex: -1,
      type: "button",
      ...a,
      className: l,
      disabled: e,
      children: /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx("span", { children: /* @__PURE__ */ o.jsx(R, { name: t }) }),
        r && /* @__PURE__ */ o.jsx("span", { children: /* @__PURE__ */ o.jsx(B.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
}
const Ef = "h-inputRichText-attachmentButton--attachmentButton__dropzone", $f = "h-inputRichText-attachmentButton--attachmentButton__fileInput", Af = "h-inputRichText-attachmentButton--attachmentButton__dropdown", Of = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", Ln = {
  dropzone: Ef,
  fileInput: $f,
  dropdown: Af,
  dropzoneIcon: Of
};
var Ws;
let Bf = (Ws = class extends k {
  constructor(t) {
    super(t);
    f(this, "handleDragEnter", (t) => {
      t.preventDefault();
      const { allowAttachments: e } = this.props;
      e && this.setState({
        fileHover: !0
      });
    });
    f(this, "handleDragLeave", (t) => {
      t.preventDefault(), this.setState({
        fileHover: !1
      });
    });
    f(this, "handleAttachmentDrop", (t) => {
      t.preventDefault();
      const { onAddAttachment: e } = this.props;
      t.dataTransfer && e(t.dataTransfer.files), this.setState({
        fileHover: !1
      });
    });
    this.state = {
      fileHover: !1
    };
  }
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: r,
      allowInline: a,
      onAddAttachment: l,
      ...c
    } = this.props, { fileHover: d } = this.state, h = b(t), u = d || n;
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        ...c,
        className: h,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          u && /* @__PURE__ */ o.jsx(Mt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !u && "Drop the file or click to upload"
        ]
      }
    );
  }
}, f(Ws, "displayName", "AttachmentButtonDropzone"), Ws);
const Hf = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class Wf extends k {
  constructor(t) {
    super(t);
    f(this, "unsubscribeAddAttachment");
    f(this, "fileInputRef");
    f(this, "openFileBrowser", (t) => {
      t.preventDefault();
      const { current: e } = this.fileInputRef;
      e && e.click();
    });
    f(this, "handleFileChanged", (t) => {
      const { onAttachFiles: e, editorWindow: n } = this.props, r = t.target;
      r !== null && r instanceof n.HTMLInputElement && (e(r.files), r.value = "");
    });
    f(this, "preventDefault", (t) => {
      t.preventDefault();
    });
    this.fileInputRef = W(), this.unsubscribeAddAttachment = xi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        var t;
        (t = this.fileInputRef.current) == null || t.click();
      }
    );
  }
  componentWillUnmount() {
    var t;
    (t = this.unsubscribeAddAttachment) == null || t.call(this);
  }
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: r } = this.props;
    return /* @__PURE__ */ o.jsxs("div", { className: Ln.dropdown, children: [
      /* @__PURE__ */ o.jsx(
        Bf,
        {
          className: Ln.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ o.jsx(R, { name: "paperclip", className: Ln.dropzoneIcon })
        }
      ),
      r
    ] });
  }
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: r,
      isAttachmentsUploading: a,
      dropdownRef: l,
      editorWindow: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: Ln.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ o.jsx(
        ee,
        {
          ...d,
          className: t,
          noStyle: !0,
          ref: l,
          dropdown: this.renderDropdown(),
          children: /* @__PURE__ */ o.jsx(
            Pt,
            {
              onMouseDown: this.preventDefault,
              icon: "paperclip",
              showBadge: e.length > 0
            }
          )
        }
      )
    ] });
  }
}
const Mf = "h-inputRichText-dropzone--dropzone__root", zf = "h-inputRichText-dropzone--dropzone__inlineDropzone", Vf = "h-inputRichText-dropzone--dropzone__attachmentDropzone", Kf = "h-inputRichText-dropzone--dropzone__rootDual", Uf = "h-inputRichText-dropzone--dropzone__icon", Ce = {
  root: Mf,
  inlineDropzone: zf,
  attachmentDropzone: Vf,
  rootDual: Kf,
  icon: Uf
};
class fa extends k {
  constructor(t) {
    super(t);
    f(this, "handleDragEnter", (t) => {
      t.preventDefault();
      const { allowInlineAttachments: e, allowAttachments: n } = this.props;
      !e && !n || this.setState({
        fileHover: !0
      });
    });
    f(this, "handleDragLeave", (t) => {
      t.preventDefault(), this.setState({
        fileHover: !1
      });
    });
    f(this, "handleEnterDropzone", (t) => {
      t.preventDefault(), this.setState({
        overDropzone: !0
      });
    });
    f(this, "handleLeaveDropzone", (t) => {
      t.preventDefault(), this.setState({
        overDropzone: !1
      });
    });
    f(this, "handleInlineDrop", (t) => {
      t.preventDefault();
      const { onAddInline: e } = this.props;
      t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
        overDropzone: !1,
        fileHover: !1
      });
    });
    f(this, "handleAttachmentDrop", (t) => {
      t.preventDefault();
      const { onAddAttachment: e } = this.props;
      t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
        overDropzone: !1,
        fileHover: !1
      });
    });
    this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: r,
      onAddInline: a,
      onMouseDown: l,
      attachments: c,
      onAddAttachment: d,
      ...h
    } = this.props, { fileHover: u, overDropzone: p } = this.state, m = b(
      {
        [Ce.root]: !0,
        [Ce.rootDual]: n && r
      },
      t
    ), g = n || r, y = {};
    return l && (y.onClick = l), g && (y.onDragEnter = this.handleDragEnter, y.onDragOver = this.handleDragEnter, y.onDragLeave = this.handleDragLeave), /* @__PURE__ */ o.jsxs(
      "div",
      {
        ...h,
        tabIndex: -1,
        className: m,
        ...y,
        children: [
          e,
          (u || p) && /* @__PURE__ */ o.jsxs(Mt, { children: [
            n && /* @__PURE__ */ o.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: Ce.inlineDropzone,
                children: [
                  /* @__PURE__ */ o.jsx(R, { name: "upload", size: 24, className: Ce.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            r && /* @__PURE__ */ o.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: Ce.attachmentDropzone,
                children: [
                  /* @__PURE__ */ o.jsx(R, { name: "paperclip", size: 24, className: Ce.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
f(fa, "displayName", "InputRichTextDropzone");
const ba = (i, s) => i.split(new RegExp(`(${ro(s)})`, "gi")).map(
  (t, e) => t.toLowerCase() === s.toLowerCase() ? /* @__PURE__ */ o.jsx("span", { children: t }, e) : t
), qf = "h-inputRichText-emoji--emoji__root", Gf = "h-inputRichText-emoji--emoji__decorator", Yf = "h-inputRichText-emoji--emoji__suggestion", Qf = "h-inputRichText-emoji--emoji__suggestionActive", Xf = "h-inputRichText-emoji--emoji__suggestionName", en = {
  root: qf,
  decorator: Gf,
  suggestion: Yf,
  suggestionActive: Qf,
  suggestionName: Xf
}, Jf = ui(
  () => import("./emoji-OBfaI_6_.js").then((i) => i.g).then((i) => ({
    default: i.EmojiPicker
  }))
), ns = {};
gi.emojis.forEach((i) => {
  i.forEach(
    (s) => {
      s.shortNames && s.shortNames.forEach((t) => {
        ns[t.replace(/:/g, "")] = s.emoji;
      });
    }
  );
});
const Zf = (i) => {
  const { active: s, item: t, match: e, onSelect: n } = i, r = e ? ba(t, e) : t;
  return /* @__PURE__ */ o.jsxs(
    "button",
    {
      onClick: () => n(t),
      type: "button",
      "aria-current": s,
      className: b(en.suggestion, {
        [en.suggestionActive]: s
      }),
      children: [
        ns[t],
        /* @__PURE__ */ o.jsx("span", { className: en.suggestionName, children: r })
      ]
    }
  );
};
class tb extends k {
  constructor(t) {
    super(t);
    f(this, "getSuggestions", (t) => Object.keys(ns).filter((n) => n.indexOf(t) !== -1));
    // eslint-disable-next-line no-undef
    f(this, "preventDefault", (t) => {
      t.preventDefault();
    });
    f(this, "renderDropdown", () => /* @__PURE__ */ o.jsx(pi, { fallback: /* @__PURE__ */ o.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ o.jsx(yn.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ o.jsx(
      Jf,
      {
        onSelect: (e) => {
          this.insertEmoji(e), t();
        }
      }
    ) }) }));
    this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Zf,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(ns[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: r } = this.props, a = document.createElement("span");
    a.classList.add(en.decorator), a.innerHTML = t, r.content.insert(a, {
      getSelection: () => {
        const l = r.selection.recreate();
        return e && (l != null && l.anchorNode) && l.extend(l.anchorNode, n), l;
      }
    });
  }
  render() {
    const { className: t } = this.props, e = b(
      {
        [en.root]: !0
      },
      t
    );
    return /* @__PURE__ */ o.jsx("div", { className: e, children: /* @__PURE__ */ o.jsx(ee, { icon: "smile", dropdown: this.renderDropdown(), noStyle: !0, children: /* @__PURE__ */ o.jsx(
      Pt,
      {
        icon: "smile",
        title: "Emojis",
        onMouseDown: this.preventDefault
      }
    ) }) });
  }
}
const eb = "h-inputRichText--inputRichText__inputWrapper", nb = "h-inputRichText--inputRichText__root", sb = "h-inputRichText--inputRichText__toolbar", ob = "h-inputRichText--inputRichText__toolbarHint", rb = "h-inputRichText--inputRichText__toolbarHintVisible", ab = "h-inputRichText--inputRichText__toolbarHintHidden", ib = "h-inputRichText--inputRichText__editorWrap", lb = "h-inputRichText--inputRichText__placeholder", cb = "h-inputRichText--inputRichText__editor", db = "h-inputRichText--inputRichText__fileInput", hb = "h-inputRichText--inputRichText__uiBlocker", wt = {
  inputWrapper: eb,
  root: nb,
  toolbar: sb,
  toolbarHint: ob,
  toolbarHintVisible: rb,
  toolbarHintHidden: ab,
  editorWrap: ib,
  placeholder: lb,
  editor: cb,
  fileInput: db,
  uiBlocker: hb
}, ub = "h-inputRichText-linkButton--linkButton__linkOpener", pb = "h-inputRichText-linkButton--linkButton__dropdownContainer", Qo = {
  linkOpener: ub,
  dropdownContainer: pb
}, mb = "h-inputRichText-linkButton--linkMenu__root", gb = "h-inputRichText-linkButton--linkMenu__field", Rs = {
  root: mb,
  field: gb
};
class fb extends k {
  constructor(t) {
    super(t);
    f(this, "handleTextChange", (t) => {
      t && this.setState({
        textValue: t.target.value
      });
    });
    f(this, "handleUrlChange", (t) => {
      t && this.setState({
        urlValue: t.target.value
      });
    });
    f(this, "handleAddLink", (t) => {
      t == null || t.preventDefault();
      const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: r, urlValue: a } = this.state;
      r && a && (e(r, a), n());
    });
    f(this, "handleUnlink", (t) => {
      t.preventDefault();
      const { onUnlink: e, toggleDropdown: n } = this.props;
      e(), n();
    });
    f(this, "handleKeyDown", (t) => {
      t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
    });
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: r,
      toggleDropdown: a,
      onUnlink: l,
      ...c
    } = this.props, { textValue: d, urlValue: h } = this.state, u = b({ [Rs.root]: !0 }, t);
    return /* @__PURE__ */ o.jsxs("div", { ...c, className: u, children: [
      /* @__PURE__ */ o.jsx(
        Qs,
        {
          label: "Link title",
          noAlert: !0,
          className: Rs.field,
          input: {
            value: d,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ o.jsx(
        Qs,
        {
          label: "Link URL",
          noAlert: !0,
          className: Rs.field,
          input: {
            value: h,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ o.jsxs(M, { gap: "200", children: [
        /* @__PURE__ */ o.jsx(tt, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!h && /* @__PURE__ */ o.jsx(tt, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const bb = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: de ? [[["Control", "Meta"], "KeyK"]] : [[["Control", "Alt"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], yb = ({ editor: i }) => {
  const [s, t] = mi((_) => _ + 1, 0), [e, n] = fi(!1), r = Z(null), a = Z(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = bi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Le(() => {
    i.events.onMouseOver((_) => {
      m(_);
    }), a.current = i.events.subscribe("hyperlink", () => {
      n(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), te(() => {
    var _;
    (_ = a.current) == null || _.call(a);
  });
  const p = () => {
    var v;
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: w, focusNode: S } = _;
    if (w && S === w && ((v = w.parentElement) == null ? void 0 : v.nodeName) === "A") {
      const { href: T, innerText: D } = w.parentElement;
      u({
        selectedLink: T,
        selectedText: D
      });
    } else
      u({
        selectedLink: "",
        selectedText: _.toString()
      });
  }, m = L(
    (_) => {
      const { target: w } = _, { current: S } = i.ref;
      if (S && w && w instanceof HTMLAnchorElement) {
        const v = S.getBoundingClientRect(), T = w.getBoundingClientRect();
        u({
          hoverLinkHref: w.getAttribute("href"),
          hoverLinkBounds: {
            top: T.top - v.top,
            left: T.left - v.left,
            width: T.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = L(() => {
    var v;
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: w, focusNode: S } = _;
    if (w && w === S && ((v = w.parentElement) == null ? void 0 : v.nodeName) === "A") {
      const T = document.createRange();
      T.selectNodeContents(w.parentElement), _.removeAllRanges(), _.addRange(T);
    }
  }, [i.selection]), y = L(
    (_, w) => {
      w && (g(), i.command.run("insertHTML", `<a href="${w}">${_ || w}</a>`), t());
    },
    [i.command, g]
  ), x = L(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), C = L((_) => {
    _.preventDefault();
  }, []);
  return $r(r, () => {
    n(!1);
  }), Er("Escape", () => {
    n(!1), g();
  }), /* @__PURE__ */ o.jsxs(Mt, { children: [
    /* @__PURE__ */ o.jsxs("div", { ref: r, className: Qo.dropdownContainer, children: [
      /* @__PURE__ */ o.jsx(
        Pt,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: C,
          onClick: () => n()
        }
      ),
      e && /* @__PURE__ */ o.jsx(zt, { isOpen: e, children: /* @__PURE__ */ o.jsx(
        fb,
        {
          onAddLink: y,
          toggleDropdown: n,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ o.jsx(
      "a",
      {
        className: Qo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ o.jsx(R, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, xb = "h-tabs--tabs__root", _b = "h-tabs--tabs__tabs", Cb = "h-tabs--tabs__tab", wb = "h-tabs--tabs__tabTop", vb = "h-tabs--tabs__tabTopActive", Sb = "h-tabs--tabs__tabTopSelected", Ib = "h-tabs--tabs__tabLeft", kb = "h-tabs--tabs__tabLeftActive", Db = "h-tabs--tabs__tabLeftSelected", Tb = "h-tabs--tabs__tabBottom", jb = "h-tabs--tabs__tabBottomActive", Nb = "h-tabs--tabs__tabBottomSelected", Fb = "h-tabs--tabs__tabRight", Pb = "h-tabs--tabs__tabRightActive", Rb = "h-tabs--tabs__tabRightSelected", Lb = "h-tabs--tabs__tabDisabled", it = {
  root: xb,
  tabs: _b,
  tab: Cb,
  tabTop: wb,
  tabTopActive: vb,
  tabTopSelected: Sb,
  tabLeft: Ib,
  tabLeftActive: kb,
  tabLeftSelected: Db,
  tabBottom: Tb,
  tabBottomActive: jb,
  tabBottomSelected: Nb,
  tabRight: Fb,
  tabRightActive: Pb,
  tabRightSelected: Rb,
  tabDisabled: Lb
}, Eb = 13;
class $b extends k {
  constructor(s) {
    super(s), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: s, onChange: t, disabled: e } = this.props;
    e || t(s);
  }
  handleOnKeyDown(s) {
    s.keyCode === Eb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: s,
      placement: t,
      className: e,
      disabled: n,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = b(it.tab, e, {
      [it.tabDisabled]: n,
      [it.tabTop]: t === "top",
      [it.tabRight]: t === "right",
      [it.tabLeft]: t === "left",
      [it.tabBottom]: t === "bottom",
      [it.tabTopSelected]: t === "top" && s,
      [it.tabRightSelected]: t === "right" && s,
      [it.tabLeftSelected]: t === "left" && s,
      [it.tabBottomSelected]: t === "bottom" && s,
      [it.tabTopActive]: t === "top" && r,
      [it.tabRightActive]: t === "right" && r,
      [it.tabLeftActive]: t === "left" && r,
      [it.tabBottomActive]: t === "bottom" && r
    });
    return a && (l = b(l, { [a]: s })), l;
  }
  render() {
    const { id: s, label: t, icon: e, disabled: n, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: n ? -1 : 0,
        children: [
          a || !!e && /* @__PURE__ */ o.jsx(R, { name: e, className: "icon-vertical-fix" }),
          t,
          r
        ]
      },
      s
    );
  }
}
class ms extends k {
  constructor(t) {
    super(t);
    f(this, "containerRef");
    this.containerRef = W(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: r,
    slotEnd: a,
    slotStart: l
  }) {
    const {
      selectedId: c,
      activeId: d,
      onChange: h,
      tabsPlacement: u,
      tabClassName: p,
      tabSelectedClassName: m
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      $b,
      {
        selected: t === c,
        className: p,
        selectedClassName: m,
        id: t,
        label: e,
        icon: n,
        onChange: h,
        placement: u,
        disabled: r,
        active: t === d,
        slotEnd: a,
        slotStart: l
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: r,
      selectedId: a,
      onChange: l,
      tabsPlacement: c,
      activeId: d,
      ...h
    } = this.props, u = b(it.root, t);
    return /* @__PURE__ */ o.jsx("div", { ref: this.containerRef, ...h, className: u, children: /* @__PURE__ */ o.jsx("div", { className: it.tabs, children: this.renderTabs() }) });
  }
}
f(ms, "defaultProps", {
  tabsPlacement: "top"
});
const Ab = gn(ms, {
  fallback: null
}), Ob = "h-inputRichText-quickResponseSelector--quickResponseItem__root", Bb = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Hb = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Ue = {
  root: Ob,
  rootActive: Bb,
  name: Hb
};
class Ls extends k {
  constructor(s) {
    super(s), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: s, onSelect: t, item: e } = this.props;
    s || t(e);
  }
  render() {
    const {
      className: s,
      item: t,
      isLoading: e,
      onSelect: n,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !e && t ? t : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = b(
      {
        [Ue.root]: Ue.root,
        [Ue.rootActive]: r
      },
      s
    ), m = u ? ba(d, u) : d;
    return /* @__PURE__ */ o.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ o.jsx(B.Heading, { variant: "heading-3", className: Ue.name, children: m }),
          /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "4", className: Ue.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const Wb = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", Mb = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", zb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", Vb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", Kb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Ub = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", we = {
  container: Wb,
  dropdownButtonContainer: Mb,
  tabbedDropdown: zb,
  tabbedDropdownTabs: Vb,
  tabbedDropdownTabsContent: Kb,
  regularDropdown: Ub
}, Xo = /(^|\s)=/, Jo = "Quick responses";
class qb extends xt {
  constructor(t) {
    var e;
    super(t);
    f(this, "preventDefault", (t) => {
      t.preventDefault();
    });
    f(this, "handleSelect", (t, e) => {
      var n;
      (n = this.insertContent(t)) == null || n.then(() => {
        e && e();
      });
    });
    f(this, "insertContent", (t, e, n) => {
      const { renderQuickResponse: r, sanitize: a, editor: l } = this.props;
      return r(t).then((c) => {
        var m, g, y;
        const d = l.selection.recreate();
        if (!d)
          return;
        const h = !!e, u = h && !!((g = (m = d.anchorNode) == null ? void 0 : m.textContent) != null && g.match(
          `^${Xo.source}`
        )) || !h && !((y = d.anchorNode) != null && y.textContent);
        let p;
        u ? p = bo(
          es(a(c), { inline: !1 })
        ) : p = es(a(c), { inline: !0 }), d != null && d.rangeCount && (d == null ? void 0 : d.rangeCount) > 0 && l.content.insert(
          // template is sanitized
          // eslint-disable-next-line no-unsanitized/method
          d.getRangeAt(0).createContextualFragment(p),
          {
            getSelection: () => {
              const x = l.selection.recreate();
              return h && (x != null && x.anchorNode) && x.extend(x.anchorNode, n), x;
            }
          }
        );
      });
    });
    this.state = {
      searchTerm: "",
      selectedTab: (e = t.languages[0]) == null ? void 0 : e.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Xo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: Ls,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  handleToggle(t) {
    var r, a;
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== ((r = n[0]) == null ? void 0 : r.code)) && this.setState({ searchTerm: "", selectedTab: (a = n[0]) == null ? void 0 : a.code }, () => {
      const { searchTerm: l, selectedTab: c } = this.state;
      this.handleSearchChange(l, c, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: r } = this.props;
    return r.paramsChange({ search: t, locale: e }, n).then((a) => a.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ o.jsx(
      Pt,
      {
        icon: this.props.iconName ?? "bolt",
        title: Jo,
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ o.jsx(
      ps,
      {
        className: t,
        dropdownProps: {
          className: we.regularDropdown
        },
        containerProps: { className: we.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: Ls,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    );
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ o.jsx("div", { className: we.dropdownButtonContainer, children: /* @__PURE__ */ o.jsx(
      ee,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: Jo },
        dropdown: /* @__PURE__ */ o.jsxs("div", { className: we.tabbedDropdown, children: [
          /* @__PURE__ */ o.jsx(
            ms,
            {
              className: we.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ o.jsx("div", { className: we.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ o.jsx(yn.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ o.jsx(
      ua,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: Ls,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (r) => this.handleSelect(r, n),
        emptyComponent: xn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t != null && t.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Gb = "h-inputRichText-formatSelector--formatSelector__root", Yb = "h-inputRichText-formatSelector--formatSelector__list", Qb = "h-inputRichText-formatSelector--formatSelector__selector", Xb = "h-inputRichText-formatSelector--formatSelector__option", Jb = "h-inputRichText-formatSelector--formatSelector__optionActive", Zb = "h-inputRichText-formatSelector--formatSelector__button", ve = {
  root: Gb,
  list: Yb,
  selector: Qb,
  option: Xb,
  optionActive: Jb,
  button: Zb
}, Zs = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Zo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class ty extends k {
  constructor() {
    super(...arguments);
    f(this, "preventDefault", (t) => {
      t.preventDefault();
    });
  }
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ o.jsx(yn.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ o.jsx("ul", { className: ve.list, children: Zs.map((n) => {
      const r = "condition" in n;
      if (!(!r || r && n.condition(t)))
        return;
      const l = Zo[n.name];
      return /* @__PURE__ */ o.jsx(
        "li",
        {
          className: b(ve.option, {
            [ve.optionActive]: this.isActiveFormat(l)
          }),
          children: /* @__PURE__ */ o.jsx(
            "button",
            {
              type: "button",
              className: ve.button,
              onClick: () => {
                var c;
                (c = n.callback) == null || c.call(n, t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    var t;
    return ((t = Zs.find(
      (e) => this.isActiveFormat(Zo[e.name])
    )) == null ? void 0 : t.label) ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...r } = this.props, a = b(ve.root, t);
    return /* @__PURE__ */ o.jsx(
      ee,
      {
        className: a,
        ...r,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ o.jsxs("div", { className: ve.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ o.jsx(R, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const ey = "h-inputRichText-stylingMenu--stylingMenu__menu", ny = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", tr = {
  menu: ey,
  buttonsContainer: ny
}, ya = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: de ? [[["Control", "Meta"], "Digit7"]] : [[["Control", "Alt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: de ? [[["Control", "Meta"], "Digit8"]] : [[["Control", "Alt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [],
    callback: (i) => i.command.run("removeFormat")
  }
], xa = [...Zs, ...ya];
class sy extends k {
  constructor(t) {
    super(t);
    f(this, "domRef");
    f(this, "handleClickOutside", (t) => {
      const { current: e } = this.domRef;
      e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
        isOpen: !1
      });
    });
    f(this, "handleClick", (t) => {
      t.preventDefault();
      const { isOpen: e } = this.state;
      this.setState({
        isOpen: !e
      });
    });
    this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = W(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: r } = this.props;
    n !== e.isOpen && r[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: gf(t)
    });
  }
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      if (e.preventDefault(), t) {
        const r = xa.find(
          (a) => a.name === t
        );
        r == null || r.callback(n), this.forceUpdate();
      }
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: r, ...a } = this.props, { isOpen: l, currentFormat: c } = this.state, d = b(t);
    return /* @__PURE__ */ o.jsxs("div", { ...a, className: d, ref: this.domRef, children: [
      l && /* @__PURE__ */ o.jsxs("div", { className: tr.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ o.jsx(
          ty,
          {
            formatBlock: c,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ o.jsx("div", { className: tr.buttonsContainer, children: ya.map((h) => {
          const u = "condition" in h;
          if (!u || u && h.condition(n))
            return /* @__PURE__ */ o.jsx(
              Pt,
              {
                isActive: this.styleActive(h.name),
                onMouseDown: this.handleToolbarButtonClick(h.name),
                icon: h.icon
              },
              h.name
            );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ o.jsx(
        Pt,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick
        }
      )
    ] });
  }
}
const oy = "h-inputRichText-suggestions--suggestions__dropdown", ry = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", ay = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", iy = "h-inputRichText-suggestions--suggestions__dropdownTabs", ly = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", qe = {
  dropdown: oy,
  dropdownWithTabs: ry,
  dropdownWithoutTabs: ay,
  dropdownTabs: iy,
  dropdownTabsContent: ly
};
function cy(i) {
  var n;
  if (!i)
    return null;
  const { focusOffset: s, anchorOffset: t, anchorNode: e } = i;
  return s !== t || !e || e.nodeName !== "#text" ? null : (n = e == null ? void 0 : e.textContent) == null ? void 0 : n.slice(0, s);
}
class dy extends k {
  constructor(t) {
    super(t);
    f(this, "dropdownRef");
    f(this, "tabsRef");
    this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = W(), this.tabsRef = W(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: r } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), r !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    var r;
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const a = (r = n == null ? void 0 : n.getTabs) == null ? void 0 : r.call(n)[e];
      a && this.handleTabChange(a.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!(t != null && t.length);
  }
  hasTabs() {
    var t, e;
    return !!((e = (t = this.state.suggestionTrigger) == null ? void 0 : t.getTabs) != null && e.call(t).length);
  }
  getSelectedTabIndex() {
    var n;
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? (n = t == null ? void 0 : t.getTabs) == null ? void 0 : n.call(t).findIndex((r) => r.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : n.length - 1 : r = (e + 1) % n.length, {
          suggestionIndex: r
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      var a;
      const r = (a = n == null ? void 0 : n.getTabs) == null ? void 0 : a.call(n);
      if (r != null && r.length) {
        let l;
        return t < 0 ? l = e > 0 ? e - 1 : r.length - 1 : l = (e + 1) % r.length, {
          tabIndex: l
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    var c;
    const { editor: n } = this.props, { selectedTab: r, selectionMode: a } = this.state, l = cy(n.selection.recreate());
    if (l) {
      const d = n.triggers.test(l);
      if (d && n.triggers.isSuggestionTrigger(d.matchedTrigger)) {
        const { match: h, matchedTrigger: u } = d, p = (c = u == null ? void 0 : u.getTabs) == null ? void 0 : c.call(u);
        if (p != null && p.length) {
          let g = null;
          if (t ? g = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : r ? t = r : g = {
            selectionMode: "tab",
            selectedTab: p[0].id,
            tabIndex: 0
          }, g && this.setState(g, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else a !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          u.getSuggestions(h[1], t, e)
        ).then((g) => {
          this.updateSuggestions(h, u, g);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: r } = this.props, a = r.selection.recreate();
        if (a) {
          const { focusOffset: l, anchorNode: c } = a;
          if (c) {
            if (l - t >= 0)
              try {
                a.extend(c, l - t);
              } catch (d) {
                n == null || n(d);
              }
            if (a != null && a.rangeCount && (a == null ? void 0 : a.rangeCount) > 0) {
              const d = a.getRangeAt(0).getBoundingClientRect();
              a.collapseToEnd(), setTimeout(() => {
                e(d), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: r } = this.props;
    this.findTriggerPosition(t[0].length, (a) => {
      var m;
      const l = r.selection.recreate();
      if (!l)
        return;
      const { focusOffset: c } = l, h = new RegExp(e.trigger).exec(t[0]), u = ((m = h == null ? void 0 : h[1]) == null ? void 0 : m.length) ?? 0, p = t[0].length - u;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: a,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: c - p,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, a = e.listRef.current.children[t].getBoundingClientRect(), l = n.getBoundingClientRect();
        l.bottom < a.bottom ? n.scrollTop += a.bottom - l.bottom : l.top > a.top && (n.scrollTop -= l.top - a.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, a = e.containerRef.current.children[0].children[t].getBoundingClientRect(), l = n.getBoundingClientRect();
      l.bottom < a.bottom ? n.scrollTop += a.bottom - l.bottom : l.top > a.top && (n.scrollTop -= l.top - a.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: r
    } = this.state;
    if (!(!t || !t[e] || !r))
      return r.insertContent(
        t[e],
        r.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => {
        var n;
        return ((n = e.onNext) == null ? void 0 : n.call(e).then((r) => {
          this.setState({ suggestions: r });
        })) ?? Promise.resolve(void 0);
      }
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ o.jsx(xn, { label: "No suggestions found" });
  }
  renderTabs() {
    var c, d;
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: r } = this.state, a = ((c = e == null ? void 0 : e.getTabs) == null ? void 0 : c.call(e)) ?? [], l = !!(t != null && t.length);
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        ms,
        {
          ref: this.tabsRef,
          className: qe.dropdownTabs,
          tabs: a,
          tabsPlacement: "left",
          selectedId: n,
          activeId: (d = a == null ? void 0 : a[r]) == null ? void 0 : d.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ o.jsx("div", { className: qe.dropdownTabsContent, children: l ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: r } = this.state, a = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ o.jsx(
      ds,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: a,
        activeItem: r === "suggestion" ? t == null ? void 0 : t[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !(n != null && n.length) || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const r = b(qe.dropdown, {
      [qe.dropdownWithTabs]: this.hasTabs(),
      [qe.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ o.jsx("div", { ...n, children: /* @__PURE__ */ o.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ o.jsx(zt, { className: r, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function er(i) {
  return i instanceof RegExp ? i.source : i;
}
function hy(i) {
  return i.replace(/\(/g, "(?:");
}
class _a {
  constructor() {
    f(this, "storedTriggers");
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (s) => `(?!${er(s.trigger)})`
    ).join("");
  }
  add(s) {
    this.storedTriggers.push(s);
  }
  update(s) {
    const t = this.storedTriggers.findIndex(
      (e) => this.isAddonTrigger(e) && e.id === s.id
    );
    t !== -1 && (this.storedTriggers[t] = s);
  }
  test(s) {
    let t;
    for (let e = 0; e < this.storedTriggers.length; e += 1) {
      const n = this.storedTriggers[e], { trigger: r, allowSpaces: a, minChars: l } = n, c = hy(
        er(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (t = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(s), t && (!l || t[1].length >= l))
        return {
          match: t,
          matchedTrigger: n
        };
    }
    return null;
  }
  isSuggestionTrigger(s) {
    return "getSuggestions" in s;
  }
  isAddonTrigger(s) {
    return !this.isSuggestionTrigger(s);
  }
}
const Ca = "input-rich-text-editor", uy = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: de ? [[["Control", "Meta"], "KeyM"]] : [[["Control"], "KeyM"]]
  }
], nr = [
  ...uy,
  ...xa,
  ...bb,
  ...Hf
], py = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, my = Wt({
  command: {
    run: O,
    active: () => !1
  },
  content: {
    insert: O,
    setUiBlocker: O
  },
  hotkeys: {
    add: O,
    updateKeybindings: O
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: O
  },
  events: {
    subscribe: () => O,
    publish: O,
    onMouseOver: O,
    onBlur: O
  },
  allowFormatting: [],
  triggers: new _a(),
  ref: W(),
  window,
  history: {
    canUndo: () => !1,
    undo: O,
    takeSnapshot: O,
    reset: O
  }
}), Fe = class Fe extends k {
  constructor(t) {
    super(t);
    f(this, "editor");
    f(this, "editorRef");
    f(this, "currentSuggestionRef");
    f(this, "fileInputRef");
    f(this, "attachmentDropdownButtonRef");
    f(this, "unsubscribeInlineAttachment");
    f(this, "isInserting");
    f(this, "contentInsertionQueue");
    /**
     * The core update function, that triggers every time the selection is
     * changed, which will also trigger when the contents change.
     *
     * This method handles calling onChange prop.
     *
     * @returns {void | undefined} Description
     * @todo Test if onInput would be a better way of triggering onChange
     */
    f(this, "handleSelectionChange", () => {
      const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: r } = this.state, { current: a } = this.editorRef;
      if (a) {
        this.forceUpdate();
        const l = this.extractEditorContent();
        l !== n && (this.setState({
          htmlOld: l
        }), t(l));
      }
      r.forEach((l) => {
        l();
      }), e && e();
    });
    /** Handle any mouse over events on the editor */
    f(this, "handleMouseOver", (t) => {
      const { mouseOverListeners: e } = this.state;
      e.forEach((n) => {
        n(t);
      });
    });
    /** Handle blur events on the editor */
    f(this, "handleBlurListeners", (t) => {
      const { blurListeners: e } = this.state;
      e.forEach(
        (n) => {
          n(t);
        }
      );
    });
    f(this, "handleKeyDown", (t) => {
      if (t.getModifierState(t.key))
        return;
      const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: r } = this.props;
      if (r == null || r(t), e.some(
        ({ preventDefaultKeybinding: l }) => l && Ns(l, t)
      ) && t.preventDefault(), e.some(
        ({ name: l, keybindings: c, condition: d, callback: h }) => {
          if (Ns(c, t) && (d === void 0 || d(this.editor)))
            return h == null || h(this.editor, t), l && this.editor.events.publish(l), !0;
        }
      )) {
        this.setKeyDownHandled(t);
        return;
      }
      if (Ns([[["$metaOrCtrl"], "Enter"]], t)) {
        const { onTriggerSend: l } = this.props;
        this.setKeyDownHandled(t), l();
      } else if (t.key === "Enter" && n && !t.shiftKey) {
        const { onTriggerSend: l } = this.props;
        this.setKeyDownHandled(t), l();
      }
      return null;
    });
    f(this, "getBlockLevelParent", (t) => {
      const { editorWindow: e = window } = this.props;
      let n = go(t) ? t : t.parentElement;
      for (; !fo(n, e); )
        n = n.parentElement;
      return n;
    });
    // Insert actual text direction into the html
    f(this, "onInput", (t) => {
      var c;
      const { current: e } = this.editorRef, n = t == null ? void 0 : t.nativeEvent;
      if (!n)
        return;
      this.resetUndoStack();
      const { inputType: r } = n;
      if (r === "insertFromPaste" || !r) {
        qo(e), bf(e);
        return;
      }
      const a = document.getSelection(), l = a == null ? void 0 : a.anchorNode;
      if (r === "insertText" && l && ((c = l.textContent) == null ? void 0 : c.length) === 1) {
        const d = this.getBlockLevelParent(l);
        if (
          // if the parent element is `ol` or `ul`, and if it has direction, do not change it
          (d.tagName === "UL" || d.tagName === "OL") && d.hasAttribute("dir")
        )
          return;
        d.setAttribute("dir", "auto");
        const h = window.getComputedStyle(d).direction;
        d.setAttribute("dir", h), d.style.textAlign = "";
      }
    });
    f(this, "handleKeyUp", () => {
      const { keyDownHandled: t } = this.state;
      t || this.handleSelectionChange(), this.setState({
        keyDownHandled: !1
      });
    });
    f(this, "setKeyDownHandled", (t) => {
      t.preventDefault(), this.setState({
        keyDownHandled: !0
      });
    });
    f(this, "addKeyCommands", (t) => {
      this.setState(({ keyCommands: e }) => ({
        keyCommands: [...e, ...t]
      }));
    });
    f(this, "updateKeyCommandsKeybindings", (t) => {
      if (!t)
        return;
      const { keyCommands: e } = this.state;
      Object.entries(t).forEach(([n, r]) => {
        const a = e.findIndex(
          ({ name: l }) => l === n
        );
        a > -1 && r && (e[a].keybindings = r);
      });
    });
    f(this, "handlePaste", (t) => {
      const {
        onFileDropped: e,
        allowInlineAttachments: n,
        editorWindow: r = window,
        sanitize: a
      } = this.props, { clipboardData: l } = t;
      if (!l)
        return;
      let c = l.getData("text/html");
      const d = l.getData("text/plain"), h = l.files.item(0);
      if (c) {
        t.preventDefault(), this.commandRun("insertHTML", a == null ? void 0 : a(c));
        return;
      }
      if (d && py.test(d)) {
        t.preventDefault(), c = `<a href="${d}">${d}</a>`, this.commandRun("insertHTML", c);
        return;
      }
      if (h) {
        if (n && e) {
          const { src: u, uid: p } = Uo(r, h);
          this.insertImageLoader(u, p), e(h, p);
        }
        t.preventDefault();
      }
    });
    f(this, "getText", () => {
      const { current: t } = this.editorRef;
      return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
    });
    f(this, "getSanitizedHtml", () => {
      var t, e;
      return (e = (t = this.props).sanitize) == null ? void 0 : e.call(t, this.getText());
    });
    f(this, "getPlainText", () => {
      const { current: t } = this.editorRef, e = (
        // innerHTML of <div></div> should count as empty
        t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
      );
      return e ? e.replace(/\n\n/g, `
`).trim() : "";
    });
    f(this, "handleInlineUpload", (t) => {
      if (t === null) return;
      const { onFileDropped: e, editorWindow: n = window } = this.props;
      t && e && Array.from(t).forEach((a) => {
        if (ff(a)) {
          const { src: l, uid: c } = Uo(n, a);
          this.insertImageLoader(l, c), e(a, c);
        } else {
          const l = cn();
          this.insertFileLoader(a.name, l), e(a, l);
        }
      });
    });
    f(this, "handleAttachmentUpload", (t) => {
      const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
      n && n.open(), t && typeof e == "function" && Array.from(t).forEach((a) => {
        const l = cn();
        e(a, l);
      });
    });
    f(this, "handleDetachAttachmentFile", (t) => {
      const { onDetachAttacmentFile: e } = this.props;
      typeof e == "function" && e(t);
    });
    f(this, "handleFileSelect", (t) => {
      var n;
      const e = t.target;
      (n = e == null ? void 0 : e.ownerDocument) != null && n.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
    });
    f(this, "openFileBrowser", (t) => {
      t == null || t.preventDefault();
      const { current: e } = this.fileInputRef;
      e && e.click();
    });
    f(this, "handleToggleSendOnEnter", (t) => {
      t.preventDefault();
      const { onToggleSendOnEnter: e } = this.props;
      e();
    });
    f(this, "handleToggleAutocompleteSuggestions", (t) => {
      t.preventDefault();
      const { autocomplete: e } = this.props;
      e && e.onToggleShowAutocompleteSuggestions();
    });
    f(this, "insertContent", (t, e) => {
      this.contentInsertionQueue.push(t), e != null && e.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
        this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
      }));
    });
    f(this, "processContentInsertionQueue", (t) => {
      if (!(!t || !this.isSelectionWithinEditor(t))) {
        if (yf(t), t != null && t.rangeCount && (t == null ? void 0 : t.rangeCount) > 0) {
          const e = t.getRangeAt(0);
          if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
            e.insertNode(this.contentInsertionQueue[0]);
          else if (this.contentInsertionQueue.length > 1) {
            const n = document.createElement("span");
            this.contentInsertionQueue.forEach((r) => {
              n.appendChild(r);
            }), e.insertNode(n);
          }
        }
        this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
          t.collapseToEnd();
        }), this.handleSelectionChange();
      }
    });
    f(this, "handleFocus", () => {
      const { editorWindow: t = window } = this.props;
      this.setState({
        hasFocus: !0
      }), t.document.addEventListener(
        "selectionchange",
        this.handleSelectionChange
      );
    });
    f(this, "handleBlur", (t) => {
      const { editorWindow: e = window } = this.props, n = e.getSelection(), r = () => n != null && n.rangeCount && (n == null ? void 0 : n.rangeCount) > 0 ? n.getRangeAt(0) : null;
      this.setState({
        lastSelection: r(),
        hasFocus: !1
      }), e.document.removeEventListener(
        "selectionchange",
        this.handleSelectionChange
      ), this.handleBlurListeners(t);
    });
    f(this, "focus", () => {
      const { current: t } = this.editorRef, { hasFocus: e } = this.state;
      t && (e || t.focus());
    });
    f(this, "lastExtractedContent", W());
    f(this, "canUndo", () => this.state.undoStack.length > 0);
    f(this, "undo", () => {
      const { undoStack: t } = this.state;
      if (t.length > 0) {
        const e = t[t.length - 1];
        this.setHtml(e), this.setState({
          undoStack: t.slice(0, -1)
        });
      }
    });
    f(this, "resetUndoStack", () => {
      this.setState({
        undoStack: []
      });
    });
    f(this, "addCurrentContentToUndoStack", () => {
      this.setState({
        // To prevent undo stack from growing indefinitely, we only keep a finite amount
        undoStack: [...this.state.undoStack.slice(-50), this.getText()]
      });
    });
    this.editorRef = W(), this.currentSuggestionRef = W(), this.fileInputRef = W(), this.attachmentDropdownButtonRef = W(), this.unsubscribeInlineAttachment = O, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: nr,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new _a(),
      ref: this.editorRef,
      window: this.props.editorWindow ?? window,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const { editorWindow: t = window, onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    var c;
    const { fileUploadStatuses: e, autocomplete: n, keybindings: r, uiBlocker: a } = this.props, { current: l } = this.editorRef;
    e && e !== t.fileUploadStatuses && l && (Object.keys(e).forEach((d) => {
      this.updateFileLoader(d, e[d]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== ((c = t.autocomplete) == null ? void 0 : c.showAutocompleteSuggestions) && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), Nr(t.keybindings, r) || this.updateKeyCommandsKeybindings(r), t.uiBlocker !== a && this.setUiBlocker(a);
  }
  componentWillUnmount() {
    var e;
    const { onUnmount: t } = this.props;
    (e = this.unsubscribeInlineAttachment) == null || e.call(this), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return nr.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => Pr(n, t));
    };
  }
  publish(t) {
    var e;
    (e = this.state.pubsub[t]) == null || e.forEach((n) => n(this.editor));
  }
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: r } = this.editorRef, { editorWindow: a = window } = this.props;
      r && (n || this.recreateSelection(), a.document.execCommand(
        t,
        !1,
        // execCommand 3rd expects string | null, TS thinks it needs string | undefined
        e
      ));
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, { editorWindow: n = window } = this.props;
    return !!(e && mf(n, t));
  }
  setHtml(t) {
    var r, a;
    const { current: e } = this.editorRef, n = (a = (r = this.props).sanitize) == null ? void 0 : a.call(r, t);
    e && (e.innerHTML = n || "", qo(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  insertImageLoader(t, e) {
    const { editorWindow: n = window } = this.props, r = n.document.createElement("img");
    r.setAttribute("class", "async-loading"), r.setAttribute("data-uid", e), r.setAttribute("src", t), this.insertContent(r);
  }
  insertFileLoader(t, e) {
    const { editorWindow: n = window } = this.props, r = n.document.createElement("a");
    r.setAttribute("class", "async-loading"), r.setAttribute("data-uid", e), r.setAttribute("href", "#"), r.innerText = t, this.insertContent(r);
  }
  updateFileLoader(t, { link: e, status: n }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${t}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), e && a instanceof HTMLImageElement && (a.src = e), e && a instanceof HTMLAnchorElement && (a.href = e)));
    }
  }
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const r = `.${wt.editor}`;
    let a = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(r) : !1;
    for (; !a && n !== null; ) {
      if (n.matches(r)) {
        a = !0;
        break;
      }
      n = n.parentElement;
    }
    return a;
  }
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const { editorWindow: t = window } = this.props;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e != null && e.rangeCount && (e == null ? void 0 : e.rangeCount) > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection() {
    const { current: t } = this.editorRef, { hasFocus: e, lastSelection: n } = this.state, { editorWindow: r = window } = this.props, a = r.getSelection();
    return t && !e && (t.focus(), n && a && (a.removeAllRanges(), a.addRange(n))), a;
  }
  hasContent(t) {
    return t != null && t.length ? !t.match(
      /^\s*<br>\s*$|^<[A-z\s="0-9]*>\s*(<br>\s*)?<\/[A-z\s="0-9]*>$/
    ) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? uf : [];
  }
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, r = (n == null ? void 0 : n.innerHTML) ?? "";
    if (!t)
      return r;
    if (r === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const a = t(n);
    return this.lastExtractedContent.current = (e == null ? void 0 : e(a)) ?? a, this.lastExtractedContent.current;
  }
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: r,
      sendOnEnter: a,
      placeholder: l,
      allowInlineAttachments: c,
      allowAttachments: d,
      attachmentsFields: h,
      attachments: u,
      isAttachmentsUploading: p,
      hideSendOnEnterToggle: m,
      editorWindow: g = window,
      languages: y,
      disabled: x,
      status: C,
      onError: _,
      icon: w,
      prefix: S,
      suffix: v,
      id: T,
      autocomplete: D,
      toolbarAddons: E
    } = this.props, { htmlOld: F, uiBlocker: P } = this.state, I = b(wt.root, t);
    return /* @__PURE__ */ o.jsx(Fe.Context.Provider, { value: this.editor, children: /* @__PURE__ */ o.jsx(
      Et,
      {
        status: C,
        icon: w,
        prefix: S,
        suffix: v,
        disabled: x,
        className: b(wt.inputWrapper, e),
        children: /* @__PURE__ */ o.jsxs("div", { className: I, children: [
          /* @__PURE__ */ o.jsxs(
            fa,
            {
              className: wt.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(u) ? u : [],
              allowInlineAttachments: c,
              allowAttachments: d,
              children: [
                /* @__PURE__ */ o.jsx(
                  "div",
                  {
                    id: T,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    className: wt.editor,
                    "data-testid": Ca,
                    contentEditable: !0
                  }
                ),
                !this.hasContent(F) && !!l && /* @__PURE__ */ o.jsx("span", { role: "presentation", className: wt.placeholder, children: l })
              ]
            }
          ),
          /* @__PURE__ */ o.jsxs("div", { className: wt.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
              /* @__PURE__ */ o.jsx(
                sy,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: g
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ o.jsx(yb, { editor: this.editor })
            ] }),
            c && /* @__PURE__ */ o.jsx(
              Pt,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser
              }
            ),
            d && /* @__PURE__ */ o.jsx(
              Wf,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(u) ? u : [],
                isAttachmentsUploading: p,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: g,
                editor: this.editor,
                children: h
              }
            ),
            /* @__PURE__ */ o.jsx(tb, { "data-tip": "Emojis", editor: this.editor }),
            !!r && !!n && /* @__PURE__ */ o.jsx(
              qb,
              {
                languages: y,
                renderQuickResponse: n,
                quickResponsesApi: r,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            D && D.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ o.jsx(
              Pt,
              {
                isActive: D.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete"
              }
            ),
            E,
            !m && /* @__PURE__ */ o.jsx(
              Pt,
              {
                isActive: a,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter"
              }
            ),
            D ? /* @__PURE__ */ o.jsxs(
              "span",
              {
                className: b(wt.toolbarHint, {
                  [wt.toolbarHintVisible]: this.state.showHint,
                  [wt.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  D.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ o.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: wt.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ o.jsx(dy, { editor: this.editor, onError: _ }),
          /* @__PURE__ */ o.jsx(jf, { editor: this.editor }),
          P && /* @__PURE__ */ o.jsx("div", { className: wt.uiBlocker, children: P })
        ] })
      }
    ) });
  }
};
/**
 * Button that can be used in `toolbarAddons` to have same styles as the
 * buitlin buttons.
 */
f(Fe, "ToolbarButton", Pt), /** Context containing props and methods to interact with the editor. */
f(Fe, "Context", my), f(Fe, "defaultProps", {
  allowAttachments: !1,
  allowInlineAttachments: !1,
  languages: [],
  onTriggerSend() {
    console.warn("InputRichText: onTriggerSend callback missing in props");
  },
  onToggleSendOnEnter: O,
  sendOnEnter: !1,
  editorWindow: window,
  onMount: O,
  onUnmount: O,
  disabled: !1,
  hasAutocompleteSuggestionsFeature: !1
});
let to = Fe;
const gy = "h-textarea--textarea__inputWrapper", fy = "h-textarea--textarea__input", sr = {
  inputWrapper: gy,
  input: fy
}, by = "textarea", wa = z(function(s, t) {
  const e = Z(null), {
    className: n,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p,
    style: m,
    ...g
  } = s, y = { ...m, height: p };
  return /* @__PURE__ */ o.jsx(
    Et,
    {
      className: sr.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ o.jsx(
        "textarea",
        {
          "data-testid": by,
          className: sr.input,
          dir: "auto",
          id: l,
          ...g,
          ref: e,
          style: y,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), yy = "h-fieldRichText--fieldRichText__editorContainer", xy = "h-fieldRichText--fieldRichText__fallbackTextArea", or = {
  editorContainer: yy,
  fallbackTextArea: xy
};
class _y extends k {
  render() {
    const {
      className: s,
      input: t,
      label: e,
      meta: n,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: e,
        labelFor: t.name,
        meta: n,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ o.jsx(
          mn,
          {
            fallback: /* @__PURE__ */ o.jsx(
              wa,
              {
                ...t,
                className: or.fallbackTextArea,
                disabled: a,
                value: t.value,
                onChange: (p) => t.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ o.jsx("div", { className: or.editorContainer, children: /* @__PURE__ */ o.jsx(
              to,
              {
                disabled: a,
                status: V.getStatus(n),
                ...t,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: O
              }
            ) })
          }
        )
      }
    );
  }
}
f(_y, "defaultProps", {
  allowFormatting: !0
});
class JD extends k {
  constructor(s) {
    super(s), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: s },
      items: t
    } = this.props;
    return typeof s == "string" && (t != null && t.some((e) => e.id === s)) ? [s] : Array.isArray(s) && s.length && (t != null && t.some((e) => s.some((n) => n === e.id))) ? s : [];
  }
  handleSelect(s) {
    const {
      input: { onChange: t }
    } = this.props;
    typeof t == "function" && t(s === null ? "" : s.id.toString());
  }
  handleClear() {
    const {
      input: { value: s },
      onClear: t
    } = this.props;
    typeof s == "string" && this.handleSelect(null), typeof t == "function" && t();
  }
  render() {
    const {
      className: s,
      input: t,
      meta: e,
      label: n,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: n,
        labelFor: t.name,
        meta: e,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ o.jsx(
          dn,
          {
            ...u,
            id: t.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: V.getStatus(e)
          }
        )
      }
    );
  }
}
function va(i, s = "") {
  return Ht.toArray(i).reduce((t, e) => Lt(e) ? e.type === Mt ? [
    ...t,
    ...va(e.props.children, e.key)
  ] : [...t, { ...e, key: `${s}${e.key}` }] : t, []);
}
const gs = (i) => G(() => va(i), [i]), Cy = "h-selectionList--selectionList__root", wy = "h-selectionList--selectionList__disabled", rr = {
  root: Cy,
  disabled: wy
}, Ae = ci(
  () => Wt({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: O,
      register: O,
      isSelected: () => !1,
      onSelect: O,
      isOnlyVisibleItem: !1
    }
  })
), yo = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [s, t] = U(!1), [e, n] = U(-1), [r, a] = U([]), [l, c] = U({}), d = L(
    ({
      isActivatable: g,
      isLastChild: y,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: C
    }, _) => {
      g !== void 0 && a((w) => {
        const S = g ? [...w, _].sort((v, T) => v - T) : w.filter((v) => v !== _);
        return y && n((v) => (S.includes(_) && !w.includes(_) || _ !== v) && S.includes(v) && _ !== S[i] ? v : S[i] ?? S[0] ?? v), S;
      }), x !== void 0 && t(x), C !== void 0 && c((w) => ({
        ...w,
        [_]: C
      }));
    },
    [i]
  ), h = L(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (y) => y === e
    ) + g.step + r.length) % r.length],
    [r, e]
  ), u = L(
    (g) => {
      n(h(g));
    },
    [h]
  );
  at(() => {
    (e < 0 || e === void 0) && n(r[i]);
  }, [e, r, i]);
  const p = G(
    () => l[e] ?? [],
    [e, l]
  );
  return G(
    () => ({
      activeItemIndex: e,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: s,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      e,
      h,
      d,
      s,
      p,
      u
    ]
  );
}, ar = ({
  className: i,
  selectedValues: s = [],
  isActive: t,
  isDisabled: e,
  isMultiple: n = !1,
  onChange: r = O,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = U(!1), [g, y] = U({ isActive: !!t, source: "parent" }), x = Ae(), {
    activeItemIndex: C,
    setActiveItem: _,
    handleItemRegister: w,
    isOnlyActiveItemVisible: S,
    keysDelegatedHandlingToItem: v
  } = yo({ defaultActiveItemIndex: c }), T = gs(d), D = L(
    (I) => I !== void 0 && s.some((j) => a(j, I)),
    [a, s]
  ), E = L(
    ({ value: I, meta: j }, A) => {
      _({ index: A }), I !== void 0 && r(n ? {
        selectedValues: D(I) ? s.filter(
          (K) => !a(K, I)
        ) : [...s, I],
        selectedItem: {
          isNode: j == null ? void 0 : j.isNode,
          isSelected: !D(I),
          value: I
        },
        event: j == null ? void 0 : j.event
      } : {
        selectedValues: [I],
        selectedItem: {
          isNode: j == null ? void 0 : j.isNode,
          isSelected: !0,
          value: I
        },
        event: j == null ? void 0 : j.event
      });
    },
    [
      a,
      D,
      n,
      r,
      s,
      _
    ]
  ), F = G(
    () => !e && (g.isActive || p),
    [e, g.isActive, p]
  ), P = (I) => {
    !F || v.includes(I.key) || (I.key === "Enter" ? I.preventDefault() : I.key === "Home" ? (_({ step: "first" }), I.preventDefault()) : I.key === "End" ? (_({ step: "last" }), I.preventDefault()) : I.key === "ArrowDown" ? (_({ step: 1 }), I.preventDefault()) : I.key === "ArrowUp" && (_({ step: -1 }), I.preventDefault()));
  };
  return at(() => {
    y({ isActive: !!t, source: "parent" });
  }, [t]), fn("keydown", P), /* @__PURE__ */ o.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: e || t ? -1 : l,
      ...h,
      className: b(i, rr.root, {
        [rr.disabled]: e
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && y({ isActive: !1, source: "self" });
      },
      children: T.map(
        (I, j) => Lt(I) && (!S || j === C) && /* @__PURE__ */ o.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: n,
                isActive: g.isActive,
                isDisabled: e
              },
              item: {
                isActive: F && j === C,
                setActive: () => {
                  y({ isActive: !0, source: "child" }), _({ index: j });
                },
                register: (A) => w(A, j),
                isSelected: D,
                onSelect: (A) => E(A, j),
                isOnlyVisibleItem: S,
                isLastChild: j === T.length - 1
              }
            },
            children: I
          },
          j
        )
      )
    }
  );
}, ir = ({ className: i, label: s, ...t }, e) => {
  const {
    item: { register: n, isLastChild: r }
  } = Jt(Ae());
  return Le(() => {
    n({ isActivatable: !1, isLastChild: r });
  }), te(() => {
    n({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ o.jsx(
    io,
    {
      ref: e,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...t,
      children: /* @__PURE__ */ o.jsx(B.Paragraph, { as: "span", variant: "4", color: "secondary", children: s })
    }
  );
}, Sa = Object.assign(z(ir), {
  name: ir.name
}), vy = "h-selectionList-subComponents-item--selectionListItem__root", Sy = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", Iy = "h-selectionList-subComponents-item--selectionListItem__rootActive", ky = "h-selectionList-subComponents-item--selectionListItem__selectionState", Dy = "h-selectionList-subComponents-item--selectionListItem__fixedSize", Ty = "h-selectionList-subComponents-item--selectionListItem__content", jy = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", ae = {
  root: vy,
  rootDisabled: Sy,
  rootActive: Iy,
  selectionState: ky,
  fixedSize: Dy,
  content: Ty,
  contentDisabled: jy
}, lr = ({
  value: i,
  isDisabled: s = !1,
  isIndeterminate: t = !1,
  className: e,
  contentClassName: n,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: y
    },
    item: {
      register: x,
      isSelected: C,
      onSelect: _,
      isActive: w,
      isNode: S = !1,
      isLastChild: v = !1,
      setActive: T
    }
  } = Jt(Ae()), D = C(i), E = G(
    () => !m && (g || y),
    [g, m, y]
  ), F = G(
    () => !s && w && E,
    [w, s, E]
  ), P = Z(null);
  pn(
    u,
    () => P.current
  );
  const I = L(
    ($) => {
      !s && !m && (c == null || c({ value: i, meta: { target: $ == null ? void 0 : $.target } }), _({
        value: i,
        meta: {
          target: $ == null ? void 0 : $.target,
          event: $ || void 0
        }
      }));
    },
    [s, m, c, _, i]
  ), j = L(
    ($) => {
      F && $.key === "Enter" && I($);
    },
    [F, I]
  );
  at(() => {
    var $;
    w && E && (($ = P.current) == null || $.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    }));
  }, [w]);
  const A = L(
    () => ({
      isActive: w,
      isSelected: D,
      isLastChild: v,
      isNode: S,
      value: i
    }),
    [w, v, S, D, i]
  ), K = ln(w), rt = ln(D);
  Zt(() => {
    w !== K && (a == null || a(A())), D !== rt && (l == null || l(A()));
  }, [
    A,
    w,
    D,
    a,
    l,
    K,
    rt
  ]), fn("keydown", j), at(() => (x({ isActivatable: !s, isLastChild: v }), () => x({ isActivatable: !1, isLastChild: v })), [s]);
  const J = !p && D || p && i !== void 0 || !r;
  return /* @__PURE__ */ o.jsxs(
    "li",
    {
      ref: P,
      role: "option",
      "aria-selected": D,
      "aria-disabled": s,
      onClick: I,
      onMouseMove: T,
      className: b(ae.root, e, {
        [ae.rootActive]: F,
        [ae.rootDisabled]: s
      }),
      ...h,
      children: [
        J && /* @__PURE__ */ o.jsxs(
          M,
          {
            className: b(ae.selectionState, {
              [ae.fixedSize]: !r
            }),
            children: [
              !p && D && /* @__PURE__ */ o.jsx(R, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ o.jsx(
                bn,
                {
                  checked: D,
                  indeterminate: !D && t,
                  disabled: s,
                  onChange: O,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o.jsx(
          lt,
          {
            className: b(ae.content, n, {
              [ae.contentDisabled]: s
            }),
            children: d
          }
        ),
        S && /* @__PURE__ */ o.jsx(R, { name: "angle-right" })
      ]
    }
  );
}, Ny = Object.assign(z(lr), {
  name: lr.name
}), Fy = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", Py = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", cr = {
  root: Fy,
  rootActive: Py
}, dr = ({
  className: i,
  content: s,
  onActiveStateChange: t,
  onSelected: e,
  ...n
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Jt(Ae()), m = G(
    () => !a && (l || c),
    [l, a, c]
  ), g = G(
    () => h && m,
    [h, m]
  ), y = Z(null);
  pn(
    r,
    () => y.current
  );
  const x = L(() => {
    u({}), e == null || e();
  }, [u, e]), C = L(
    (w) => {
      !g || a || w.key === "Enter" && x();
    },
    [x, g, a]
  );
  at(() => {
    var w;
    h && m && ((w = y.current) == null || w.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    }));
  }, [h]);
  const _ = ln(h);
  return Zt(() => {
    h !== _ && (t == null || t({ isActive: h }));
  }, [h, t, _]), fn("keydown", C), Le(() => {
    d({ isActivatable: !0 });
  }), te(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ o.jsx(
    "li",
    {
      ref: y,
      role: "navigation",
      className: b(cr.root, i, {
        [cr.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...n,
      children: s || /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(R, { name: "angle-left" }),
        /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, Ia = Object.assign(
  z(dr),
  {
    name: dr.name
  }
), Ry = "h-selectionList-subComponents-list--selectionListList__list", Ly = {
  list: Ry
}, hr = ({
  parentItem: i,
  children: s,
  backItemProps: t = {},
  listProps: { className: e, ...n } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Ae(), d = Jt(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: y,
      register: x,
      setActive: C,
      isLastChild: _ = !1
    }
  } = d, w = G(
    () => !p && (u || h),
    [u, p, h]
  ), S = gs(s), {
    activeItemIndex: v,
    setActiveItem: T,
    handleItemRegister: D,
    isOnlyActiveItemVisible: E,
    keysDelegatedHandlingToItem: F
  } = yo({ defaultActiveItemIndex: 1 }), P = L(
    ($, ot) => {
      T({ index: ot }), g($);
    },
    [g, T]
  ), I = ($) => {
    !w || !y || F.includes($.key) || ($.key === "Home" ? (T({ step: "first" }), $.preventDefault()) : $.key === "End" ? (T({ step: "last" }), $.preventDefault()) : $.key === "ArrowDown" ? (T({ step: 1 }), $.preventDefault()) : $.key === "ArrowUp" && (T({ step: -1 }), $.preventDefault()));
  }, j = ln(
    y
  );
  Zt(() => {
    y !== j && (r == null || r({
      isActive: y,
      isLastChild: _
    }));
  }, [
    y,
    r,
    j
  ]), at(() => {
    x(y ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [y]), fn("keydown", I);
  const A = L(
    ({ value: $, meta: ot }) => {
      (ot == null ? void 0 : ot.target) instanceof HTMLInputElement && ot.target.type === "checkbox" ? g({ value: $, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), K = L(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  at(() => {
    y || T({ index: -1 });
  }, [y, T]);
  const rt = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: A,
        isNode: !0
      }
    }),
    [A, d]
  ), J = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: K,
        isActive: v === 0,
        setActive: () => {
          C(), T({ index: 0 });
        },
        register: ($) => D($, 0)
      }
    }),
    [
      v,
      K,
      D,
      d,
      C,
      T
    ]
  );
  return y ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    !E && /* @__PURE__ */ o.jsx(c.Provider, { value: J, children: /* @__PURE__ */ o.jsx(Ia, { ...t }) }),
    /* @__PURE__ */ o.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ o.jsx(
      "ul",
      {
        role: "listbox",
        className: b(Ly.list, e),
        ...n,
        children: S.map(($, ot) => {
          const ut = ot + 1;
          return Lt($) && (!E || ut === v) && /* @__PURE__ */ o.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && ut === v,
                  setActive: () => {
                    C(), T({ index: ut });
                  },
                  register: (Vt) => D(Vt, ut),
                  onSelect: (Vt) => P(Vt, ut),
                  isOnlyVisibleItem: E,
                  isLastChild: ot === S.length - 1
                }
              },
              children: $
            },
            ot
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ o.jsx(c.Provider, { value: rt, children: i });
}, Ey = Object.assign(z(hr), {
  name: hr.name
}), $y = "h-selectionList-subComponents-section--selectionListSection__section", Ay = {
  section: $y
}, ur = ({
  title: i,
  children: s,
  listProps: { className: t, ...e } = {},
  onActiveStateChange: n,
  ...r
}, a) => {
  const l = Ae(), c = Jt(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: y,
      isLastChild: x = !1
    }
  } = c, C = G(
    () => !u && (h || d),
    [h, u, d]
  ), _ = gs(s), {
    activatableItemIndices: w,
    activeItemIndex: S,
    setActiveItem: v,
    handleItemRegister: T,
    keysDelegatedHandlingToItem: D
  } = yo(), E = L(
    (I, j) => {
      v({ index: j }), g(I);
    },
    [g, v]
  ), F = (I) => {
    !C || D.includes(I.key) || (I.key === "Home" ? v({ step: "first" }) : I.key === "End" && v({ step: "last" }), p ? I.key === "ArrowDown" && S !== w[w.length - 1] ? (v({ step: 1 }), I.preventDefault()) : I.key === "ArrowUp" && S !== w[0] && (v({ step: -1 }), I.preventDefault()) : I.key === "ArrowDown" ? v({ step: "first" }) : I.key === "ArrowUp" && v({ step: "last" }));
  }, P = ln(p);
  return Zt(() => {
    p !== P && (n == null || n({
      isActive: p,
      isLastChild: x
    }));
  }, [p, n, P]), at(() => {
    const I = [];
    p && (S !== w[w.length - 1] && I.push("ArrowDown"), S !== w[0] && I.push("ArrowUp")), y({ keysTakenOverHandlingFromParent: I });
  }, [w, S, p]), Le(() => y({ isActivatable: !0 })), te(() => y({ isActivatable: !1 })), fn("keydown", F), /* @__PURE__ */ o.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ o.jsxs(
    "ul",
    {
      role: "group",
      className: b(Ay.section, t),
      ...e,
      children: [
        /* @__PURE__ */ o.jsx(Sa, { label: i }),
        _.map(
          (I, j) => Lt(I) && /* @__PURE__ */ o.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && j === S,
                  setActive: () => {
                    m(), v({ index: j });
                  },
                  register: (A) => T(A, j),
                  onSelect: (A) => E(A, j),
                  isLastChild: x && j === _.length - 1
                }
              },
              children: I
            },
            j
          )
        )
      ]
    }
  ) });
}, Oy = Object.assign(z(ur), {
  name: ur.name
}), By = Object.assign(z(ar), {
  name: ar.name,
  Item: Ny,
  BackItem: Ia,
  Divider: Sa,
  Section: Oy,
  List: Ey
}), Hy = "h-inputSelectionList-chip--inputSelectionListChip__root", Wy = "h-inputSelectionList-chip--inputSelectionListChip__name", pr = {
  root: Hy,
  name: Wy
}, Es = ({
  onDelete: i,
  className: s,
  disabled: t,
  readOnly: e,
  ...n
}) => {
  const r = G(() => {
    if (!(!i || t || e))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [t, i, e]);
  return /* @__PURE__ */ o.jsx(
    Re,
    {
      ...n,
      onDelete: r,
      className: b(pr.root, s),
      tagNameClassName: pr.name
    }
  );
}, My = "h-inputSelectionList--inputSelectionList__root", zy = "h-inputSelectionList--inputSelectionList__inputWrapper", Vy = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Ky = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Uy = "h-inputSelectionList--inputSelectionList__rootReadOnly", qy = "h-inputSelectionList--inputSelectionList__titleContainer", Gy = "h-inputSelectionList--inputSelectionList__filterInput", Yy = "h-inputSelectionList--inputSelectionList__placeholder", Qy = "h-inputSelectionList--inputSelectionList__titleBox", Xy = "h-inputSelectionList--inputSelectionList__iconContainer", Jy = "h-inputSelectionList--inputSelectionList__iconButton", Zy = "h-inputSelectionList--inputSelectionList__dropdown", tx = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", ex = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", dt = {
  root: My,
  inputWrapper: zy,
  inputWrapperChild: Vy,
  rootHasWrapperIcon: Ky,
  rootReadOnly: Uy,
  titleContainer: qy,
  filterInput: Gy,
  placeholder: Yy,
  titleBox: Qy,
  iconContainer: Xy,
  iconButton: Jy,
  dropdown: Zy,
  hiddenItemsTooltip: tx,
  hiddenItemsChip: ex
}, nx = "inputSelectionListTestId", mr = ({
  className: i,
  name: s,
  value: t,
  onChange: e,
  prefix: n,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: y,
  keepOpen: x,
  onToggleDropdown: C,
  onClick: _,
  onBlur: w,
  onKeyDown: S,
  limit: v = Number.POSITIVE_INFINITY,
  clearable: T = !1,
  equalityFn: D = Object.is,
  defaultActiveItemIndex: E,
  valueArrayToStringFn: F = JSON.stringify,
  rootClassName: P,
  dropdownProps: I,
  selectionListProps: j,
  slotBeforeList: A,
  slotAfterList: K,
  ...rt
}, J) => {
  const $ = Z(null), ot = Z(null), ut = Z(null), Vt = Z(null), [Q, Cn] = U(!1);
  pn(
    J,
    () => ot.current
  );
  const fs = G(
    () => (p == null ? void 0 : p.value) !== void 0 && p.onChange !== void 0 && Q,
    [p, Q]
  ), Na = G(() => {
    if (!(t != null && t.length))
      return c;
    if (!m) {
      const H = g(t[0]);
      return typeof H == "object" ? "" : H == null ? void 0 : H.toString();
    }
    return "";
  }, [m, c, g, t]), Fa = G(() => fs ? m && !!(t != null && t.length) : !0, [m, fs, t == null ? void 0 : t.length]), bs = L(
    (H) => {
      !h && !d && (e == null || e({
        selectedItem: {
          isSelected: !1,
          value: H
        },
        selectedValues: (t == null ? void 0 : t.filter((q) => !D(q, H))) ?? []
      }));
    },
    [d, D, e, h, t]
  ), Pa = G(() => {
    if (!(t != null && t.length))
      return /* @__PURE__ */ o.jsx(M, { alignItems: "center", className: dt.placeholder, children: c });
    if (m) {
      const H = v < t.length ? t.slice(0, v) : t, q = v < t.length ? t.slice(v) : [];
      return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        H == null ? void 0 : H.map((St, he) => /* @__PURE__ */ o.jsx(
          Es,
          {
            onDelete: () => {
              bs(St);
            },
            disabled: d,
            readOnly: h,
            children: g(St)
          },
          he
        )),
        !!q.length && /* @__PURE__ */ o.jsx(
          yt,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ o.jsx(
              M,
              {
                className: dt.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: q == null ? void 0 : q.map((St, he) => /* @__PURE__ */ o.jsx(
                  Es,
                  {
                    onDelete: () => {
                      bs(St);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(St)
                  },
                  he
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ o.jsxs(
              Es,
              {
                className: dt.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  q.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ o.jsx(lt, { className: dt.titleBox, children: g(t[0]) });
  }, [
    t,
    m,
    g,
    c,
    v,
    d,
    h,
    bs
  ]), pt = L(
    (H) => {
      (h || d) && H || (H !== Q && (C == null || C(H)), Cn(H));
    },
    [d, Q, C, h]
  ), Oe = L(
    ({ target: H }) => {
      var q, St, he;
      (q = Vt.current) != null && q.contains(H) || ((St = $.current) != null && St.contains(H) && ((he = ot.current) == null || he.focus()), pt(!1));
    },
    [pt]
  ), Be = L(
    (H) => {
      var q;
      Ee(H.key) && Q && (pt(!1), (q = ot.current) == null || q.focus());
    },
    [Q, pt]
  ), Ra = L(
    (H) => {
      var q;
      H.relatedTarget && ((q = $.current) != null && q.contains(H.relatedTarget)) || (pt(!1), w == null || w(H));
    },
    [w, pt]
  ), La = L(
    (H) => {
      Q || H.stopPropagation(), pt(!0), _ == null || _(H);
    },
    [Q, _, pt]
  ), Ea = L(
    (H) => {
      is(H.key) && pt(!0), S == null || S(H);
    },
    [S, pt]
  ), $a = L(
    (H) => {
      var q;
      H.stopPropagation(), pt(!Q), (q = ot.current) == null || q.focus();
    },
    [Q, pt]
  ), Aa = L(
    (H) => {
      var q;
      H.stopPropagation(), (q = ot.current) == null || q.focus(), !d && !h && (e == null || e({ selectedValues: [] }));
    },
    [d, e, h]
  ), Oa = L(
    (H) => {
      var q, St;
      e == null || e(H), (q = ot.current) == null || q.focus(), !x && !m ? pt(!1) : (St = ut.current) == null || St.focus();
    },
    [m, x, e, pt]
  );
  return at(() => (Q ? (window.addEventListener("click", Oe), window.addEventListener("keydown", Be)) : (window.removeEventListener("click", Oe), window.removeEventListener("keydown", Be)), () => {
    window.removeEventListener("click", Oe), window.removeEventListener("keydown", Be);
  }), [Oe, Be, Q]), at(() => {
    var H;
    Q && ((H = ut.current) == null || H.focus());
  }, [Q]), te(() => {
    window.removeEventListener("click", Oe), window.removeEventListener("keydown", Be);
  }), /* @__PURE__ */ o.jsxs(
    "div",
    {
      "data-testid": nx,
      ref: $,
      className: b(dt.root, P, {
        [dt.rootHasWrapperIcon]: !!a,
        [dt.rootReadOnly]: h
      }),
      "aria-expanded": Q,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ o.jsx(
          Et,
          {
            ...rt,
            ref: ot,
            className: b(i, dt.inputWrapper),
            prefix: n,
            suffix: r,
            disabled: d,
            icon: a,
            active: Q,
            status: l,
            onClick: La,
            onBlur: Ra,
            onKeyDown: Ea,
            tabIndex: d ? -1 : y ?? 0,
            children: /* @__PURE__ */ o.jsxs(M, { className: dt.inputWrapperChild, children: [
              /* @__PURE__ */ o.jsxs(M, { gap: "100", flexWrap: "wrap", className: dt.titleContainer, children: [
                Fa && Pa,
                fs && /* @__PURE__ */ o.jsx(
                  "input",
                  {
                    ...p,
                    ref: ut,
                    className: b(dt.filterInput, p == null ? void 0 : p.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: Na,
                    disabled: d || (p == null ? void 0 : p.disabled)
                  }
                )
              ] }),
              /* @__PURE__ */ o.jsxs(M, { alignItems: "center", className: dt.iconContainer, children: [
                T && !d && !h && !!(t != null && t.length) && /* @__PURE__ */ o.jsx(
                  st,
                  {
                    className: dt.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: Aa,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ o.jsx(
                  st,
                  {
                    className: dt.iconButton,
                    variant: "tertiary",
                    icon: Q ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: $a,
                    "aria-label": Q ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        s && /* @__PURE__ */ o.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: s,
            value: F(t)
          }
        ),
        /* @__PURE__ */ o.jsx(
          zt,
          {
            isOpen: Q,
            ...I,
            className: b(I == null ? void 0 : I.className, dt.dropdown),
            children: /* @__PURE__ */ o.jsx("div", { ref: Vt, style: { width: "100%" }, children: Q && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
              A,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ o.jsx(
                By,
                {
                  ...j,
                  equalityFn: D,
                  defaultActiveItemIndex: E,
                  isActive: Q,
                  isMultiple: m,
                  selectedValues: t,
                  onChange: Oa,
                  children: u
                }
              ),
              K
            ] }) })
          }
        )
      ]
    }
  );
}, sx = Object.assign(z(mr), {
  name: mr.name
}), ZD = ({
  className: i,
  input: { value: s, name: t, onChange: e, ...n },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ o.jsx(
  V,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ o.jsx(
      sx,
      {
        name: t,
        value: s || [],
        onChange: (g) => {
          e(g.selectedValues);
        },
        ...n,
        status: V.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), ox = "h-slider--slider__rootWrapper", rx = "h-slider--slider__rootWrapperNoAnnotations", ax = "h-slider--slider__root", ix = "h-slider--slider__rootDark", lx = "h-slider--slider__rootDisabled", cx = "h-slider--slider__handle", dx = "h-slider--slider__trackWrapper", hx = "h-slider--slider__track", ux = "h-slider--slider__highlight", px = "h-slider--slider__minValueIndicator", mx = "h-slider--slider__maxValueIndicator", _t = {
  rootWrapper: ox,
  rootWrapperNoAnnotations: rx,
  root: ax,
  rootDark: ix,
  rootDisabled: lx,
  handle: cx,
  trackWrapper: dx,
  track: hx,
  highlight: ux,
  minValueIndicator: px,
  maxValueIndicator: mx
};
var jt = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(jt || {});
const gx = (i) => {
  i.preventDefault();
}, fx = (i, s, t) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ o.jsxs(B.Paragraph, { variant: "3", children: [
  s,
  i,
  t
] }) : /* @__PURE__ */ o.jsxs(B.Paragraph, { variant: "3", children: [
  s,
  i[0],
  t,
  " - ",
  s,
  i[1],
  t
] });
class ka extends k {
  constructor(t) {
    super(t);
    f(this, "sliderRef", W());
    this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    var e, n, r, a;
    typeof t == "number" ? (n = (e = this.props).onChange) == null || n.call(e, Math.round(t)) : (a = (r = this.props).onChange) == null || a.call(
      r,
      t.map((l) => Math.round(l))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: r, currentIndex: a } = this.state, l = e + (t.clientX - n) / r, c = this.getAbsoluteValue(l, a);
    this.handleChange(c);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const r = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, r);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, r);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, r = this.sliderRef.current.getBoundingClientRect(), a = (t.clientX - r.left) / r.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: a,
      // save the current percentage
      sliderWidth: r.width
      // save the slider width
    });
    let l;
    if (this.isInterval(e)) {
      const c = n ?? this.findTheNearestHandle(a, e);
      this.setState({
        currentIndex: c
      }), l = this.getAbsoluteValue(a, c);
    } else
      l = this.getAbsoluteValue(a);
    this.handleChange(l), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, r] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > r && t > n ? 1 : t < r && t < n ? 0 : Math.abs(n - t) > Math.abs(r - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: r } = this.props;
    let a = Mn(t, 0, 1);
    if (r) {
      const u = this.getAdjustedStep(r);
      a = Math.round(a / u) * u;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(a);
    const [l, c] = n;
    let d = this.relativeValueToAbsoluteValue(a);
    e === 0 && d > c ? d = c : e === 1 && d < l && (d = l);
    const h = [l, c];
    return typeof e == "number" && (h[e] = d), h;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, r = e + (n - e) * t;
    return Mn(r, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, r = (t - e) / (n - e);
    return Mn(r, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let r;
    if (this.isInterval(n)) {
      const a = [...n];
      a[e ?? 0] = a[e ?? 0] + t, r = a;
    } else
      r = n + t;
    this.handleChange(r);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), r = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${r * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (vt(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: r,
      min: a,
      max: l,
      dark: c,
      disabled: d,
      onChange: h,
      formatValue: u,
      hideAnnotations: p,
      valuePrefix: m,
      valueSuffix: g,
      onBlur: y,
      onFocus: x,
      children: C,
      ..._
    } = this.props, w = b(
      _t.root,
      { [_t.rootDark]: c },
      { [_t.rootDisabled]: d },
      t
    );
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: b(_t.rootWrapper, {
          [_t.rootWrapperNoAnnotations]: p
        }),
        children: [
          /* @__PURE__ */ o.jsxs(
            "div",
            {
              ..._,
              className: w,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ o.jsxs(
                  "div",
                  {
                    className: _t.trackWrapper,
                    "data-testid": jt.TrackBackground,
                    children: [
                      !vt(r) && /* @__PURE__ */ o.jsx(
                        "div",
                        {
                          className: _t.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": jt.Highlight
                        }
                      ),
                      /* @__PURE__ */ o.jsx(
                        "div",
                        {
                          className: _t.track,
                          style: this.getTrackStyles(),
                          "data-testid": jt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ o.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": a,
                    "aria-valuemax": l,
                    "aria-valuenow": e,
                    className: _t.handle,
                    onClick: gx,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": jt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ o.jsxs(Mt, { children: [
                  /* @__PURE__ */ o.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: _t.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  ),
                  /* @__PURE__ */ o.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: _t.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  )
                ] }),
                !p && /* @__PURE__ */ o.jsx(
                  "span",
                  {
                    "data-testid": jt.LowBoundIndicator,
                    className: _t.minValueIndicator,
                    children: /* @__PURE__ */ o.jsxs(B.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      m,
                      a,
                      g
                    ] })
                  }
                ),
                !p && /* @__PURE__ */ o.jsx(
                  "span",
                  {
                    className: _t.maxValueIndicator,
                    "data-testid": jt.HighBoundIndicator,
                    children: /* @__PURE__ */ o.jsxs(B.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      m,
                      l,
                      g
                    ] })
                  }
                )
              ]
            }
          ),
          !p && /* @__PURE__ */ o.jsx("div", { "data-testid": jt.Value, children: u(e, m, g) })
        ]
      }
    );
  }
}
f(ka, "defaultProps", {
  min: 0,
  max: 100,
  dark: !1,
  highlightRange: null,
  formatValue: fx,
  hideAnnotations: !1
});
const eo = gn(ka, {
  fallback: null
}), bx = "h-fieldSlider--fieldSlider__root", yx = {
  root: bx
};
class tT extends k {
  constructor(s) {
    super(s), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(s) {
    const t = new Event("change");
    Object.defineProperty(t, "target", {
      writable: !0,
      value: { value: s, name: this.props.input.name }
    }), this.props.input.onChange(t);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(s) {
    var n;
    const { input: t } = this.props, e = new FocusEvent(
      "blur",
      s
    );
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t.value, name: t.name }
    }), (n = t.onBlur) == null || n.call(t, e);
  }
  render() {
    const {
      className: s,
      input: t,
      meta: e,
      label: n,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = b(yx.root, s);
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: p,
        label: n,
        meta: e,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ o.jsx(
          eo,
          {
            ...t,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const xx = "h-switch--switch__root", _x = "h-switch--switch__input", Cx = "h-switch--switch__inner", wx = "h-switch--switch__pending", vx = "h-switch--switch__active", Ge = {
  root: xx,
  input: _x,
  inner: Cx,
  pending: wx,
  active: vx
}, gr = {
  input: "Switch-input",
  label: "Switch-label"
};
class Sx extends k {
  render() {
    const { id: s, className: t, variant: e, ...n } = this.props, r = s || `switch_${Math.random()}`;
    return /* @__PURE__ */ o.jsxs("div", { className: b(t, Ge.root), "data-testid": s, children: [
      /* @__PURE__ */ o.jsx(
        "input",
        {
          ...n,
          id: r,
          type: "checkbox",
          className: Ge.input,
          "data-testid": gr.input
        }
      ),
      /* @__PURE__ */ o.jsx(
        "label",
        {
          htmlFor: r,
          className: b(Ge.inner, {
            [Ge.active]: e === "active",
            [Ge.pending]: e === "pending"
          }),
          "data-testid": gr.label
        }
      )
    ] });
  }
}
class eT extends k {
  render() {
    const { input: s, ...t } = this.props, { ref: e, ...n } = s;
    return /* @__PURE__ */ o.jsx(Sx, { ...n, ...t });
  }
}
class nT extends k {
  render() {
    const {
      className: s,
      input: t,
      label: e,
      meta: n,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ o.jsx(
      V,
      {
        className: s,
        label: e,
        labelFor: t.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ o.jsx(
          wa,
          {
            status: V.getStatus(n),
            disabled: a,
            required: r,
            ...t,
            ...u
          }
        )
      }
    );
  }
}
const sT = ({
  className: i,
  input: { name: s, value: t, onChange: e, ...n },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = L(
    (y) => void e(y ?? ""),
    []
  );
  return /* @__PURE__ */ o.jsx(
    V,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: s,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ o.jsx(
        hn,
        {
          selectedItems: t ? [t] : [],
          ...n,
          ...m,
          disabled: c,
          id: s,
          onSelect: g,
          status: V.getStatus(a)
        }
      )
    }
  );
}, oT = ({
  className: i,
  input: { name: s, value: t, onChange: e, ...n },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = L(
    (y) => void e({
      startTime: y.startTime ?? "",
      endTime: y.endTime ?? ""
    }),
    []
  );
  return /* @__PURE__ */ o.jsx(
    V,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: s,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ o.jsx(
        sg,
        {
          endTime: t.endTime,
          startTime: t.startTime,
          ...n,
          ...m,
          disabled: c,
          id: s,
          onSelect: g,
          status: V.getStatus(a)
        }
      )
    }
  );
}, Ix = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", kx = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", Dx = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", Tx = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", En = {
  root: Ix,
  rootAlpha: kx,
  indicator: Dx,
  indicatorNoColor: Tx
}, jx = ({
  color: i,
  alpha: s,
  className: t,
  ...e
}) => /* @__PURE__ */ o.jsx(
  "div",
  {
    ...e,
    className: b(En.root, t, {
      [En.rootAlpha]: s
    }),
    children: /* @__PURE__ */ o.jsx(
      "div",
      {
        className: b(En.indicator, {
          [En.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), Nx = "h-inputColorPicker--inputColorPicker__root", Fx = "h-inputColorPicker--inputColorPicker__inputContainer", Px = "h-inputColorPicker--inputColorPicker__input", Rx = "h-inputColorPicker--inputColorPicker__rootReadOnly", Lx = "h-inputColorPicker--inputColorPicker__iconContainer", Ex = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", $x = "h-inputColorPicker--inputColorPicker__clearIcon", Ax = "h-inputColorPicker--inputColorPicker__colorIndicator", Qt = {
  root: Nx,
  inputContainer: Fx,
  input: Px,
  rootReadOnly: Rx,
  iconContainer: Lx,
  rootHasWrapperIcon: Ex,
  clearIcon: $x,
  colorIndicator: Ax
}, Ox = "inputColorPickerTestId", Bx = ({
  className: i,
  name: s = Math.floor(Math.random() * 1e8).toString(),
  value: t,
  onChange: e,
  dropdownProps: n,
  prefix: r,
  suffix: a,
  icon: l,
  status: c,
  placeholder: d,
  disabled: h,
  colorPickerProps: u,
  clearable: p,
  readOnly: m,
  children: g,
  ...y
}) => {
  const x = Z(null), C = Z(null), _ = Z(null), [w, S] = U(!1);
  at(() => {
    w ? (window.addEventListener("click", T), window.addEventListener("keydown", D)) : (window.removeEventListener("click", T), window.removeEventListener("keydown", D)), w && v();
  }, [w]), te(() => {
    window.removeEventListener("click", T), window.removeEventListener("keydown", D);
  });
  const v = () => {
    var A;
    const j = (A = _.current) == null ? void 0 : A.querySelector("input");
    j == null || j.focus();
  }, T = ({ target: j }) => {
    var A;
    (A = C.current) != null && A.contains(j) || S(!1);
  }, D = (j) => {
    Ee(j.key) && w && (j.stopPropagation(), S(!1));
  }, E = () => {
    m || S(!0);
  }, F = ({ target: j }) => {
    var A;
    (A = C.current) != null && A.contains(j) || S(!1);
  }, P = () => {
    m || S(!0);
  }, I = ({ key: j }) => {
    is(j) && S(!0);
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      "data-testid": Ox,
      ref: C,
      className: b(Qt.root, i, {
        [Qt.rootHasWrapperIcon]: !!l,
        [Qt.rootReadOnly]: m
      }),
      children: [
        /* @__PURE__ */ o.jsx(
          Et,
          {
            prefix: r,
            suffix: a,
            disabled: h,
            icon: l,
            active: w,
            status: c,
            children: /* @__PURE__ */ o.jsxs("div", { className: Qt.inputContainer, children: [
              /* @__PURE__ */ o.jsx(
                "input",
                {
                  ...y,
                  id: s,
                  name: s,
                  className: Qt.input,
                  ref: x,
                  onClick: P,
                  onFocus: E,
                  onBlur: F,
                  onKeyDown: I,
                  disabled: h,
                  placeholder: d,
                  autoComplete: "off",
                  value: t,
                  onChange: Gn(t) ? void 0 : O,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ o.jsx("div", { className: Qt.iconContainer, children: p && t && /* @__PURE__ */ o.jsx(
                st,
                {
                  className: Qt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: h,
                  onClick: () => e == null ? void 0 : e("")
                }
              ) }),
              /* @__PURE__ */ o.jsx(
                jx,
                {
                  className: Qt.colorIndicator,
                  onClick: P,
                  color: t,
                  alpha: u == null ? void 0 : u.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ o.jsx(zt, { ...n, isOpen: w, children: /* @__PURE__ */ o.jsx("div", { ref: _, children: /* @__PURE__ */ o.jsx(
          ls,
          {
            margin: "300",
            ...u,
            color: t,
            onChange: e ?? O,
            children: g
          }
        ) }) })
      ]
    }
  );
}, rT = ({
  className: i,
  input: { value: s, name: t, onChange: e, ...n },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ o.jsx(
  V,
  {
    className: i,
    label: r,
    labelFor: t,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ o.jsx(
      Bx,
      {
        name: t,
        value: s,
        onChange: e,
        ...n,
        status: V.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Hx = "h-fieldAddonDropdown--fieldAddonDropdown__root", Wx = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Mx = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", zx = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", $n = {
  root: Hx,
  prefix: Wx,
  suffix: Mx,
  angleDown: zx
}, aT = ({
  className: i,
  noArrow: s,
  ...t
}) => oo(t) ? null : /* @__PURE__ */ o.jsx(Vs.Consumer, { children: ({ position: e, disabled: n }) => /* @__PURE__ */ o.jsx(
  ps,
  {
    ...Pr(t, "meta"),
    noStyle: !0,
    itemComponent: mo,
    children: /* @__PURE__ */ o.jsxs(
      "button",
      {
        className: b(
          $n.root,
          {
            [$n.prefix]: e === "prefix",
            [$n.suffix]: e === "suffix"
          },
          i
        ),
        disabled: n || t.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ o.jsx("span", { children: t.meta.selectedValue }),
          !s && /* @__PURE__ */ o.jsx(
            R,
            {
              name: "angle-down",
              className: b("icon-vertical-fix", $n.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Vx = "h-countryFlag--countryFlag__flag", Kx = "h-countryFlag--countryFlag__ad", Ux = "h-countryFlag--countryFlag__ae", qx = "h-countryFlag--countryFlag__af", Gx = "h-countryFlag--countryFlag__ag", Yx = "h-countryFlag--countryFlag__ai", Qx = "h-countryFlag--countryFlag__al", Xx = "h-countryFlag--countryFlag__am", Jx = "h-countryFlag--countryFlag__ao", Zx = "h-countryFlag--countryFlag__aq", t_ = "h-countryFlag--countryFlag__ar", e_ = "h-countryFlag--countryFlag__as", n_ = "h-countryFlag--countryFlag__at", s_ = "h-countryFlag--countryFlag__au", o_ = "h-countryFlag--countryFlag__aw", r_ = "h-countryFlag--countryFlag__ax", a_ = "h-countryFlag--countryFlag__az", i_ = "h-countryFlag--countryFlag__ba", l_ = "h-countryFlag--countryFlag__bb", c_ = "h-countryFlag--countryFlag__bd", d_ = "h-countryFlag--countryFlag__be", h_ = "h-countryFlag--countryFlag__bf", u_ = "h-countryFlag--countryFlag__bg", p_ = "h-countryFlag--countryFlag__bh", m_ = "h-countryFlag--countryFlag__bi", g_ = "h-countryFlag--countryFlag__bj", f_ = "h-countryFlag--countryFlag__bl", b_ = "h-countryFlag--countryFlag__bm", y_ = "h-countryFlag--countryFlag__bn", x_ = "h-countryFlag--countryFlag__bo", __ = "h-countryFlag--countryFlag__bq", C_ = "h-countryFlag--countryFlag__br", w_ = "h-countryFlag--countryFlag__bs", v_ = "h-countryFlag--countryFlag__bt", S_ = "h-countryFlag--countryFlag__bv", I_ = "h-countryFlag--countryFlag__bw", k_ = "h-countryFlag--countryFlag__by", D_ = "h-countryFlag--countryFlag__bz", T_ = "h-countryFlag--countryFlag__ca", j_ = "h-countryFlag--countryFlag__cd", N_ = "h-countryFlag--countryFlag__cf", F_ = "h-countryFlag--countryFlag__cg", P_ = "h-countryFlag--countryFlag__ch", R_ = "h-countryFlag--countryFlag__ci", L_ = "h-countryFlag--countryFlag__ck", E_ = "h-countryFlag--countryFlag__cl", $_ = "h-countryFlag--countryFlag__cm", A_ = "h-countryFlag--countryFlag__cn", O_ = "h-countryFlag--countryFlag__co", B_ = "h-countryFlag--countryFlag__cp", H_ = "h-countryFlag--countryFlag__cr", W_ = "h-countryFlag--countryFlag__cu", M_ = "h-countryFlag--countryFlag__cv", z_ = "h-countryFlag--countryFlag__cw", V_ = "h-countryFlag--countryFlag__cy", K_ = "h-countryFlag--countryFlag__cz", U_ = "h-countryFlag--countryFlag__de", q_ = "h-countryFlag--countryFlag__dj", G_ = "h-countryFlag--countryFlag__dk", Y_ = "h-countryFlag--countryFlag__dm", Q_ = "h-countryFlag--countryFlag__dz", X_ = "h-countryFlag--countryFlag__ec", J_ = "h-countryFlag--countryFlag__ee", Z_ = "h-countryFlag--countryFlag__eg", tC = "h-countryFlag--countryFlag__eh", eC = "h-countryFlag--countryFlag__er", nC = "h-countryFlag--countryFlag__es", sC = "h-countryFlag--countryFlag__et", oC = "h-countryFlag--countryFlag__eu", rC = "h-countryFlag--countryFlag__fi", aC = "h-countryFlag--countryFlag__fj", iC = "h-countryFlag--countryFlag__fm", lC = "h-countryFlag--countryFlag__fo", cC = "h-countryFlag--countryFlag__fr", dC = "h-countryFlag--countryFlag__ga", hC = "h-countryFlag--countryFlag__gb", uC = "h-countryFlag--countryFlag__gd", pC = "h-countryFlag--countryFlag__ge", mC = "h-countryFlag--countryFlag__gg", gC = "h-countryFlag--countryFlag__gh", fC = "h-countryFlag--countryFlag__gi", bC = "h-countryFlag--countryFlag__gl", yC = "h-countryFlag--countryFlag__gm", xC = "h-countryFlag--countryFlag__gn", _C = "h-countryFlag--countryFlag__gp", CC = "h-countryFlag--countryFlag__gq", wC = "h-countryFlag--countryFlag__gr", vC = "h-countryFlag--countryFlag__gt", SC = "h-countryFlag--countryFlag__gu", IC = "h-countryFlag--countryFlag__gw", kC = "h-countryFlag--countryFlag__gy", DC = "h-countryFlag--countryFlag__hk", TC = "h-countryFlag--countryFlag__hn", jC = "h-countryFlag--countryFlag__hr", NC = "h-countryFlag--countryFlag__ht", FC = "h-countryFlag--countryFlag__hu", PC = "h-countryFlag--countryFlag__id", RC = "h-countryFlag--countryFlag__ie", LC = "h-countryFlag--countryFlag__il", EC = "h-countryFlag--countryFlag__im", $C = "h-countryFlag--countryFlag__iq", AC = "h-countryFlag--countryFlag__ir", OC = "h-countryFlag--countryFlag__is", BC = "h-countryFlag--countryFlag__it", HC = "h-countryFlag--countryFlag__je", WC = "h-countryFlag--countryFlag__jm", MC = "h-countryFlag--countryFlag__jo", zC = "h-countryFlag--countryFlag__jp", VC = "h-countryFlag--countryFlag__ke", KC = "h-countryFlag--countryFlag__kg", UC = "h-countryFlag--countryFlag__kh", qC = "h-countryFlag--countryFlag__ki", GC = "h-countryFlag--countryFlag__km", YC = "h-countryFlag--countryFlag__kn", QC = "h-countryFlag--countryFlag__kp", XC = "h-countryFlag--countryFlag__kr", JC = "h-countryFlag--countryFlag__kw", ZC = "h-countryFlag--countryFlag__ky", tw = "h-countryFlag--countryFlag__kz", ew = "h-countryFlag--countryFlag__la", nw = "h-countryFlag--countryFlag__lb", sw = "h-countryFlag--countryFlag__lc", ow = "h-countryFlag--countryFlag__li", rw = "h-countryFlag--countryFlag__lk", aw = "h-countryFlag--countryFlag__lr", iw = "h-countryFlag--countryFlag__ls", lw = "h-countryFlag--countryFlag__lt", cw = "h-countryFlag--countryFlag__lu", dw = "h-countryFlag--countryFlag__lv", hw = "h-countryFlag--countryFlag__ly", uw = "h-countryFlag--countryFlag__ma", pw = "h-countryFlag--countryFlag__mc", mw = "h-countryFlag--countryFlag__md", gw = "h-countryFlag--countryFlag__me", fw = "h-countryFlag--countryFlag__mf", bw = "h-countryFlag--countryFlag__mg", yw = "h-countryFlag--countryFlag__mh", xw = "h-countryFlag--countryFlag__mk", _w = "h-countryFlag--countryFlag__ml", Cw = "h-countryFlag--countryFlag__mm", ww = "h-countryFlag--countryFlag__mn", vw = "h-countryFlag--countryFlag__mo", Sw = "h-countryFlag--countryFlag__mq", Iw = "h-countryFlag--countryFlag__mr", kw = "h-countryFlag--countryFlag__ms", Dw = "h-countryFlag--countryFlag__mt", Tw = "h-countryFlag--countryFlag__mu", jw = "h-countryFlag--countryFlag__mv", Nw = "h-countryFlag--countryFlag__mw", Fw = "h-countryFlag--countryFlag__mx", Pw = "h-countryFlag--countryFlag__my", Rw = "h-countryFlag--countryFlag__mz", Lw = "h-countryFlag--countryFlag__na", Ew = "h-countryFlag--countryFlag__nc", $w = "h-countryFlag--countryFlag__ne", Aw = "h-countryFlag--countryFlag__ng", Ow = "h-countryFlag--countryFlag__ni", Bw = "h-countryFlag--countryFlag__nl", Hw = "h-countryFlag--countryFlag__no", Ww = "h-countryFlag--countryFlag__np", Mw = "h-countryFlag--countryFlag__nq", zw = "h-countryFlag--countryFlag__nr", Vw = "h-countryFlag--countryFlag__nu", Kw = "h-countryFlag--countryFlag__nz", Uw = "h-countryFlag--countryFlag__om", qw = "h-countryFlag--countryFlag__pa", Gw = "h-countryFlag--countryFlag__pe", Yw = "h-countryFlag--countryFlag__pf", Qw = "h-countryFlag--countryFlag__pg", Xw = "h-countryFlag--countryFlag__ph", Jw = "h-countryFlag--countryFlag__pk", Zw = "h-countryFlag--countryFlag__pl", tv = "h-countryFlag--countryFlag__pr", ev = "h-countryFlag--countryFlag__ps", nv = "h-countryFlag--countryFlag__pt", sv = "h-countryFlag--countryFlag__pw", ov = "h-countryFlag--countryFlag__py", rv = "h-countryFlag--countryFlag__qa", av = "h-countryFlag--countryFlag__re", iv = "h-countryFlag--countryFlag__ro", lv = "h-countryFlag--countryFlag__rs", cv = "h-countryFlag--countryFlag__ru", dv = "h-countryFlag--countryFlag__rw", hv = "h-countryFlag--countryFlag__sa", uv = "h-countryFlag--countryFlag__sb", pv = "h-countryFlag--countryFlag__sc", mv = "h-countryFlag--countryFlag__sd", gv = "h-countryFlag--countryFlag__se", fv = "h-countryFlag--countryFlag__sg", bv = "h-countryFlag--countryFlag__sh", yv = "h-countryFlag--countryFlag__si", xv = "h-countryFlag--countryFlag__sj", _v = "h-countryFlag--countryFlag__sk", Cv = "h-countryFlag--countryFlag__sl", wv = "h-countryFlag--countryFlag__sm", vv = "h-countryFlag--countryFlag__sn", Sv = "h-countryFlag--countryFlag__so", Iv = "h-countryFlag--countryFlag__sr", kv = "h-countryFlag--countryFlag__ss", Dv = "h-countryFlag--countryFlag__st", Tv = "h-countryFlag--countryFlag__sv", jv = "h-countryFlag--countryFlag__sx", Nv = "h-countryFlag--countryFlag__sy", Fv = "h-countryFlag--countryFlag__sz", Pv = "h-countryFlag--countryFlag__tc", Rv = "h-countryFlag--countryFlag__td", Lv = "h-countryFlag--countryFlag__tg", Ev = "h-countryFlag--countryFlag__th", $v = "h-countryFlag--countryFlag__tj", Av = "h-countryFlag--countryFlag__tl", Ov = "h-countryFlag--countryFlag__tm", Bv = "h-countryFlag--countryFlag__tn", Hv = "h-countryFlag--countryFlag__to", Wv = "h-countryFlag--countryFlag__tr", Mv = "h-countryFlag--countryFlag__tt", zv = "h-countryFlag--countryFlag__tv", Vv = "h-countryFlag--countryFlag__tw", Kv = "h-countryFlag--countryFlag__tz", Uv = "h-countryFlag--countryFlag__ua", qv = "h-countryFlag--countryFlag__ug", Gv = "h-countryFlag--countryFlag__us", Yv = "h-countryFlag--countryFlag__uy", Qv = "h-countryFlag--countryFlag__uz", Xv = "h-countryFlag--countryFlag__va", Jv = "h-countryFlag--countryFlag__vc", Zv = "h-countryFlag--countryFlag__ve", tS = "h-countryFlag--countryFlag__vg", eS = "h-countryFlag--countryFlag__vi", nS = "h-countryFlag--countryFlag__vn", sS = "h-countryFlag--countryFlag__vu", oS = "h-countryFlag--countryFlag__ws", rS = "h-countryFlag--countryFlag__ye", aS = "h-countryFlag--countryFlag__yt", iS = "h-countryFlag--countryFlag__za", lS = "h-countryFlag--countryFlag__zm", cS = "h-countryFlag--countryFlag__zw", fr = {
  flag: Vx,
  ad: Kx,
  ae: Ux,
  af: qx,
  ag: Gx,
  ai: Yx,
  al: Qx,
  am: Xx,
  ao: Jx,
  aq: Zx,
  ar: t_,
  as: e_,
  at: n_,
  au: s_,
  aw: o_,
  ax: r_,
  az: a_,
  ba: i_,
  bb: l_,
  bd: c_,
  be: d_,
  bf: h_,
  bg: u_,
  bh: p_,
  bi: m_,
  bj: g_,
  bl: f_,
  bm: b_,
  bn: y_,
  bo: x_,
  bq: __,
  br: C_,
  bs: w_,
  bt: v_,
  bv: S_,
  bw: I_,
  by: k_,
  bz: D_,
  ca: T_,
  cd: j_,
  cf: N_,
  cg: F_,
  ch: P_,
  ci: R_,
  ck: L_,
  cl: E_,
  cm: $_,
  cn: A_,
  co: O_,
  cp: B_,
  cr: H_,
  cu: W_,
  cv: M_,
  cw: z_,
  cy: V_,
  cz: K_,
  de: U_,
  dj: q_,
  dk: G_,
  dm: Y_,
  do: "h-countryFlag--countryFlag__do",
  dz: Q_,
  ec: X_,
  ee: J_,
  eg: Z_,
  eh: tC,
  er: eC,
  es: nC,
  et: sC,
  eu: oC,
  fi: rC,
  fj: aC,
  fm: iC,
  fo: lC,
  fr: cC,
  ga: dC,
  gb: hC,
  gd: uC,
  ge: pC,
  gg: mC,
  gh: gC,
  gi: fC,
  gl: bC,
  gm: yC,
  gn: xC,
  gp: _C,
  gq: CC,
  gr: wC,
  gt: vC,
  gu: SC,
  gw: IC,
  gy: kC,
  hk: DC,
  hn: TC,
  hr: jC,
  ht: NC,
  hu: FC,
  id: PC,
  ie: RC,
  il: LC,
  im: EC,
  in: "h-countryFlag--countryFlag__in",
  iq: $C,
  ir: AC,
  is: OC,
  it: BC,
  je: HC,
  jm: WC,
  jo: MC,
  jp: zC,
  ke: VC,
  kg: KC,
  kh: UC,
  ki: qC,
  km: GC,
  kn: YC,
  kp: QC,
  kr: XC,
  kw: JC,
  ky: ZC,
  kz: tw,
  la: ew,
  lb: nw,
  lc: sw,
  li: ow,
  lk: rw,
  lr: aw,
  ls: iw,
  lt: lw,
  lu: cw,
  lv: dw,
  ly: hw,
  ma: uw,
  mc: pw,
  md: mw,
  me: gw,
  mf: fw,
  mg: bw,
  mh: yw,
  mk: xw,
  ml: _w,
  mm: Cw,
  mn: ww,
  mo: vw,
  mq: Sw,
  mr: Iw,
  ms: kw,
  mt: Dw,
  mu: Tw,
  mv: jw,
  mw: Nw,
  mx: Fw,
  my: Pw,
  mz: Rw,
  na: Lw,
  nc: Ew,
  ne: $w,
  ng: Aw,
  ni: Ow,
  nl: Bw,
  no: Hw,
  np: Ww,
  nq: Mw,
  nr: zw,
  nu: Vw,
  nz: Kw,
  om: Uw,
  pa: qw,
  pe: Gw,
  pf: Yw,
  pg: Qw,
  ph: Xw,
  pk: Jw,
  pl: Zw,
  pr: tv,
  ps: ev,
  pt: nv,
  pw: sv,
  py: ov,
  qa: rv,
  re: av,
  ro: iv,
  rs: lv,
  ru: cv,
  rw: dv,
  sa: hv,
  sb: uv,
  sc: pv,
  sd: mv,
  se: gv,
  sg: fv,
  sh: bv,
  si: yv,
  sj: xv,
  sk: _v,
  sl: Cv,
  sm: wv,
  sn: vv,
  so: Sv,
  sr: Iv,
  ss: kv,
  st: Dv,
  sv: Tv,
  sx: jv,
  sy: Nv,
  sz: Fv,
  tc: Pv,
  td: Rv,
  tg: Lv,
  th: Ev,
  tj: $v,
  tl: Av,
  tm: Ov,
  tn: Bv,
  to: Hv,
  tr: Wv,
  tt: Mv,
  tv: zv,
  tw: Vv,
  tz: Kv,
  ua: Uv,
  ug: qv,
  us: Gv,
  uy: Yv,
  uz: Qv,
  va: Xv,
  vc: Jv,
  ve: Zv,
  vg: tS,
  vi: eS,
  vn: nS,
  vu: sS,
  ws: oS,
  ye: rS,
  yt: aS,
  za: iS,
  zm: lS,
  zw: cS
}, dS = 127365, hS = /^[a-z]{2}$/, uS = (i) => hS.test(i) ? String.fromCodePoint(
  ...i.split("").map((s) => dS + s.charCodeAt(0))
) : "", iT = ({
  className: i,
  countryCode: s,
  size: t = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ o.jsx(lt, { style: { width: t, height: t }, children: /* @__PURE__ */ o.jsx(
  lt,
  {
    className: b(fr.flag, fr[s], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${t} / 32))`
    }
  }
) }) : /* @__PURE__ */ o.jsx("span", { className: i, style: { fontSize: t }, children: uS(s) }), lT = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], pS = "h-formGrid--formGrid__root", mS = {
  root: pS
}, gS = "formGridTestId", cT = z(function({ className: s, children: t, ...e }, n) {
  const r = b(mS.root, s);
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      "data-testid": gS,
      className: r,
      ...e,
      ref: n,
      children: t
    }
  );
}), fS = "h-formGrid-field--formField__root", bS = "h-formGrid-field--formField__rootSpan5", yS = "h-formGrid-field--formField__rootSpan4", xS = "h-formGrid-field--formField__rootSpan3", _S = "h-formGrid-field--formField__rootSpan2", CS = "h-formGrid-field--formField__rootSpan1", De = {
  root: fS,
  rootSpan5: bS,
  rootSpan4: yS,
  rootSpan3: xS,
  rootSpan2: _S,
  rootSpan1: CS
}, wS = "formFieldTestId", vS = {
  1: De.rootSpan1,
  2: De.rootSpan2,
  3: De.rootSpan3,
  4: De.rootSpan4,
  5: De.rootSpan5,
  6: void 0
};
class SS extends k {
  render() {
    const { span: s, className: t, children: e, ...n } = this.props, r = b(
      De.root,
      t,
      vS[s]
    );
    return /* @__PURE__ */ o.jsx("div", { "data-testid": wS, className: r, ...n, children: e });
  }
}
f(SS, "defaultProps", {
  span: 6
});
const IS = "h-helperField--helperField__root", kS = "h-helperField--helperField__label", DS = "h-helperField--helperField__helpIcon", TS = "h-helperField--helperField__error", jS = "h-helperField--helperField__rootRequired", Ye = {
  root: IS,
  label: kS,
  helpIcon: DS,
  error: TS,
  rootRequired: jS
};
class dT extends k {
  render() {
    const {
      className: s,
      label: t,
      required: e,
      disabled: n,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = b(
      {
        [Ye.root]: !0,
        [Ye.rootRequired]: e
      },
      s
    );
    return /* @__PURE__ */ o.jsxs("div", { ...d, className: h, children: [
      !!t && /* @__PURE__ */ o.jsx(
        "label",
        {
          className: Ye.label,
          htmlFor: a,
          id: `${a}-label`,
          children: t
        }
      ),
      !!(c != null && c.text) && /* @__PURE__ */ o.jsx(
        ho,
        {
          ...c,
          className: b(Ye.helpIcon, (c == null ? void 0 : c.className) ?? "")
        }
      ),
      !!r && /* @__PURE__ */ o.jsx("p", { className: Ye.error, children: r }),
      l
    ] });
  }
}
const Qe = /* @__PURE__ */ new Map();
function NS({
  containerId: i,
  children: s
}) {
  const [t, e] = U(null), n = (a) => {
    const l = Qe.get(i);
    l !== void 0 && Qe.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return at(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Qe.set(i, 0)), e(a), n(1), () => {
      n(-1), Qe.get(i) === 0 && a && (Qe.delete(i), a.remove());
    };
  }, [i]), t ? _i.createPortal(s, t) : null;
}
const FS = "h-modal--modal__root", PS = "h-modal--modal__modalContainer", RS = "h-modal--modal__rootDisplayed", LS = "h-modal--modal__rootOpened", ES = "h-modal--modal__modalContent", $S = "h-modal--modal__modal", Se = {
  root: FS,
  modalContainer: PS,
  rootDisplayed: RS,
  rootOpened: LS,
  modalContent: ES,
  modal: $S
};
class Da extends k {
  constructor(t) {
    super(t);
    f(this, "rootRef");
    f(this, "haskeydownEventListner");
    f(this, "closeTimer");
    f(this, "removeKeyDownEventListener", () => {
      window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
    });
    this.rootRef = W(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: r } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== r && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    var r;
    const { isOpen: e, onClose: n } = this.props;
    e && Ee(t.key) && ((r = this.rootRef.current) != null && r.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 }));
  }
  animateClosing() {
    this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.removeKeyDownEventListener(), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred();
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: r,
      allowClickOutside: a,
      allowEscClose: l,
      // Stops allowEscClose from being passed in with otherProps
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, y = b(Se.root, c == null ? void 0 : c.className, {
      [Se.rootDisplayed]: m,
      [Se.rootOpened]: g
    }), x = b(Se.modal, t);
    return /* @__PURE__ */ o.jsx(NS, { containerId: "modal-container", children: /* @__PURE__ */ o.jsx("div", { ...c, className: y, children: /* @__PURE__ */ o.jsx(
      "div",
      {
        className: Se.modalContainer,
        ref: this.rootRef,
        ...a ? { onClick: r } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ o.jsx(
          Ur,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ o.jsx("div", { className: Se.modalContent, children: /* @__PURE__ */ o.jsx(
              "div",
              {
                className: x,
                onClick: (C) => a && C.stopPropagation(),
                children: n
              }
            ) })
          }
        )
      }
    ) }) });
  }
}
f(Da, "defaultProps", {
  allowEscClose: !0,
  restoreFocus: !0,
  bringInFocusOnTab: !0
});
const AS = "h-lightbox--lightbox__lightSource", OS = "h-lightbox--lightbox__closeButton", BS = "h-lightbox--lightbox__downloadButton", HS = "h-lightbox--lightbox__image", An = {
  lightSource: AS,
  closeButton: OS,
  downloadButton: BS,
  image: HS
};
class hT extends k {
  render() {
    const { className: s, src: t, alt: e, isOpen: n, onClose: r } = this.props;
    return /* @__PURE__ */ o.jsx(
      Da,
      {
        className: s,
        isOpen: n,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ o.jsxs("div", { className: An.lightSource, children: [
          t && /* @__PURE__ */ o.jsx(rs, { className: An.image, alt: e, src: t }),
          r && /* @__PURE__ */ o.jsx(
            st,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: An.closeButton
            }
          ),
          t && typeof t == "string" && /* @__PURE__ */ o.jsx(
            "a",
            {
              href: t,
              target: "_blank",
              download: !0,
              className: An.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ o.jsx(
                R,
                {
                  name: "cloud-download",
                  className: b("icon-vertical-fix")
                }
              )
            }
          )
        ] })
      }
    );
  }
}
const WS = "h-list-items--item__root", MS = "h-list-items--item__rootWithHoverEffect", zS = "h-list-items--item__rootDense", VS = "h-list-items--item__rootLarge", KS = "h-list-items--item__contentLeft", US = "h-list-items--item__contentRight", qS = "h-list-items--item__titles", GS = "h-list-items--item__title", YS = "h-list-items--item__titleSecondary", QS = "h-list-items--item__arrow", Tt = {
  root: WS,
  rootWithHoverEffect: MS,
  rootDense: zS,
  rootLarge: VS,
  contentLeft: KS,
  contentRight: US,
  titles: qS,
  title: GS,
  titleSecondary: YS,
  arrow: QS
};
class _n extends k {
  renderTitle() {
    const { title: s, titleSecondary: t } = this.props;
    return s || t ? /* @__PURE__ */ o.jsxs("div", { className: Tt.titles, children: [
      !!s && /* @__PURE__ */ o.jsx(B.Paragraph, { as: "div", variant: "2", className: Tt.title, children: s }),
      !!t && /* @__PURE__ */ o.jsx(
        B.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Tt.titleSecondary,
          children: t
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: s } = this.props;
    return s ? /* @__PURE__ */ o.jsx("div", { className: Tt.contentLeft, children: s }) : null;
  }
  renderContentRight() {
    const { contentRight: s } = this.props;
    return s ? /* @__PURE__ */ o.jsx("div", { className: Tt.contentRight, children: s }) : null;
  }
  renderIcon() {
    const { isLink: s, contentRight: t } = this.props;
    return s && !t ? /* @__PURE__ */ o.jsx(
      R,
      {
        className: b(Tt.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ o.jsxs(Mt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: s,
      children: t,
      contentLeft: e,
      contentRight: n,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = b(Tt.root, s, {
      [Tt.rootDense]: d === "dense",
      [Tt.rootLarge]: d === "large",
      [Tt.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ o.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
f(_n, "defaultProps", {
  variant: "dense",
  withHoverEffect: !0
});
const XS = "h-list-items--keyValue__root", JS = {
  root: XS
};
class Ta extends k {
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: s, className: t, pair: e, ...n } = this.props, r = b(JS.root, t);
    return s && this.isValueEmpty() ? null : /* @__PURE__ */ o.jsx(
      _n,
      {
        ...n,
        className: r,
        title: /* @__PURE__ */ o.jsx(B.Paragraph, { as: "span", variant: "4", subdued: !0, children: e.key }),
        titleSecondary: /* @__PURE__ */ o.jsx(B.Paragraph, { as: "span", variant: "2", children: e.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
f(Ta, "defaultProps", {
  hideIfValueIsEmpty: !0
});
const ZS = "h-list-items--text__root", tI = {
  root: ZS
};
class eI extends k {
  render() {
    const { children: s, className: t, ...e } = this.props, n = b(tI.root, t);
    return /* @__PURE__ */ o.jsx(
      _n,
      {
        ...e,
        className: n,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ o.jsx(B.Paragraph, { variant: "2", children: s })
      }
    );
  }
}
const nI = "h-list-items--user__root", sI = "h-list-items--user__avatarWrapper", br = {
  root: nI,
  avatarWrapper: sI
};
class oI extends k {
  getTitle() {
    const { user: s, title: t } = this.props;
    return t || s.display_name || s.name || s.phone_number || s.id;
  }
  getSubTitle() {
    const { user: s, titleSecondary: t } = this.props;
    return t || s.email;
  }
  render() {
    const { className: s, user: t, title: e, titleSecondary: n, ...r } = this.props, a = b(s, br.root);
    return /* @__PURE__ */ o.jsx(
      _n,
      {
        className: a,
        contentLeft: /* @__PURE__ */ o.jsx("div", { className: br.avatarWrapper, children: /* @__PURE__ */ o.jsx(Vr, { user: t }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const rI = "h-list--list__root", aI = {
  root: rI
};
class tn extends k {
  render() {
    const { className: s, ...t } = this.props;
    return /* @__PURE__ */ o.jsx("ul", { ...t, className: b(aI.root, s) });
  }
}
f(tn, "Item", _n), f(tn, "Text", eI), f(tn, "User", oI), f(tn, "KeyValue", Ta);
const uT = gn(tn, {
  fallback: null
}), iI = () => {
  document.exitFullscreen && document.exitFullscreen();
}, lI = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, cI = (i) => document.fullscreenElement === i;
class dI extends Error {
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`);
    f(this, "status");
    f(this, "url");
    f(this, "response");
    this.status = t.status, this.url = t.url, this.response = t;
  }
}
const hI = {
  fetch: (i, ...s) => fetch(i, ...s).then((t) => {
    if (!(t.status >= 200 && t.status < 300))
      throw new dI(t);
    return t;
  })
}, uI = "h-mediaPlayer--mediaPlayer__root", pI = "h-mediaPlayer--mediaPlayer__controls", mI = "h-mediaPlayer--mediaPlayer__unstyled", gI = "h-mediaPlayer--mediaPlayer__rootFullScreen", fI = "h-mediaPlayer--mediaPlayer__rootHideControls", bI = "h-mediaPlayer--mediaPlayer__control", yI = "h-mediaPlayer--mediaPlayer__progress", xI = "h-mediaPlayer--mediaPlayer__progressSlider", _I = "h-mediaPlayer--mediaPlayer__volumeSlider", CI = "h-mediaPlayer--mediaPlayer__timestamp", wI = "h-mediaPlayer--mediaPlayer__videoWrapper", vI = "h-mediaPlayer--mediaPlayer__rootWaiting", SI = "h-mediaPlayer--mediaPlayer__rootAudio", II = "h-mediaPlayer--mediaPlayer__video", kI = "h-mediaPlayer--mediaPlayer__volume", DI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", TI = "h-mediaPlayer--mediaPlayer__downloadLink", et = {
  root: uI,
  controls: pI,
  unstyled: mI,
  rootFullScreen: gI,
  rootHideControls: fI,
  control: bI,
  progress: yI,
  progressSlider: xI,
  volumeSlider: _I,
  timestamp: CI,
  videoWrapper: wI,
  rootWaiting: vI,
  rootAudio: SI,
  video: II,
  volume: kI,
  volumeMuteControl: DI,
  downloadLink: TI
};
function jI(i) {
  const s = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - s, s);
}
class NI extends k {
  constructor(t) {
    super(t);
    f(this, "intersectionObserver");
    f(this, "videoRef", W());
    f(this, "playerRef", W());
    f(this, "hideControlsTimeout");
    f(this, "controller", new AbortController());
    f(this, "handleVolume", (t) => {
      const { current: e } = this.videoRef;
      !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
        this.setPlayerVolume(t);
      });
    });
    this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: r,
      mediaFile: { src: a }
    } = this.props;
    n !== a && (r ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    var a;
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), (a = this.intersectionObserver) == null || a.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: r
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const a = new Headers(n);
    hI.fetch(e, {
      headers: a,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((l) => l.blob()).then((l) => {
      const c = window.URL.createObjectURL(l);
      t ? di.saveAs(
        l,
        r || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(c), this.setState({ asyncStatus: "succeeded" });
    }).catch((l) => {
      l && l.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", l), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let r = null;
      const a = t.buffered;
      for (let l = 0; l < a.length; l += 1) {
        const c = a.start(l), d = a.end(l);
        c <= e && e <= d && (r = [c / n, d / n]);
      }
      this.setState({
        buffer: r
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = cI(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? iI() : lI(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, r = e === 0, a = r ? n : 0;
    this.setState(
      {
        volume: a,
        prevVolume: r ? n : e
      },
      () => {
        this.setPlayerVolume(a);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: r,
      width: a,
      controls: l,
      noControlsStyle: c,
      ...d
    } = this.props, {
      src: h,
      playing: u,
      duration: p,
      time: m,
      volume: g,
      hideControls: y,
      isFullScreen: x,
      isWaiting: C,
      buffer: _,
      asyncStatus: w
    } = this.state, S = (l == null ? void 0 : l.play) ?? !0, v = (l == null ? void 0 : l.download) ?? !0, T = (l == null ? void 0 : l.progress) ?? !0, D = (l == null ? void 0 : l.volume) ?? !0, E = (l == null ? void 0 : l.maximize) ?? !0, F = S || v || T || D || E, P = typeof e == "string" && e.startsWith("audio"), I = !h || w === "loading", j = x ? "primary" : "secondary", A = b(
      et.root,
      {
        [et.rootFullScreen]: x,
        [et.rootHideControls]: y,
        [et.rootWaiting]: u && C,
        [et.rootAudio]: P
      },
      t
    );
    return /* @__PURE__ */ o.jsxs(
      "div",
      {
        ...d,
        className: A,
        ref: this.playerRef,
        style: { width: a },
        children: [
          /* @__PURE__ */ o.jsx("div", { className: et.videoWrapper, children: !!h && /* @__PURE__ */ o.jsx(
            "video",
            {
              className: et.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ o.jsx("source", { src: h })
            }
          ) }),
          F && /* @__PURE__ */ o.jsxs(
            "div",
            {
              className: b(et.controls, {
                [et.unstyled]: c
              }),
              children: [
                S && /* @__PURE__ */ o.jsx(
                  Rt,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: et.control,
                    disabled: I,
                    icon: u ? "pause" : "play",
                    variant: j
                  }
                ),
                v && (r ? /* @__PURE__ */ o.jsx(
                  tt,
                  {
                    variant: j,
                    className: et.control,
                    disabled: I,
                    children: /* @__PURE__ */ o.jsx(
                      "a",
                      {
                        href: h,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: et.downloadLink,
                        children: /* @__PURE__ */ o.jsx(R, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ o.jsx(
                  Rt,
                  {
                    icon: "download",
                    variant: j,
                    className: et.control,
                    disabled: I,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                T && /* @__PURE__ */ o.jsxs("div", { className: et.progress, children: [
                  /* @__PURE__ */ o.jsx(
                    eo,
                    {
                      hideAnnotations: !0,
                      className: et.progressSlider,
                      min: 0,
                      max: p,
                      value: m,
                      onChange: (K) => !Array.isArray(K) && this.seek(K / p),
                      dark: x,
                      highlightRange: _ == null ? void 0 : _.map((K) => K * p)
                    }
                  ),
                  /* @__PURE__ */ o.jsx("span", { className: et.timestamp, children: jI(p) })
                ] }),
                D && /* @__PURE__ */ o.jsxs("div", { className: et.volume, children: [
                  /* @__PURE__ */ o.jsx(
                    R,
                    {
                      className: et.volumeMuteControl,
                      name: g === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ o.jsx(
                    eo,
                    {
                      hideAnnotations: !0,
                      className: et.volumeSlider,
                      value: g,
                      onChange: (K) => !Array.isArray(K) && this.handleVolume(K),
                      dark: x
                    }
                  )
                ] }),
                E && !P && /* @__PURE__ */ o.jsx(
                  Rt,
                  {
                    variant: j,
                    onClick: this.handleFullscreenToggle,
                    className: et.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
f(NI, "defaultProps", {
  headers: {}
});
const FI = "h-modalBody--modalBody__root", PI = {
  root: FI
};
class pT extends k {
  render() {
    const { className: s, children: t, ...e } = this.props, n = b(
      {
        [PI.root]: !0
      },
      s
    );
    return /* @__PURE__ */ o.jsx("div", { ...e, className: n, children: t });
  }
}
const RI = "h-modalFoot--modalFoot__root", LI = "h-modalFoot--modalFoot__confirm", EI = "h-modalFoot--modalFoot__confirmSecondary", $I = "h-modalFoot--modalFoot__cancel", On = {
  root: RI,
  confirm: LI,
  confirmSecondary: EI,
  cancel: $I
};
class ja extends k {
  render() {
    const {
      className: s,
      confirmOnClick: t,
      confirmSecondaryOnClick: e,
      cancelOnClick: n,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = b(
      {
        [On.root]: !0
      },
      s
    ), g = b(
      {
        [On.cancel]: !0
      },
      h == null ? void 0 : h.className
    ), y = b(
      {
        [On.confirm]: !0
      },
      c == null ? void 0 : c.className
    ), x = b(
      {
        [On.confirmSecondary]: !0
      },
      d == null ? void 0 : d.className
    );
    return /* @__PURE__ */ o.jsxs("div", { ...p, className: m, children: [
      u,
      e && /* @__PURE__ */ o.jsx(
        tt,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: e,
          children: a
        }
      ),
      n && /* @__PURE__ */ o.jsx(
        tt,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: n,
          children: l
        }
      ),
      t && /* @__PURE__ */ o.jsx(
        tt,
        {
          variant: "primary",
          ...c,
          className: y,
          onClick: t,
          children: r
        }
      )
    ] });
  }
}
f(ja, "defaultProps");
ja.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const AI = "h-modalHead--modalHead__root", OI = "h-modalHead--modalHead__top", BI = "h-modalHead--modalHead__title", HI = "h-modalHead--modalHead__buttons", WI = "h-modalHead--modalHead__caption", Xe = {
  root: AI,
  top: OI,
  title: BI,
  buttons: HI,
  caption: WI
}, mT = ({
  className: i,
  title: s,
  children: t,
  onClose: e,
  secondaryButton: n,
  buttonsClassName: r,
  ...a
}) => {
  const l = b(
    {
      [Xe.root]: !0
    },
    i
  );
  return /* @__PURE__ */ o.jsxs("div", { ...a, className: l, children: [
    /* @__PURE__ */ o.jsxs("div", { className: Xe.top, children: [
      /* @__PURE__ */ o.jsx(B.Heading, { className: Xe.title, children: s }),
      /* @__PURE__ */ o.jsxs("div", { className: b(Xe.buttons, r), children: [
        typeof (n == null ? void 0 : n.onClick) == "function" && /* @__PURE__ */ o.jsx(yt, { content: n == null ? void 0 : n.tooltipContent, children: /* @__PURE__ */ o.jsx(
          st,
          {
            icon: n == null ? void 0 : n.icon,
            variant: "tertiary",
            onClick: n == null ? void 0 : n.onClick
          }
        ) }),
        typeof e == "function" && /* @__PURE__ */ o.jsx(
          st,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: e
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ o.jsx(
      B.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Xe.caption,
        children: t
      }
    )
  ] });
}, MI = "h-page-body--pageBody__root", zI = {
  root: MI
}, VI = z(function({ children: s, className: t, ...e }, n) {
  return /* @__PURE__ */ o.jsx(
    ft.Row,
    {
      ...e,
      ref: n,
      className: b(zI.root, t),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: s
    }
  );
}), KI = "h-page-head--pageHead__root", UI = {
  root: KI
}, qI = z(function({ className: s, title: t, controls: e, ...n }, r) {
  return /* @__PURE__ */ o.jsxs(
    ft.Row,
    {
      ...n,
      ref: r,
      as: "header",
      className: b(UI.root, s),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ o.jsx(ft.Slot, { placement: "start", children: /* @__PURE__ */ o.jsx(B.Heading, { variant: "heading-2", as: "h1", children: t }) }),
        e && /* @__PURE__ */ o.jsx(ft.Slot, { placement: "end", children: /* @__PURE__ */ o.jsx(M, { alignItems: "center", gap: "200", children: e }) })
      ]
    }
  );
}), GI = "h-page-section--pageSection__root", YI = "h-page-section--pageSection__head", QI = "h-page-section--pageSection__callout", XI = "h-page-section--pageSection__content", Bn = {
  root: GI,
  head: YI,
  callout: QI,
  content: XI
}, JI = z(function({
  children: s,
  className: t,
  title: e,
  titleMeta: n,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(e || n || r);
  return /* @__PURE__ */ o.jsxs(
    ft.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: b(Bn.root, t),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ o.jsxs(
          ft.Row,
          {
            className: Bn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (e || n) && /* @__PURE__ */ o.jsx(ft.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ o.jsxs(M, { alignItems: "center", gap: "200", children: [
                e && /* @__PURE__ */ o.jsx(B.Heading, { variant: "heading-3", as: "h2", children: e }),
                n && /* @__PURE__ */ o.jsx(M, { alignItems: "center", gap: "200", children: n })
              ] }) }),
              r && /* @__PURE__ */ o.jsx(ft.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ o.jsx(M, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ o.jsx(
          ft.Row,
          {
            className: Bn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ o.jsx(
          ft.Row,
          {
            className: Bn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: s
          }
        )
      ]
    }
  );
}), ZI = z(function({ children: s, className: t, ...e }, n) {
  return /* @__PURE__ */ o.jsx(
    ft.Row,
    {
      ...e,
      ref: n,
      className: t,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: s
    }
  );
}), yr = ({ children: i, className: s, ...t }, e) => /* @__PURE__ */ o.jsx(Wd, { ...t, ref: e, as: "article", className: s, children: /* @__PURE__ */ o.jsx(ft, { children: i }) }), gT = Object.assign(z(yr), {
  name: yr.name,
  Head: qI,
  Body: VI,
  Section: JI,
  Tabs: ZI
}), tk = "h-radio--radio__radio", ek = "h-radio--radio__radioDisabled", nk = "h-radio--radio__radioChecked", sk = "h-radio--radio__input", Hn = {
  radio: tk,
  radioDisabled: ek,
  radioChecked: nk,
  input: sk
}, fT = z(function(s, t) {
  const { id: e, checked: n, disabled: r, className: a, labelProps: l, ...c } = s, d = b(
    Hn.radio,
    { [Hn.radioChecked]: n },
    { [Hn.radioDisabled]: r },
    a
  ), h = e || `radio_${Math.random()}`;
  return /* @__PURE__ */ o.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ o.jsx(
        "input",
        {
          ...c,
          ref: t,
          id: h,
          onChange: c.onChange || O,
          checked: n,
          disabled: r,
          type: "radio",
          className: Hn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), ok = "h-reverseScroll--reverseScroll__root", rk = "h-reverseScroll--reverseScroll__column", ak = "h-reverseScroll--reverseScroll__row", ik = "h-reverseScroll--reverseScroll__scrollHandle", Je = {
  root: ok,
  column: rk,
  row: ak,
  scrollHandle: ik
}, lk = "reverse-scroll", bT = z(function({
  children: s,
  className: t,
  direction: e = "column",
  ...n
}, r) {
  const a = Z(null), l = Z(null), c = Z(null), d = gs(s), h = G(
    () => d.reverse(),
    [d]
  ), u = (y) => {
    var x;
    return (x = c.current) == null ? void 0 : x.scrollIntoView(y);
  }, p = (y) => {
    var x;
    return (x = l.current) == null ? void 0 : x.scrollIntoView(y);
  }, m = (y) => {
    var x, C;
    return (C = (x = a.current) == null ? void 0 : x.children[1]) == null ? void 0 : C.scrollIntoView(y);
  }, g = (y) => {
    var C;
    const x = (C = a.current) == null ? void 0 : C.children[a.current.children.length - 2];
    return x == null ? void 0 : x.scrollIntoView(y);
  };
  return pn(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ o.jsxs(
    "div",
    {
      ...n,
      "data-testid": lk,
      ref: a,
      className: b(t, Je.root, {
        [Je.row]: e === "row",
        [Je.column]: e === "column"
      }),
      children: [
        /* @__PURE__ */ o.jsx("div", { ref: c, className: Je.scrollHandle }),
        h,
        /* @__PURE__ */ o.jsx("div", { ref: l, className: Je.scrollHandle })
      ]
    }
  );
}), ck = "h-removableCard--removableCard__root", dk = "h-removableCard--removableCard__close", hk = "h-removableCard--removableCard__title", uk = "h-removableCard--removableCard__titleIcon", Ze = {
  root: ck,
  close: dk,
  title: hk,
  titleIcon: uk
};
class yT extends k {
  render() {
    const { icon: s, title: t, children: e, onRemove: n, className: r, ...a } = this.props, l = b(
      {
        [Ze.root]: Ze.root
      },
      r
    );
    return /* @__PURE__ */ o.jsxs(
      lt,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ o.jsx(
            lt,
            {
              as: "button",
              "aria-label": "Remove",
              className: Ze.close,
              onClick: n,
              children: /* @__PURE__ */ o.jsx(R, { name: "close" })
            }
          ),
          /* @__PURE__ */ o.jsxs(
            M,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Ze.title,
              children: [
                s && /* @__PURE__ */ o.jsx(R, { name: s, className: Ze.titleIcon }),
                t
              ]
            }
          ),
          /* @__PURE__ */ o.jsx(lt, { margin: "300 0 0 0" }),
          e
        ]
      }
    );
  }
}
const xr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, pk = "h-sandboxIframe--sandboxIframe__frame", mk = {
  frame: pk
}, on = class on extends k {
  constructor(t) {
    super(t);
    f(this, "frameRef");
    this.state = {
      iframeHeight: 0
    }, this.frameRef = W(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: r } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== r) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: r } = this.frameRef;
    if (r) {
      let a = "";
      t.indexOf("</body>") !== -1 ? a = t.replace(
        "</body>",
        `${xr({ colorMode: n })}</body>`
      ) : a = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${xr(
        { colorMode: n }
      )}</body></html>`, r.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(a))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: r,
      colorMode: a,
      ...l
    } = this.props, { iframeHeight: c } = this.state, d = b({}, t);
    return /* @__PURE__ */ o.jsx("div", { ...l, className: d, children: /* @__PURE__ */ o.jsx(
      "iframe",
      {
        title: "message",
        sandbox: r ?? on.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${c}px` },
        className: mk.frame,
        ref: this.frameRef
      }
    ) });
  }
};
f(on, "defaultProps"), f(on, "defaultSandboxParams", "allow-scripts allow-popups allow-forms");
let _r = on;
const gk = "h-scrollbar--scrollbar__track", fk = "h-scrollbar--scrollbar__handle", Cr = {
  track: gk,
  handle: fk
};
class xT extends k {
  constructor(t) {
    super(t);
    f(this, "updateSize", () => {
      const { container: t } = this.props;
      if (t.current) {
        const { current: e } = t;
        this.setState({
          size: e.offsetHeight / e.scrollHeight,
          progress: e.scrollTop / e.scrollHeight
        });
      }
    });
    this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const r = e.current.getBoundingClientRect();
      let a = (t.clientY - r.top) / e.current.offsetHeight - n / 2;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), e.current.scrollTop = a * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: r } = this.state;
    if (e.current) {
      const a = e.current.getBoundingClientRect();
      let l = (t.clientY - a.top) / e.current.offsetHeight - r;
      l < 0 && (l = 0), l + n > 1 && (l = 1 - n), e.current.scrollTop = l * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...r } = this.props, { size: a, progress: l } = this.state, c = b(t);
    return /* @__PURE__ */ o.jsx("div", { ...r, className: c, children: /* @__PURE__ */ o.jsx(
      "div",
      {
        className: b(Cr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ o.jsx(
          "div",
          {
            className: b(Cr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${a * 100}%`,
              top: `${l * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const bk = "h-scrollShadow--scrollShadow__wrapper", yk = "h-scrollShadow--scrollShadow__content", wr = {
  wrapper: bk,
  content: yk
}, _T = ({
  className: i,
  children: s,
  ...t
}) => {
  const e = b(wr.wrapper, i);
  return /* @__PURE__ */ o.jsx("div", { className: e, ...t, children: /* @__PURE__ */ o.jsx("div", { className: wr.content, children: s }) });
}, xk = "h-searchInput--searchInput__root", _k = "h-searchInput--searchInput__input", Ck = "h-searchInput--searchInput__inputButton", Wn = {
  root: xk,
  input: _k,
  inputButton: Ck
}, wk = 275, vr = 300, CT = ({
  className: i,
  initialSearch: s,
  maxWidth: t = wk,
  placeholder: e,
  onChange: n,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = Z(null), [d, h] = U(!!s), [u, p] = U(!1), [m, g] = U(s ?? "");
  yi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    vr,
    [u]
  ), Zt(() => {
    a == null || a(d), d && requestAnimationFrame(() => {
      var v;
      return (v = c.current) == null ? void 0 : v.focus();
    });
  }, [d]);
  const y = L(() => {
    h(!0);
  }, []), x = L(() => {
    p(!0);
  }, []), C = L(
    (v) => {
      v.preventDefault(), r(m);
    },
    [r, m]
  ), _ = L(
    (v) => {
      const {
        target: { value: T }
      } = v;
      g(T), n == null || n(T);
    },
    [n]
  ), w = L(
    ({ key: v }) => {
      v === "Enter" && y();
    },
    [y]
  ), S = L(
    ({ key: v }) => {
      (v === "Esc" || v === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ o.jsx(
    "div",
    {
      className: b(Wn.root, i),
      style: {
        "--max-width": `${d && !u ? t : 32}px`,
        "--transition-delay": `${vr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ o.jsx("form", { onSubmit: C, children: /* @__PURE__ */ o.jsx(
        us,
        {
          className: Wn.input,
          ref: c,
          onChange: _,
          placeholder: e ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: C,
              className: Wn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: Wn.inputButton
            }
          },
          onKeyDown: S
        }
      ) }) : /* @__PURE__ */ o.jsx(
        st,
        {
          icon: "search",
          variant: "secondary",
          onClick: y,
          onKeyDown: w,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, vk = "h-selectOption--selectOption__root", Sk = "h-selectOption--selectOption__checkbox", Ik = "h-selectOption--selectOption__content", $s = {
  root: vk,
  checkbox: Sk,
  content: Ik
}, wT = (i) => {
  const s = b($s.root);
  return /* @__PURE__ */ o.jsxs("label", { className: s, children: [
    /* @__PURE__ */ o.jsx(
      bn,
      {
        ...i,
        className: b($s.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ o.jsx("div", { className: $s.content, children: i.name })
  ] });
}, kk = "h-simpleProgressBar--simpleProgressBar__container", Dk = "h-simpleProgressBar--simpleProgressBar__progressBar", Tk = "h-simpleProgressBar--simpleProgressBar__progressBarFill", As = {
  container: kk,
  progressBar: Dk,
  progressBarFill: Tk
}, jk = "simpleProgressBarId";
function vT({
  progress: i,
  base: s = 100,
  progressColor: t = "purple.500",
  backgroundColor: e = "neutral.200",
  tooltipContent: n,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = U(0), d = 4;
  at(() => c(i), [i]);
  const h = s >= l ? l / s : 1, u = () => d / h, p = {
    backgroundColor: an(e)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: an(t)
  };
  return /* @__PURE__ */ o.jsx(
    M,
    {
      "test-id": jk,
      "align-items": "center",
      "justify-content": "center",
      className: As.container,
      ...a,
      children: /* @__PURE__ */ o.jsx(
        yt,
        {
          disabled: !n,
          content: n,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ o.jsx("div", { className: As.progressBar, style: p, children: /* @__PURE__ */ o.jsx(
            "div",
            {
              className: As.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const Nk = "h-tabsWithContent--tabsWithContent__container", Fk = "h-tabsWithContent--tabsWithContent__containerTop", Pk = "h-tabsWithContent--tabsWithContent__containerLeft", Rk = "h-tabsWithContent--tabsWithContent__containerRight", Lk = "h-tabsWithContent--tabsWithContent__containerBottom", Ek = "h-tabsWithContent--tabsWithContent__childrenContainer", Ie = {
  container: Nk,
  containerTop: Fk,
  containerLeft: Pk,
  containerRight: Rk,
  containerBottom: Lk,
  childrenContainer: Ek
}, rn = class rn extends xt {
  constructor(s) {
    super(s), this.state = { activeTab: s.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(s) {
    var t, e;
    this.ensureTabIsValid(s) && (this.setState({ activeTab: s }), (e = (t = this.props).onChange) == null || e.call(t, s));
  }
  ensureTabIsValid(s) {
    return this.props.tabs.some((t) => t.id === s);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: s }) => s === this.state.activeTab);
  }
  render() {
    const {
      className: s,
      tabsClassName: t,
      tabClassName: e,
      tabSelectedClassName: n,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Ht.toArray(l);
    if (h.length !== a.length) {
      const g = `${rn.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${rn.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = b(s, Ie.container, {
      [Ie.containerTop]: c === "top",
      [Ie.containerLeft]: c === "left",
      [Ie.containerBottom]: c === "bottom",
      [Ie.containerRight]: c === "right"
    }), m = b(
      r,
      Ie.childrenContainer
    );
    return /* @__PURE__ */ o.jsxs("section", { className: p, children: [
      /* @__PURE__ */ o.jsx(
        Ab,
        {
          className: t,
          tabClassName: e,
          tabSelectedClassName: n,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ o.jsx("div", { className: m, children: h[u] })
    ] });
  }
};
f(rn, "defaultProps", {
  tabsPlacement: "top"
});
let Sr = rn;
const $k = "h-tagsInput--tagsInput__root", Ak = "h-tagsInput--tagsInput__wrapper", Ok = "h-tagsInput--tagsInput__input", Bk = "h-tagsInput--tagsInput__inputIsHidden", Hk = "h-tagsInput--tagsInput__placeholder", Wk = "h-tagsInput--tagsInput__placeholderText", Mk = "h-tagsInput--tagsInput__iconBox", zk = "h-tagsInput--tagsInput__iconText", Vk = "h-tagsInput--tagsInput__tag", Kk = "h-tagsInput--tagsInput__tagIsActive", Uk = "h-tagsInput--tagsInput__tagButton", qk = "h-tagsInput--tagsInput__divider", gt = {
  root: $k,
  wrapper: Ak,
  input: Ok,
  inputIsHidden: Bk,
  placeholder: Hk,
  placeholderText: Wk,
  iconBox: Mk,
  iconText: zk,
  tag: Vk,
  tagIsActive: Kk,
  tagButton: Uk,
  divider: qk
};
function Ir(i = [], s) {
  switch (s) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const Gk = 255, ST = ({
  className: i,
  disabled: s,
  limit: t,
  placeholder: e,
  selectedTags: n,
  sortDirection: r,
  onChange: a
}) => {
  const l = Z(null), c = Z(null), [d, h] = U(""), [u, p] = U(
    Ir(n, r)
  ), [m, g] = U(""), [y, x] = U(!1);
  $r(l, () => x(!1)), Zt(() => a(u), [u, a]), Zt(() => {
    c.current && y && c.current.focus();
  }, [c.current, y]);
  const C = (D) => {
    h(D.target.value ?? "");
  }, _ = (D) => {
    const E = u.indexOf(m);
    switch (D.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((F) => {
          const P = Array.from(/* @__PURE__ */ new Set([...F, d]));
          return h(""), Ir(P, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (w(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && E > 0 && g(u[E - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && E < u.length - 1 && g(u[E + 1]);
        break;
      default:
        m && g("");
    }
  }, w = (D) => {
    p((E) => {
      const F = [...E];
      return F.splice(F.indexOf(D), 1), F;
    });
  }, S = y ? u.length : t || u.length, v = S < u.length, T = u.slice(0, S);
  return /* @__PURE__ */ o.jsx(
    Et,
    {
      ref: l,
      className: b(gt.root, i),
      onClick: () => x(!0),
      disabled: s,
      children: /* @__PURE__ */ o.jsxs("div", { className: gt.wrapper, "data-testid": "tags-wrapper", children: [
        T.map((D, E, F) => {
          const P = !y && F.length > 1 && E === F.length - 1;
          return /* @__PURE__ */ o.jsxs(Mt, { children: [
            P && /* @__PURE__ */ o.jsx(
              B.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: gt.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ o.jsx(
              Re,
              {
                className: b(gt.tag, {
                  [gt.tagIsActive]: D === m
                }),
                onDelete: () => w(D),
                "data-testid": "tag",
                children: D
              },
              D
            )
          ] }, D);
        }),
        !y && v && /* @__PURE__ */ o.jsxs(
          Re,
          {
            className: b(gt.tag, gt.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - S
            ]
          }
        ),
        !y && !u.length && !d && /* @__PURE__ */ o.jsx(M, { className: gt.placeholder, alignItems: "center", gap: "200", children: e ? /* @__PURE__ */ o.jsx(B.Paragraph, { className: gt.placeholderText, variant: "2", children: e }) : /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsx(B.Paragraph, { className: gt.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ o.jsxs("div", { className: gt.iconBox, children: [
            /* @__PURE__ */ o.jsx(R, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ o.jsx(B.Paragraph, { className: gt.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ o.jsx(
          "input",
          {
            className: b(gt.input, {
              [gt.inputIsHidden]: !y
            }),
            onChange: C,
            onKeyDown: _,
            maxLength: Gk,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, Yk = "h-textWithHighlight--textWithHighlight__highlight", Qk = {
  highlight: Yk
}, Xk = ({
  text: i,
  highlight: s,
  className: t,
  highlightClassName: e,
  ignoreCase: n = !0
}) => {
  if (!(s != null && s.trim()))
    return /* @__PURE__ */ o.jsx(o.Fragment, { children: i });
  const r = new RegExp(
    ro(s.trim()),
    n ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ o.jsx("span", { className: t, children: l.map((c, d) => /* @__PURE__ */ o.jsxs("span", { children: [
    c,
    (a == null ? void 0 : a[d]) && /* @__PURE__ */ o.jsx("em", { className: b(Qk.highlight, e), children: a[d] })
  ] }, d)) });
}, Jk = Rr(Xk);
Jk.name = "TextWithHighlight";
const Zk = "h-timestamp--timestamp__timestamp", tD = {
  timestamp: Zk
}, eD = 1e4;
class nD extends xt {
  constructor(t) {
    super(t);
    f(this, "interval");
    const { relative: e, counter: n, initialFormat: r } = t;
    let a = r ?? "absolute";
    e ? a = "ago" : n && (a = "counter"), this.state = {
      format: a,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: r } = this.state;
    e !== t.relative && r && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let r = this.state.format;
    n === "ago" ? (r = "full", this.stopTicker()) : n === "full" ? r = "absolute" : n === "absolute" && (r = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: r
    }), e == null || e(r, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: r } = this.state;
    let a = "";
    if (typeof t == "number") {
      const c = /* @__PURE__ */ new Date();
      c.setTime(t * 1e3), t = c;
    }
    const l = N(t).utc().local();
    if (r === "counter") {
      const c = N(t).utc(), h = N().utc().diff(c) / 1e3, u = Math.floor(h / (60 * 60)), p = Math.floor(u / 24), m = u % 24, g = u * 60 * 60, y = Math.floor((h - g) / 60), x = y * 60, C = Math.floor(
        h - g - x
      );
      a = [
        m.toString().padStart(2, "0"),
        y.toString().padStart(2, "0"),
        C.toString().padStart(2, "0")
      ].join(":"), p > 0 && (a = `${p} ${p === 1 ? "DAY" : "DAYS"} ${a}`);
    } else if (r === "full") {
      const c = (n == null ? void 0 : n.full) ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      a = l.format(c);
    } else if (r === "absolute")
      if (N().diff(N(t), "hours") > 12) {
        const c = (n == null ? void 0 : n.absolute) ?? `D MMMM LT${e ? "S" : ""}`;
        a = l.format(c);
      } else {
        const c = (n == null ? void 0 : n.absolute) ?? `LT${e ? "S" : ""}`;
        a = l.format(c);
      }
    else
      a = Nu(l);
    return a;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: r,
      counter: a,
      customFormatters: l,
      isSecondsDisplayed: c,
      initialFormat: d,
      onClick: h,
      ...u
    } = this.props, p = b(
      {
        [tD.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ o.jsx(
      "span",
      {
        ...u,
        ...as(this.handleClick),
        className: p,
        children: this.getTimeString()
      }
    );
  }
}
f(nD, "defaultProps", {
  refreshRate: eD
});
const sD = "h-token--token__root", oD = "h-token--token__select", rD = "h-token--token__label", aD = "h-token--token__rootReadonly", iD = "h-token--token__rootPrimary", lD = "h-token--token__rootWithError", cD = "h-token--token__value", dD = "h-token--token__icon", Ot = {
  root: sD,
  select: oD,
  label: rD,
  rootReadonly: aD,
  rootPrimary: iD,
  rootWithError: lD,
  value: cD,
  icon: dD
};
class IT extends k {
  render() {
    const {
      onDelete: s,
      id: t,
      label: e,
      options: n,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = b(
      {
        [Ot.root]: !0,
        [Ot.rootPrimary]: a,
        [Ot.rootWithError]: c == null ? void 0 : c.error,
        [Ot.rootReadonly]: !n && !s
      },
      h
    );
    let m = r;
    if (!m && l && n && n.length) {
      const g = n.filter(({ value: y }) => l.value === y);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ o.jsxs("div", { ...u, className: p, children: [
      !!n && /* @__PURE__ */ o.jsxs("select", { ...l, className: Ot.select, id: t, children: [
        !!d && /* @__PURE__ */ o.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        n.map((g) => {
          var y;
          return /* @__PURE__ */ o.jsx("option", { value: g.value, children: g.label }, (y = g.value) == null ? void 0 : y.toString());
        })
      ] }),
      /* @__PURE__ */ o.jsxs("label", { className: Ot.label, htmlFor: t, children: [
        e,
        /* @__PURE__ */ o.jsx("span", { className: Ot.value, children: m }),
        !!n && /* @__PURE__ */ o.jsx(R, { className: Ot.icon, name: "angle-down" }),
        !!s && /* @__PURE__ */ o.jsx("span", { ...as(s), children: /* @__PURE__ */ o.jsx(R, { className: Ot.icon, name: "close", onClick: s }) })
      ] })
    ] });
  }
}
const hD = "h-skeleton--skeleton__root", uD = "h-skeleton--skeleton__rootAnimationPulse", pD = "h-skeleton--skeleton__rootAnimationWave", Os = {
  root: hD,
  rootAnimationPulse: uD,
  rootAnimationWave: pD
};
function kr({ className: i, animation: s = "pulse", ...t }, e) {
  const n = b(
    {
      [Os.root]: !0,
      [Os.rootAnimationPulse]: s === "pulse",
      [Os.rootAnimationWave]: s === "wave"
    },
    i
  );
  return /* @__PURE__ */ o.jsx(lt, { className: n, ...t, ref: e });
}
const kT = Object.assign(z(kr), {
  name: kr.name
}), mD = "h-breadcrumbs--breadcrumbs__root", gD = "h-breadcrumbs--breadcrumbs__item", fD = "h-breadcrumbs--breadcrumbs__itemLink", bD = "h-breadcrumbs--breadcrumbs__itemLast", yD = "h-breadcrumbs--breadcrumbs__separator", ie = {
  root: mD,
  item: gD,
  itemLink: fD,
  itemLast: bD,
  separator: yD
};
var Un = /* @__PURE__ */ ((i) => (i.LastItem = "breadcrumbs-last-item", i.LinkItem = "breadcrumbs-link-item", i.Separator = "breadcrumbs-separator-item", i))(Un || {});
class xD extends k {
  getPathPartTitle(s) {
    return this.props.pathLabelDictionary[s] ?? s;
  }
  parsePath() {
    const { path: s, maxDepth: t } = this.props;
    return s.trim().split("/").filter(Boolean).slice(0, t);
  }
  render() {
    const {
      className: s,
      linkComponent: t,
      path: e,
      pathLabelDictionary: n,
      separator: r,
      maxDepth: a,
      children: l,
      ...c
    } = this.props;
    return /* @__PURE__ */ o.jsx("nav", { ...c, className: b(ie.root, s), children: this.parsePath().map((d, h, u) => {
      const p = h === u.length - 1, m = `/${u.slice(0, h + 1).join("/")}`;
      return p ? /* @__PURE__ */ o.jsx(
        "span",
        {
          className: b(ie.item, ie.itemLast),
          "data-testid": Un.LastItem,
          children: this.getPathPartTitle(d)
        },
        m
      ) : /* @__PURE__ */ o.jsxs(Mt, { children: [
        /* @__PURE__ */ o.jsx(
          t,
          {
            to: m,
            className: b(ie.item, ie.itemLink),
            "data-testid": Un.LinkItem,
            children: this.getPathPartTitle(d)
          }
        ),
        /* @__PURE__ */ o.jsx(
          "span",
          {
            className: b(ie.item, ie.separator),
            "data-testid": Un.Separator,
            children: r
          }
        )
      ] }, m);
    }) });
  }
}
f(xD, "defaultProps", {
  separator: /* @__PURE__ */ o.jsx(Lr, { name: "angle-right" }),
  pathLabelDictionary: {},
  maxDepth: 5
});
export {
  Df as AddonTriggerContext,
  Tf as AddonTriggerEvents,
  RD as Attachment,
  Vr as Avatar,
  la as AvatarSelectItem,
  LD as Badge,
  ED as Banner,
  lt as Box,
  xD as Breadcrumbs,
  tt as Button,
  $D as ButtonGroup,
  vo as ButtonList,
  KD as CheckableAvatarSelectItem,
  po as CheckableBaseItem,
  zD as CheckableSelectItem,
  VD as CheckableTagSelectItem,
  bn as Checkbox,
  Gp as Chip,
  OD as CollapseCard,
  BD as Collapsible,
  ls as ColorPicker,
  ft as Column,
  Wd as Columns,
  qr as CopyToClipboard,
  HD as CopyToClipboardButton,
  iT as CountryFlag,
  WD as DataTable,
  ha as DatePicker,
  Us as DatePickerOld,
  da as DateRangePicker,
  Ap as DeselectItem,
  qD as Dialer,
  io as Divider,
  zt as Dropdown,
  ee as DropdownButton,
  yn as DropdownButtonContext,
  ds as DropdownInfinite,
  Wo as DropdownItem,
  ps as DropdownSelect,
  ua as DropdownSelectContainer,
  Ag as DropdownSelectMultiple,
  gi as EMOJIS,
  jT as EmojiPicker,
  xn as EmptySelectItem,
  Nh as EmptyState,
  mn as ErrorBoundary,
  NT as ErrorBoundaryContext,
  aT as FieldAddonDropdown,
  hs as FieldAlert,
  GD as FieldButton,
  rT as FieldColorPicker,
  YD as FieldDatePicker,
  QD as FieldDateRangePicker,
  uo as FieldLabel,
  _y as FieldRichText,
  JD as FieldSelect,
  ZD as FieldSelectionList,
  tT as FieldSlider,
  eT as FieldSwitch,
  Qs as FieldText,
  nT as FieldTextarea,
  sT as FieldTimePicker,
  oT as FieldTimeRangePicker,
  V as FieldWrapper,
  M as FlexBox,
  Ur as FocusScope,
  SS as FormField,
  cT as FormGrid,
  ho as HelpIcon,
  dT as HelperField,
  R as Icon,
  st as IconButton,
  rs as Image,
  ma as InputDatePicker,
  ts as InputDateRangePicker,
  to as InputRichText,
  sx as InputSelectionList,
  us as InputText,
  Et as InputWrapper,
  hT as Lightbox,
  uT as List,
  uT as ListV2,
  NI as MediaPlayer,
  Da as Modal,
  pT as ModalBody,
  ja as ModalFoot,
  mT as ModalHead,
  FD as NavigationButton,
  gT as Page,
  Qr as Pagination,
  NS as Portal,
  ia as Presets,
  fT as Radio,
  yT as RemovableCard,
  bT as ReverseScroll,
  _r as SandboxIframe,
  _T as ScrollShadow,
  xT as Scrollbar,
  CT as SearchInput,
  Sm as Select,
  mo as SelectItem,
  wT as SelectOption,
  By as SelectionList,
  ih as SimplePagination,
  vT as SimpleProgressBar,
  kT as Skeleton,
  eo as Slider,
  ao as Spinner,
  Sx as Switch,
  bt as Table,
  cs as TableContext,
  Ab as Tabs,
  Sr as TabsWithContent,
  Re as Tag,
  UD as TagDeselectItem,
  gp as TagSelectItem,
  Pp as TagSelectSuggestion,
  ST as TagsInput,
  B as Text,
  Jk as TextWithHighlight,
  wa as Textarea,
  hn as TimePicker,
  sg as TimeRangePicker,
  nD as Timestamp,
  IT as Token,
  yt as Tooltip,
  LT as addSvgIconsToDocument,
  Ad as colorPickerTestId,
  lT as countryCodes,
  MD as datepickerDisableWeekends,
  FT as defaultElementType,
  uf as formattingOptions,
  Ae as getSelectionListContext,
  PT as iconMeta,
  nr as inputRichTextCommands,
  nx as inputSelectionListTestId,
  lk as reverseScrollTestId,
  gn as withErrorBoundary
};
//# sourceMappingURL=index.js.map
